// Taşeron portalı — statik arayüz metinleri (tr/en/de).
//
// Bu paket uygulamanın KENDİ microcopy'sidir; backend dil paketi (`/resources`)
// hata kodlarını + `label.*`'ı ekler ve aynı anahtarlar için ÜZERİNE yazar
// (i18n.ts birleştirme). Böylece backend erişilemese bile ham anahtar sızmaz
// ([[feedback_i18n_key_runtime_path]]).
//
// Anahtarlar `.` içerir ama i18next `keySeparator:false` ile bunları literal alır.
// Almanca metinler ä/ö/ü/ß içerir — font charset doğrulaması için görünür kanıt.

import type { AppResources } from '@isgportal/shared';

// Derleme-zamanı tr/en/de anahtar paritesi kontrolü — `tr` KANONİK anahtar kümesidir
// (Türkçe kaynak dil). `tr`'nin tipi buradan İMZALANMAZ (`Record<string,string>` yerine
// `satisfies` ile değer tipleri denetlenip anahtarların LİTERAL kalması sağlanır); `en`/`de`
// `Record<keyof typeof tr, string>` ile tiplenir, böylece bir anahtar yalnız `tr`'ye
// eklenip `en`/`de`'ye eklenmezse (ya da tersi) DERLEME hatası verir — bu depoda
// web-supplier için test/vitest yok, bu yüzden tip sistemi TEK denetim aracıdır.
const tr = {
  // Paylaşılan `Pagination` özeti (S33-8 review fix #2, web-expert ile AYNI anahtar/değer) —
  // `packages/shared/src/ui/Pagination.tsx` kendi özetini bu anahtarla hesaplar.
  'pagination.summary': '{{from}}–{{to}} / {{total}} kayıt',
  'pagination.summaryEmpty': '0 kayıt',
  'app.name': 'İSG Portal',
  'app.supplierPortal': 'Taşeron Portalı',
  'app.tagline': 'Taşeron firmanızın iş sağlığı ve güvenliği süreçlerini tek yerden yönetin.',

  'login.title': 'Taşeron Portalına giriş',
  'login.subtitle': 'Hesabınıza erişmek için e-posta veya telefon ile parolanızı girin.',
  'login.identifier': 'E-posta veya telefon',
  'login.identifierPlaceholder': 'ornek@firma.com veya 0555 123 45 67',
  'login.password': 'Parola',
  'login.submit': 'Giriş yap',
  'login.forgotPassword': 'Parolamı unuttum',

  'selectWorkspace.title': 'Firma seçin',
  'selectWorkspace.subtitle': 'Birden fazla firmaya bağlısınız. Devam etmek için bir firma seçin.',
  'selectWorkspace.continue': 'Firmayla devam et',
  'selectWorkspace.backToLogin': 'Girişe dön',
  'selectWorkspace.expired':
    'Firma seçim süreniz doldu veya oturum bilgisi bulunamadı. Lütfen tekrar giriş yapın.',

  'switcher.label': 'Aktif firma',
  'switcher.change': 'Firma değiştir',
  'switcher.switching': 'Firma değiştiriliyor…',
  'switcher.noAccess':
    'Bu firmaya erişiminiz bulunmuyor. Erişim için firma yetkilinizle görüşebilirsiniz.',
  'switcher.menu.heading': 'Müşteriler',
  'switcher.menu.fanoutCap': '{{shown}} / {{total}} firma özetlendi',
  'switcher.menu.footer': 'Geçiş, tüm paneli seçilen müşteriye taşır.',
  'switcher.badge.ariaLabel_one': '{{count}} müşteride bekleyen iş var',
  'switcher.badge.ariaLabel_other': '{{count}} müşteride bekleyen iş var',
  'switcher.summary.loading': 'Sayılar yükleniyor…',
  'switcher.activeNote': 'Bu paneldesiniz',
  // S26 düzeltme — sayı çeviri dizesinden ÇIKTI (component kurar, `CompanySwitcher.tsx`);
  // burada yalnız statik durum sözcüğü kalır, çoğul eki YOK. `engelli` (kişiye uygulanınca
  // "engelli çalışan" anlamına gelen yasal terim) yerine katılımcı `engellenen` kullanılır —
  // burada bir DURUMU (o gün girişe engellenen) tanımlar, KİŞİYİ değil.
  'switcher.state.blocked': 'Bugün engellenen',
  'switcher.state.atRisk': 'Bu hafta yaklaşan',
  'switcher.row.clean': 'temiz',
  'switcher.row.unavailable': 'Şu anda yüklenemedi',
  'switcher.row.goToPanel': 'Panele git',

  'guest.title': 'Hesabınızı etkinleştirin',
  'guest.subtitle': 'Sizi ekleyen firmaya katılmak için aşağıdaki adımları tamamlayın.',
  'guest.intro':
    'Doğrulama kodunu almak için aktivasyonu başlatın; ardından kod, T.C. kimlik numaranız ve yeni parolanızla hesabınızı etkinleştireceksiniz.',
  'guest.start': 'Aktivasyonu başlat',
  'guest.sentTo': 'Doğrulama kodunu gönderdik: {{target}}.',
  'guest.sentToEach':
    'İletişim bilgilerinizin her birine ayrı bir doğrulama kodu gönderdik: {{target}}. Girdiğiniz kodun gönderildiği iletişim bilgisiyle giriş yapacaksınız.',
  'guest.code': 'Doğrulama kodu',
  'guest.newPassword': 'Yeni parola',
  'guest.passwordHint': 'En az 8 karakter; en az bir harf ve bir rakam içermeli.',
  'guest.activate': 'Hesabı etkinleştir',
  'guest.resend': 'Kodu tekrar gönder',
  'guest.invalidLink':
    'Aktivasyon bağlantısı geçersiz veya eksik. Lütfen size iletilen bağlantıyı kontrol edin.',
  'guest.tc': 'T.C. kimlik no',
  'guest.tcHint':
    'Hesabınızı etkinleştirmek için 11 haneli T.C. kimlik numaranızı yazın. Numara, sizi ekleyen firmanın kaydettiği numarayla eşleşmelidir.',
  'guest.validation.tcRequired': 'T.C. kimlik no zorunludur.',
  'guest.tcRequired':
    'Hesabınız şu anda etkinleştirilemiyor; firmanın kayıtlarında T.C. kimlik numaranız eksik. Lütfen sizi ekleyen firmayla iletişime geçin; bağlantınız geçerli kalır.',
  'guest.tcAlreadyExists':
    'Hesabınız şu anda etkinleştirilemiyor; firmanın kayıtlarında düzeltme gerekiyor. Lütfen sizi ekleyen firmayla iletişime geçin; bağlantınız geçerli kalır.',
  'guest.linkDead':
    'Bu aktivasyon bağlantısı artık kullanılamıyor. Size daha yeni bir bağlantı gönderildiyse onu kullanın; aksi hâlde sizi ekleyen firmadan yeni bir bağlantı isteyin.',
  TC_KIMLIK_MISMATCH:
    'Girdiğiniz T.C. kimlik numarası kayıtlı bilgilerle eşleşmedi. Numarayı doğru yazdıysanız sizi ekleyen firmayla iletişime geçin.',
  'guest.activatedNote': 'Hesabınız etkinleştirildi; panele yönlendiriliyorsunuz.',

  'forgot.title': 'Parola sıfırlama',
  'forgot.subtitle': 'Hesabınıza bağlı e-posta veya telefonu girin; doğrulama kodu gönderelim.',
  'forgot.identifier': 'E-posta veya telefon',
  'forgot.submit': 'Kod gönder',
  'forgot.backToLogin': 'Girişe dön',

  'reset.title': 'Yeni parola belirleyin',
  'reset.subtitle': 'Size iletilen doğrulama kodunu ve yeni parolanızı girin.',
  'reset.code': 'Doğrulama kodu',
  'reset.newPassword': 'Yeni parola',
  'reset.passwordHint': 'En az 8 karakter; en az bir harf ve bir rakam içermeli.',
  'reset.submit': 'Parolayı güncelle',
  'reset.successTitle': 'Parolanız güncellendi',
  'reset.successBody': 'Yeni parolanızla giriş yapabilirsiniz.',
  'reset.toLogin': 'Girişe git',

  'layout.dashboard': 'Panel',
  'layout.documents': 'Belgelerim',
  'layout.personnel': 'Personelim',
  'layout.vehicles': 'Araçlar',
  'layout.account': 'Hesap',
  'layout.profile': 'Profil',
  'layout.logout': 'Çıkış yap',
  'layout.nav.primary': 'Ana menü',
  'layout.rail.collapse': 'Menüyü daralt',
  'layout.rail.expand': 'Menüyü genişlet',
  'layout.skipToContent': 'İçeriğe geç',
  'layout.user.menu': 'Kullanıcı menüsü',
  'layout.user.signedInAs': 'Giriş yapan hesap',
  'layout.user.company': 'Firma',
  'layout.user.language': 'Dil',

  // Profil (Self) — api-contract §18.2
  'profile.title': 'Profil',
  'profile.subtitle': 'Hesap bilgilerinizi görüntüleyin ve güncelleyin.',
  'profile.loading': 'Profil yükleniyor...',
  'profile.info.title': 'Hesap bilgileri',
  'profile.info.subtitle': 'Bu bilgiler yalnızca görüntülenir.',
  'profile.field.fullName': 'Ad soyad',
  'profile.field.firstName': 'Ad',
  'profile.field.lastName': 'Soyad',
  'profile.field.emailOrPhone': 'E-posta / telefon',
  'profile.field.company': 'Firma',
  'profile.edit.title': 'Ad soyadı düzenle',
  'profile.edit.subtitle': 'Görünen adınızı güncelleyin.',
  'profile.edit.save': 'Kaydet',
  'profile.updated': 'Profil güncellendi.',
  'profile.validation.firstNameRequired': 'Ad zorunludur.',
  'profile.validation.lastNameRequired': 'Soyad zorunludur.',
  'profile.password.title': 'Parola değiştir',
  'profile.password.subtitle': 'Güvenliğiniz için güçlü bir parola seçin.',
  'profile.password.current': 'Mevcut parola',
  'profile.password.new': 'Yeni parola',
  'profile.password.confirm': 'Yeni parola (tekrar)',
  'profile.password.hint': 'En az 8 karakter; en az bir harf ve bir rakam içermeli.',
  'profile.password.save': 'Parolayı güncelle',
  'profile.password.updated': 'Parolanız güncellendi.',
  'profile.password.wrongCurrent': 'Mevcut parola hatalı.',
  'profile.validation.currentPasswordRequired': 'Mevcut parola zorunludur.',
  'profile.validation.confirmRequired': 'Parolayı tekrar girin.',
  'profile.validation.passwordMismatch': 'Parolalar eşleşmiyor.',

  // Ortak (buton/etiket)
  'common.close': 'Kapat',
  'common.cancel': 'Vazgeç',
  'common.actions': 'İşlemler',
  'common.compactRows': 'Kompakt satırlar',
  'common.loading': 'Yükleniyor…',

  // Panel (§28.3 GET /supplier/dashboard) — "bu firmada bugün beni ne durduruyor?"
  'dashboard.title': 'Panel',
  'dashboard.subtitle': 'Firmanızın durumuna genel bakış.',
  'dashboard.loading': 'Panel yükleniyor…',
  // Paylaşılan durum sözcüğü — UpcomingPermitsCard'ın takılı kapısı (personel bir yaklaşan
  // izin için girişe hazır değil) bu anahtarı kullanır.
  'dashboard.status.notEntryReady': 'Girişe hazır değil',

  // Panel rebuild — owner mevcut tasarımı beğenmedi, SUNUM baştan kuruldu (backend §28
  // AYNEN KALDI). "7 Günlük Görünüm" (RiskWeekCard, `dashboard.risk.*`) ve "Sizden
  // bekleyenler" (PendingActionsCard, `dashboard.pending.*`) TAMAMEN KALKTI; ikisinin
  // anahtarları da bu yüzden silindi — aşağıdaki `dashboard.missing.*` PendingActionsCard'ın
  // yerini alır (bkz. MissingItemsCard.tsx).

  // Panel — "Eksikler" (§28.3 items; TÜM kalem türleri — PendingActionsCard'ın yerine geçti).
  // Eski kart yalnız `blockedBy === 'Supplier'` kalemleri gösterip kişiye göre grupluyordu;
  // bu kart TÜM kalem türlerini (Training/PermitApproval dahil) düz bir listede gösterir —
  // başlıktaki sayı (`itemsTotal`) artık listedeki kalemlerle AYNI kümeden (bkz.
  // MissingItemsCard.tsx dosya başı notu).
  'dashboard.missing.title': 'Eksikler',
  'dashboard.missing.empty': 'Eksik yok.',
  // `itemsTotal > 0` ama aktif filtre 0 satır veriyor (ör. hiç `Training` yokken "Eğitim"e
  // basmak) — kutlama durumundan (`empty`, yukarıda) AYRI: ikon yok, yalnız düz bilgi metni.
  'dashboard.missing.filterEmpty': 'Bu filtrede kayıt yok.',
  'dashboard.missing.filter.all': 'Tümü',
  'dashboard.missing.filter.document': 'Belge',
  'dashboard.missing.filter.training': 'Eğitim',
  'dashboard.missing.filter.groupLabel': 'Kalem türü filtresi',
  // `ContractorDocument` kalemlerinde personel YOKTUR (firma düzeyi belge) — satırın kişi
  // alanına bu etiket basılır.
  'dashboard.missing.companyDocument': 'Firma belgesi',
  'dashboard.missing.unknownType': 'Belge',
  'dashboard.missing.status.missing': 'Eksik',
  'dashboard.missing.status.expired': 'Süresi geçti',
  'dashboard.missing.status.noValidity': 'Tarihsiz',
  'dashboard.missing.status.rejected': 'Reddedildi',
  'dashboard.missing.rejectionReason.label': 'Red gerekçesi',
  // `SupplierActionItemDto` hangi eğitimin eksik olduğunu TAŞIMAZ (backend yalnız
  // `CompletedTrainingCount < RequiredTrainingCount` toplamından bir kalem üretir) — bu
  // yüzden eğitim adı UYDURULMAZ, satır jenerik okur (bkz. MissingItemsCard.tsx).
  'dashboard.missing.trainingGeneric': 'Eğitim tamamlanmadı',
  // `PermitApproval` kalemi İSG uzmanının onayını bekliyor demektir (blockedBy = 'Expert') —
  // Yetkili yalnız GÖRÜR, kapatamaz; satır bunu adlandırır, bir aksiyon vaat etmez.
  'dashboard.missing.permitApprovalGeneric': 'Müşteri İSG uzmanı onayı bekliyor',
  // Owner kararı: "Tüm personeli görüntüle" linki KALKTI, tek sade "Daha fazla göster" satırı
  // kaldı (sayısız) — genişletilince yerini SUNUCU tarafı sayfalamaya bırakır (§28.7,
  // MissingItemsCard.tsx dosya başı notu). `dashboard.missing.loadedNote` (kırpma notu)
  // §28.7 ile birlikte KALKTI — genişletilmiş görünüm artık TÜM kümeyi (gömülü `MaxActionItems`
  // sınırından bağımsız) sayfalıyor, "yüklü küme ≠ gerçek toplam" ayrışması bir daha OLMAZ.
  'dashboard.missing.showMore': 'Daha fazla göster',

  // Panel — "Sahaya hazırlık" (§28.3 counts.personnelReady/personnelBlocked/atRiskThisWeek —
  // partition kanıtı SiteReadinessCard.tsx dosya başı notunda).
  'dashboard.readiness.title': 'Sahaya hazırlık',
  'dashboard.readiness.blocked': 'bugün sahaya giremez',
  'dashboard.readiness.atRisk': '7 gün içinde giremeyecek',
  'dashboard.readiness.clear': 'bu hafta engel yok',
  // §28.3 ZORUNLU kılıyor: payda (`personnelReady + personnelBlocked`) taşeronun TOPLAM
  // personel mevcudu DEĞİL, açık çalışma izinlerinde kapsanan tekil kişi sayısıdır — bu alt yazı
  // o paydayı adlandırır (owner'ın reddettiği "bilgi cümlesi" değil, sözleşmenin dayattığı
  // etiket).
  'dashboard.readiness.denominator': 'Açık çalışma izinlerindeki {{count}} kişi',

  // Panel — "Aktif Çalışma İzinleri" (§28.3 upcomingPermits). Başlık sayacı (`countBadge`) ve
  // alt başlık (`subtitle`) owner kararıyla KALDIRILDI — anahtarları da bu yüzden silindi.
  'dashboard.permits.title': 'Aktif çalışma izinleri',
  'dashboard.permits.empty': 'Açık çalışma izni yok.',
  'dashboard.permits.ready': 'Hazır',
  'dashboard.permits.blockedDocuments': 'Belgeler {{ready}}/{{total}}',
  'dashboard.permits.blockedTrainings': 'Eğitimler {{ready}}/{{total}}',
  'dashboard.permits.metrics.personnelLabel': 'Atanmış personel',
  'dashboard.permits.metrics.documentsLabel': 'Belge şartını karşılayan personel',
  'dashboard.permits.metrics.trainingsLabel': 'Eğitimini tamamlayan personel',
  'dashboard.permits.metrics.complianceLabel': 'Uyumluluk',
  'dashboard.permits.metrics.complianceTooltip':
    '{{ready}}/{{total}} personel hem belge hem eğitim şartını karşılıyor (%{{percent}})',
  'dashboard.permits.viewAll': 'Tüm çalışma izinleri',

  // Panel — "Aktif Çalışma İzinleri" tablosunun (`UpcomingPermitsCard.tsx`, owner A/B
  // karşılaştırmasını 2026-08-16'da bu tasarım kazandı) sütun başlıkları + üç ikon-başlık
  // tooltip'inin açıklayıcı içeriği; kart başlığı/boş durum/alt bağlantı YUKARIDAKİ mevcut
  // anahtarları PAYLAŞIR, burada tekrar EDİLMEZ.
  'dashboard.permits.table.col.readiness': 'Hazırlık',
  'dashboard.permits.table.col.title': 'Çalışma izni',
  'dashboard.permits.table.col.hazard': 'Tehlike',
  'dashboard.permits.table.col.validity': 'Geçerlilik',
  'dashboard.permits.table.col.status': 'Durum',
  'dashboard.permits.table.col.personnelHint': 'Bu çalışma iznine atanmış personel sayısı',
  'dashboard.permits.table.col.documentsHint':
    'Belge şartını karşılayan personel / atanmış personel',
  'dashboard.permits.table.col.trainingsHint': 'Eğitimini tamamlayan personel / atanmış personel',
  'dashboard.permits.table.col.complianceHint':
    'Hem belge hem eğitim şartını karşılayan personel; iki alt sayının toplamı değildir.',

  // Panel — "Bekleyen analizler" (§20.3 awaiting-review — Belgeler sayfasındaki
  // `PendingAnalysesStrip` ile AYNI veri, panonun kendi akranı; bkz. AwaitingAnalysisCard.tsx).
  'dashboard.awaitingAnalysis.title': 'Kontrol edilmesi gereken dosyalar',

  // Tehlike sınıfı (§13; sayısal wire)
  'hazard.1': 'Az tehlikeli',
  'hazard.2': 'Tehlikeli',
  'hazard.3': 'Çok tehlikeli',

  // Taşeron durumu (§13)
  'status.active': 'Aktif',
  'status.suspended': 'Askıda',
  'status.inactive': 'Pasif',

  // Uygunluk / belge geçerliliği (§13 türetilmiş)
  'compliance.valid': 'Uygun',
  'compliance.expiring': 'Süresi yaklaşıyor',
  'compliance.expired': 'Süresi geçmiş',
  'compliance.missing': 'Eksik',

  // Belgelerim (§13.6 + §8)
  'documents.title': 'Uygunluk belgelerim',
  'documents.subtitle': 'Firmanızın uygunluk belgelerini yükleyin ve geçerliliğini takip edin.',
  'documents.add': 'Belge yükle',
  'documents.empty': 'Henüz belge yüklenmemiş. Uygunluk belgelerinizi ekleyerek başlayın.',
  'documents.col.type': 'Belge türü',
  'documents.col.file': 'Dosya',
  'documents.col.validity': 'Geçerlilik',
  'documents.col.status': 'Durum',
  'documents.action.download': 'İndir',
  'documents.action.delete': 'Sil',
  'documents.upload.title': 'Uygunluk belgesi yükle',
  'documents.upload.description':
    'Dosyayı seçin, türünü ve geçerlilik tarihlerini belirtin. Dosya doğrudan güvenli depoya yüklenir.',
  'documents.upload.submit': 'Yükle ve ekle',
  'documents.upload.uploading': 'Yükleniyor…',
  'documents.upload.progress': 'Yükleniyor: %{{percent}}',
  'documents.field.file': 'Belge dosyası',
  'documents.field.filePlaceholder': 'Dosya seçin (PDF, görsel veya ofis belgesi)',
  'documents.field.fileHint': 'En fazla 20 MB. PDF, görsel (PNG/JPG) veya ofis belgesi.',
  'documents.field.type': 'Belge türü',
  'documents.field.validFrom': 'Geçerlilik başlangıcı',
  'documents.field.validUntil': 'Geçerlilik bitişi',
  'documents.validity.fromOnly': '{{date}} tarihinden itibaren geçerli',
  'documents.validity.untilOnly': '{{date}} tarihine kadar geçerli',
  'documents.field.note': 'Not (opsiyonel)',
  'documents.delete.title': 'Belgeyi kaldır',
  'documents.delete.body': '{{type}} belgesini kaldırmak istediğinize emin misiniz?',
  'documents.delete.confirm': 'Belgeyi kaldır',
  // Belge türü kaydı (§27, GL #7): seçici/kayıt durumu/ret metinleri + bitiş tarihi kuralı.
  // Tür ETİKETLERİ uygulamada değil kayıttadır (`useDocumentTypes().label`; yoksa ham kod).
  'documentTypes.placeholder': 'Belge türü seçin',
  'documentTypes.loading': 'Yükleniyor…',
  'documentTypes.loadError': 'Belge türleri yüklenemedi.',
  'documentTypes.retry': 'Tekrar dene',
  'documentTypes.empty':
    'Yüklenebilecek bir belge türü yok. Müşteri firmanızın İSG uzmanına başvurun.',
  'documentTypes.typeRejected':
    'Bu belge türü artık kullanılamıyor. Tür listesi yenilendi; lütfen yeniden seçin.',
  // Kayıtta olmayan ya da pasif bir istenen türün eksiği hiç karşılanamaz (§27.0(6)).
  'documentTypes.inactiveMissing':
    'Bu belge türü yüklenemiyor; bu şartı İSG uzmanının güncellemesi gerekiyor.',
  'documentTypes.inactiveSuffix': '(pasif)',
  'documents.expiryHint.EndDateRequired':
    'Bitiş tarihi zorunludur; tarih geçince belge geçersiz sayılır.',
  'documents.expiryHint.EndDateOptional':
    'Bitiş tarihi isteğe bağlıdır; girilirse süresi takip edilir.',
  'documents.field.validUntilRequired': 'Bu belge türünde bitiş tarihi zorunludur.',
  'documents.field.saved': 'Kaydedildi',

  // Belge Analizi (doc-check entegrasyonu, §20 — S17)
  'analysis.title': 'Belge analizi',
  // Tanınmayan kalemin başlığı (`entity`/`code` ikisi de `null`, §20 #33). Tanınan kalem
  // `analysisItemLabel` ile §27 kayıt etiketini okur (GL #7; kayıtta yoksa ham kod).
  // 'Bilinmeyen belge' değil — suçlayıcı okunur (S19-copy-tr.md §9/§Divergences).
  'analysis.item.unrecognised': 'Türü belirlenemedi',
  // Araç kalemi (#33 B.3): #17'ye kadar analizden dosyalanamaz, inceleme panelinde yalnız Reddet.
  'analysis.review.vehicleRejectOnly':
    'Araç belgeleri buradan onaylanamaz. Bu belgeyi reddedin ve "Araçlar" sayfasında ilgili araca yükleyin.',
  // §20.2: AI'nin tanıdığı tür bu hedefte pasif/kayıtta yok — seçici boş, etiket burada.
  'analysis.review.recognisedInactive':
    'Otomatik okuma bu belgeyi “{{label}}” olarak tanıdı; bu tür burada seçilemiyor. Başka bir tür seçin.',
  'analysis.parse.tc-malformed': 'Okundu; numara T.C. kimlik no biçiminde değil',
  'analysis.parse.tc-checksum-fail': 'Okundu; doğrulama algoritmasını geçmiyor',
  'analysis.parse.date-unparseable': 'Okundu; tarih güvenilir biçimde çözülemedi',
  'analysis.parse.not-normalized': 'Okundu; serbest metin, doğrulama yapılmadı',
  // Düşük güven uyarısı (`AnalysisExtractedFields.tsx` FieldRow, REVİZE — dosya üstü not #1).
  // SAYI/yüzde YASAK — yalnız bu düz metin, `field.confidence < 0.90` iken bir ikonla gösterilir.
  'analysis.field.lowConfidence': 'Bu alan net okunamamış olabilir, kontrol edin.',

  // Belge Analizi — gelen kutusu inceleme paneli genelinde paylaşılan ortak metinler
  // (`AnalysisReviewPane.tsx`, `AnalysisInboxRail.tsx`, `lib/analysisInboxTree.ts`; eski
  // tek-analiz-sayfası C14'te SİLİNDİ).
  'analysis.result.loading': 'Analiz bilgisi yükleniyor…',
  'analysis.result.disclaimerReading': 'Bu bir makine okumasıdır; uygunluk kararı değildir.',
  'analysis.result.disclaimerNotSaved':
    'Onaylamadığınız belgeler kaydedilmez ve "Belgelerim" listesinde görünmez.',
  // Türkçe'de sayıdan sonraki isim çoğul eki almaz — `_one`/`_other` yine de
  // TANIMLI olmalı (derleme-zamanı tr/en/de anahtar parite kontrolü, yukarı bkz.).
  'analysis.result.sourcePageCount_one': '{{count}} sayfa',
  'analysis.result.sourcePageCount_other': '{{count}} sayfa',
  'analysis.result.subjectUnnamed': 'Ad okunamadı',
  'analysis.result.pages': 'Sayfa {{span}}',
  'analysis.result.derivedHeading': 'Hesaplanan geçerlilik tarihi (tehlike sınıfına göre)',
  'analysis.result.startNew': 'Yeni analiz başlat',

  // doc-check alan (field) kimlikleri — açık küme (S17-D7). Bilinmeyen anahtar ham hâliyle
  // (etiket = anahtar) gösterilir; burası yalnız BİLİNEN anahtarlara çeviri sağlar.
  'docCheckField.tcKimlikNo': 'T.C. kimlik no',
  'docCheckField.soyad': 'Soyadı',
  'docCheckField.ad': 'Adı',
  'docCheckField.dogumTarihi': 'Doğum tarihi',
  'docCheckField.belgeSonGecerlilik': 'Son geçerlilik tarihi',
  'docCheckField.soyadiAdi': 'Soyadı adı (ters sıralı)',
  'docCheckField.verilmeTarihi': 'Verilme tarihi',
  'docCheckField.sonuc': 'Sonuç',
  'docCheckField.adSoyad': 'Ad soyad',
  'docCheckField.muayeneTarihi': 'Muayene tarihi',
  'docCheckField.kanaatSonuc': 'Kanaat ve sonuç',
  'docCheckField.iseBaslamaTarihi': 'İşe başlama tarihi',
  'docCheckField.egitimKonusu': 'Eğitim konusu',
  'docCheckField.egitimTarihi': 'Eğitim tarihi',
  'docCheckField.egitimSaati': 'Eğitim saati',
  'docCheckField.tehlikeSinifi': 'Tehlike sınıfı',
  'docCheckField.belgeDuzenlemeTarihi': 'Belge düzenleme tarihi',
  'docCheckField.belgeGecerlilikTarihi': 'Belge geçerlilik tarihi',
  'docCheckField.firmaUnvani': 'Firma unvanı',
  'docCheckField.vergiNo': 'Vergi numarası',
  'docCheckField.sgkIsyeriSicilNo': 'SGK işyeri sicil no',
  'docCheckField.duzenlemeTarihi': 'Düzenleme tarihi',

  // Belge Analizi — durum çubuğu (tray, §8 — S17-D11/D13). Yükleme kuyruğundan
  // analiz sonucuna kadar rota değişse de ekranda kalan tek yüzey.
  // S19: panel artık analiz dışı bir aşamayı da taşıyor (S19-D4 değişiklik c).
  'analysis.tray.regionLabel': 'Yükleme durumu',
  'analysis.tray.uploading': '{{done}}/{{total}} dosya yüklendi',
  'analysis.tray.uploadFailed': 'Yüklenemedi',
  'analysis.tray.cancelUpload': '{{name}} yüklemesini iptal et',
  'analysis.tray.cancelAll': 'Tüm yüklemeleri iptal et',
  'analysis.tray.collapse': 'Daralt',
  'analysis.tray.expand': 'Genişlet',
  'analysis.tray.starting': 'Analiz başlatılıyor…',
  'analysis.tray.queued': 'Analiz kuyrukta',
  'analysis.tray.running': 'Analiz sürüyor',
  'analysis.tray.succeeded': 'Analiz tamamlandı',
  'analysis.tray.succeededPartial': 'Kısmen tamamlandı',
  'analysis.tray.failed': 'Analiz başarısız',
  'analysis.tray.startFailedTitle': 'Dosyalarınız yüklendi, ancak analiz başlatılamadı.',
  'analysis.tray.viewResults': 'Sonuçları gör',
  'analysis.tray.viewDetail': 'Ayrıntı',
  'analysis.tray.retry': 'Tekrar dene',
  'analysis.tray.goToOngoing': 'Devam eden analize git',

  // S19 — Belgeler'e birleşen yükleme = analiz akışı (AI-always yükleme, kuyruk, kabul).
  // Metin için KANONİK kaynak `S19-copy-tr.md`; `S19-ui-design.md` §18 yalnız
  // copy-tr'nin kapsamadığı anahtarları sağlar (S19-D10). Hiçbir anahtar,
  // kullanıcı/model kaynaklı bir adı bir Türkçe hâl ekinden önce yerleştirmez.

  // Sürükle-bırak kaplaması — Belgelerim sayfa gövdesi + Personel belgeleri paneli
  'documents.dropHere': 'Dosyaları buraya bırakın',
  'documents.dropHint': 'PDF, görsel veya ofis belgesi · en fazla 10 dosya, toplam 60 MB',
  'documents.dropCapExceeded': 'En fazla 10 dosya, toplam 60 MB yükleyebilirsiniz.',

  // Yükleme modalı — başlık, dosya özeti, alt bilgi düğmeleri. DÖRT başlık DÖRT FARKLI
  // gerçeği anlatır ve hiçbiri olmayan bir şeyi söylemez: okunuyor (anahtar açık, okunabilir
  // dosya var) · bilgilerini girin (anahtar kapalı — dosyalar yüklendi ama analiz edilmiyor) ·
  // okunabilir HİÇBİR dosya yok (hiçbir şey yüklenmedi; "alındı" demek bile yanlış olurdu) ·
  // HİÇBİR dosya kabul edilmedi (hepsi reddedildi — ne alınan ne girilecek bir şey var).
  'upload.modal.title': 'Dosyalarınız alındı, okunuyor',
  'upload.modal.titleOff': 'Dosyalarınız alındı, bilgilerini girin',
  'upload.modal.titleManual': 'Bu dosyaların bilgilerini girin',
  'upload.modal.titleRejected': 'Hiçbir dosya alınamadı',
  // Dosya adı bileşende KIRPILIR; bu anahtar yalnız arkasına eklenen sayımı taşır (eski
  // `upload.modal.filesSummary` adı HAM interpole ediyordu, tasarım N5).
  'upload.modal.filesSummaryMore_one': '+{{count}} dosya',
  'upload.modal.filesSummaryMore_other': '+{{count}} dosya',
  'upload.cancelAll': 'Yüklemeyi iptal et',
  'upload.save': 'Kaydet',
  'upload.done': 'Tamam',

  // "Otomatik okuma" anahtarı (switch) — iki durum + kapatma/kapama uyarıları
  'upload.ai.switchLabelOn': 'Otomatik okuma açık',
  'upload.ai.switchLabelOff': 'Otomatik okuma kapalı',
  'upload.ai.switchOffHint': 'Kapatırsanız belge türünü ve tarihleri kendiniz gireceksiniz.',
  // `upload.ai.offSafeHint` KALDIRILDI (S19 istemci güvenlik incelemesi F1): "Belgelerim'de
  // bekliyor" diyordu, oysa kaydetmeden kapatılan bir dosya hiçbir listede GÖRÜNMÜYORDU.
  // Yerine gelen tek metin aşağıdaki `upload.discard.*` onayıdır ve o doğruyu söyler.

  // Kaydetmeden kapatma = silme onayı (F1). Kullanıcı bu diyaloğu, hiçbir bilgisini
  // girmeden pencereyi kapatmaya çalıştığında görür. Başlık eylemi ADLANDIRIR, onay butonu
  // onu TEKRARLAR — `documents.delete.*`'in zaten gönderilmiş yıkıcı deseni; üçüncü bir
  // onay kalıbı İCAT EDİLMEZ. `{{count}}` = GERÇEKTEN silinecek dosya sayısı (kuyrukta
  // `done` olanlar), seçilen dosya sayısı DEĞİL — ikisi reddedilen/uçuştaki dosya oldukça
  // ayrışır ve bu diyalog yalnız SİLİNECEK olanı konuşur.
  'upload.discard.title': 'Yüklenen dosyaları sil',
  'upload.discard.body_one':
    "Yüklediğiniz {{count}} dosya henüz Belgelerim'e eklenmedi. Pencereyi kapatırsanız bu dosyalar silinir.",
  'upload.discard.body_other':
    "Yüklediğiniz {{count}} dosya henüz Belgelerim'e eklenmedi. Pencereyi kapatırsanız bu dosyalar silinir.",
  // `common.cancel` (Vazgeç) BURADA KULLANILMAZ: vazgeçen taraf kullanıcının kendisidir,
  // bu buton onu yüklemesine GERİ DÖNDÜRÜR.
  'upload.discard.cancel': 'Geri dön',
  'upload.discard.confirm': 'Dosyaları sil',

  // Açıklayıcı kutu — anahtar açıkken gösterilir. Beş satır, bir saniyenin
  // altında taranabilir olmalı (S19-copy-tr.md §1). İkinci satır kasıtlı
  // olarak copy-tr'nin "Kime ait olduğunu bulur" satırının YERİNE geçer —
  // S19'da kişi eşleştirme yapısal olarak imkânsız (SupplierUser'da TCKN yok),
  // bu yüzden kutu asla yönlendirme vaat etmez.
  'upload.ai.box.title': 'Yüklediğinizde ne olur?',
  'upload.ai.box.l1': 'Belgenin türünü tanır',
  'upload.ai.box.l2': 'Aynı kişinin belgelerini gruplar',
  'upload.ai.box.l3': 'Birden fazla kişi varsa ayırır',
  'upload.ai.box.l4': 'Tek seferde en fazla 10 dosya, 60 MB',
  // Beşinci satır (OD-2) — turkish-ohs-expert RC-4'te KARARLAŞTIRILDI: kutu beş
  // satır olarak kalır, bu satır SONUNCU sırada. Gerekçe: "Tamam" modalı sonuç
  // oluşmadan ÖNCE kapatır; gerçek onay daha sonra, kalem bazında, başka bir
  // sayfada olur — bu yüzden kutunun kendisi "siz onaylarsınız" der.
  'upload.ai.box.confirm': 'Sonuçları siz onaylarsınız.',

  // Elle giriş dalı — okunamayan dosyalar (Word/Excel/HEIC/WebP) ve reddedilenler.
  // Türkçe'de sayıdan sonra isim çoğul eki almaz — `_one` ve `_other` AYNI metni taşır ama
  // ikisi de TANIMLI olmak zorundadır (derleme-zamanı tr/en/de parite kontrolü; `en`/`de`'de
  // ikisi GERÇEKTEN farklıdır — eskiden "1 files could not be accepted" çıkıyordu, QA D11).
  'upload.unreadable.title_one': '{{count}} dosya yapay zekâ ile okunamıyor',
  'upload.unreadable.title_other': '{{count}} dosya yapay zekâ ile okunamıyor',
  'upload.unreadable.hint': 'Word, Excel, HEIC ve WebP dosyaları okunamaz. Bilgilerini siz girin.',

  // Yükleme başarısız — MIME yüzünden hiç denenmeyen `upload.unreadable.*`'tan FARKLI: bu
  // dosyalar okunabilir formattaydı, ağ/S3 tarafında başarısız oldu (owner raporu, S19 bug
  // fix). "Yüklenemedi" ötesinde bir SEBEP iddia ETMEZ — istemci sebebi bilmiyor.
  'upload.failed.title_one': '{{count}} dosya yüklenemedi',
  'upload.failed.title_other': '{{count}} dosya yüklenemedi',
  'upload.failed.hint': 'Yeniden deneyebilir ya da diğer dosyaları kaydetmeye devam edebilirsiniz.',
  'upload.failed.retryItem': 'Tekrar dene: {{name}}',
  'upload.rejected.title_one': '{{count}} dosya alınamadı',
  'upload.rejected.title_other': '{{count}} dosya alınamadı',
  'upload.rejected.overCap': 'Bu yüklemede en fazla {{max}} dosya olabilir.',
  'upload.rejected.overSize': 'Toplam {{max}} sınırı aşıldı.',
  'upload.personnelScope': 'Bu belgeler {{name}} için yüklenecek.',

  // Belgelerim — bekleyen onay / aksayan analiz şeritleri (S19-D4, §15)
  'documents.pending.title': '{{count}} belge onayınızı bekliyor',
  'documents.pending.personnel': "{{count}} tanesi kişi belgesi — onaylayınca Personelim'e eklenir",
  'documents.pending.queuedAt': 'Analiz: {{date}}',
  'documents.pending.cta': 'İncele ve onayla',
  // S25 kenar çubuğu hiyerarşisi §13 — `Belge Analizi` giriş düğmesinin rozeti. Sayı BELGE
  // sayar, analiz değil (§13.3); `sr-only` cümle rozetin `aria-hidden` rakamını bir isimle
  // (`analysis.title`) tamamlar, 2.5.3'ü (Label in Name) sağlar.
  'documents.analysisInbox.pendingSr_one': '{{count}} belge onayınızı bekliyor',
  'documents.analysisInbox.pendingSr_other': '{{count}} belge onayınızı bekliyor',
  'documents.analysisInbox.pendingSrAtLeast': 'En az {{count}} belge onayınızı bekliyor',
  'documents.analysisInbox.badgeAtLeast': '{{count}}+',
  'documents.stranded.title': 'Analiz tamamlanamadı — {{count}} dosya bekliyor',
  'documents.stranded.cta': 'Bilgilerini elle gir',
  'documents.stranded.allLinked': 'Bu analizin tüm dosyaları zaten bağlanmış.',

  // KAYIT DIŞI etiketi + uyuşmazlık uyarısı (plan S25 C8, `lib/personMatch.ts`) — rail 2.
  // seviye + inceleme paneli Kişi alanı AYNI anahtarları okur.
  'analysis.person.unregistered': 'Personelinizde yok',
  // S25 web kod incelemesi #2 — "hiç duyulmamış biri" değil, "davet edildi ama henüz
  // etkinleşmedi" (`personnelRegistrationStatus`, `lib/personMatch.ts`); kendi rozeti + tonu.
  'analysis.person.invited': 'Davet bekliyor',
  'analysis.person.invitedHint':
    'Bu kişi firmanıza davet edildi ama henüz hesabını etkinleştirmedi. Etkinleşene kadar belge ona bağlanamaz.',
  'analysis.person.createNew': '+ Yeni personel oluştur',
  'analysis.person.mismatch.tcLabel': 'T.C. kimlik no belgeyle uyuşmuyor',
  'analysis.person.mismatch.tcContent':
    'Seçili kişinin T.C. kimlik numarası, belgeden okunan T.C. kimlik numarasıyla uyuşmuyor. Yine de onaylayabilirsiniz.',
  'analysis.person.mismatch.nameLabel': 'Ad belgeyle uyuşmuyor',
  'analysis.person.mismatch.nameContent':
    'Seçili kişinin adı, belgeden okunan adla uyuşmuyor. Yine de onaylayabilirsiniz.',
  // FIX 2 (`lib/personMatch.ts` REVİZE) — T.C. eşleşiyor ama ad çakışıyor: bu YUMUŞAK bir
  // uyarıdır, "yanlış kişi" DEĞİL "muhtemelen okuma hatası" der — suçlayıcı değil.
  'analysis.person.mismatch.tcNameConflictLabel': 'Ad belgede farklı görünüyor',
  'analysis.person.mismatch.tcNameConflictContent':
    'T.C. kimlik numarası bu kişiyle eşleşiyor, ama belgede okunan ad farklı görünüyor. Bu genellikle bir okuma hatasıdır — belgeyi kontrol edin. Yine de onaylayabilirsiniz.',

  // Kabul (accept) yüzeyi — onay + makbuz
  'analysis.accept.subjectPicker': 'Kişi',
  'analysis.accept.confirm': 'Onayla',
  'analysis.accept.success':
    "Belgelerim'e türü ve tarihleriyle kaydedildi; geçerlilik süresi işlemeye başladı.",
  // FIX 5 (S24 UI-fix) — `Geçerlilik bitişi` belgenin kendi basılı tarihinden değil, tehlike
  // sınıfına göre hesaplanan adaydan ön-doldurulduğunda gösterilir; alan yine DÜZENLENEBİLİR,
  // yalnız kullanıcı bunun bir çıkarım olduğunu bilir.
  'analysis.accept.validUntilInferredHint':
    'Belgede basılı bir geçerlilik tarihi yok; bu tarih tehlike sınıfına göre hesaplandı.',

  // İnceleme paneli (plan S25 C5-C12, `AnalysisReviewPane.tsx`) — çıkarılan alan kartı, footer
  // ⓘ'sı, onay diyaloğu (C10, HER ZAMAN açılır — mismatch'e bağlı DEĞİL).
  'analysis.review.extractedHeading': 'Belgeden okunan alanlar',
  // `droppedCount` (§20 `DocumentAnalysisItemTeachingSignal`, `packages/shared/documentAnalyses.ts`)
  // ÜÇ durumludur — yalnız `> 0` iken gösterilir; `null` (ölçülmedi) ile `0` (ölçüldü, temiz)
  // ASLA bu satırı tetiklemez. Türkçe'de sayıdan sonra isim çoğul eki almaz — `_one`/`_other`
  // yine de AYNI metni taşır (repodaki `sourcePageCount` emsaliyle aynı disiplin).
  'analysis.review.unplacedFields_one':
    '{{count}} alan bir sayfaya bağlanamadı; eksik sayfayı yükleyin veya elle girin.',
  'analysis.review.unplacedFields_other':
    '{{count}} alan bir sayfaya bağlanamadı; eksik sayfayı yükleyin veya elle girin.',
  // `issues` dizisindeki her kod `DOCCHECK_<code>`e çözülür (backend dil paketi, `/resources`) —
  // bu yalnız o çözüm HENÜZ mümkün değilken (paket yüklenmeden önce) gösterilen bir yer tutucu.
  // Bu bir HATA DEĞİL, bir bulgu bildirimi — asla `error.generic` KULLANILMAZ.
  'analysis.issue.generic': 'Bu belgeyle ilgili bir bulgu var.',
  'analysis.review.kanaatSonucInfoLabel': 'Kanaat ve sonuç hakkında',
  'analysis.review.kanaatSonucInfoContent':
    'Hekimin belgedeki kendi ifadesi, değiştirilmeden gösterilir.',
  'analysis.review.footer.infoLabel': 'Onaylamadan önce',
  'analysis.review.footer.infoContent':
    'Onayla, belgeyi seçtiğiniz kişiye veya firmanıza kalıcı olarak bağlar. Reddet tek tıktır ve rayda "geri al" ile geri alınabilir.',
  'analysis.review.confirm.title': 'Belgeyi onayla',
  'analysis.review.confirm.document': 'Belge',
  'analysis.review.confirm.person': 'Kişi',
  'analysis.review.confirm.validity': 'Geçerlilik',
  'analysis.review.confirm.validityEmpty': 'Tarih girilmedi',
  'analysis.review.confirm.warning':
    'Onayladıktan sonra bu belge kaydınıza bağlanır; bağlama geri alınamaz.',
  // C8 §3 — uyuşmazlık algılandığında onay diyaloğuna EKLENEN uyarı satırı (ekran 3c);
  // onayı ASLA engellemez, yalnız anlaşmazlığı adlandırır.
  'analysis.review.confirm.mismatch.tc': 'Seçili kişinin T.C. kimlik numarası belgeyle uyuşmuyor.',
  'analysis.review.confirm.mismatch.name': 'Seçili kişinin adı belgeyle uyuşmuyor.',
  // FIX 2 — T.C. eşleşiyor, ad çakışıyor: YUMUŞAK ton, "okuma hatası olabilir" der.
  'analysis.review.confirm.mismatch.tcNameConflict':
    'T.C. kimlik numarası bu kişiyle eşleşiyor, ama belgedeki ad farklı görünüyor. Muhtemelen bir okuma hatası — belgeyi kontrol edin.',
  'analysis.review.confirm.failed': 'Belge onaylanamadı. Lütfen tekrar deneyin.',

  // Sayfa önizleme (S24, §20 `DocumentAnalysisPageDto`) — süresi dolmuş presigned URL guard'ı
  // + yer tutucu (`DocumentAnalysisPreview.tsx`).
  'analysis.preview.unavailable': 'Önizleme yok',
  // İnceleme paneli tek-sayfa carousel'i (plan S25 C5) — sayfa rozeti, büyüt düğmesi, alt yazı.
  'analysis.preview.pageChip': 'sayfa {{page}}',
  'analysis.preview.itemCaption': '{{fileName}} · sayfa {{span}}',
  'analysis.preview.expandAria': 'Sayfayı büyüt',
  // FIX 3 (S24 UI-fix) — küçük resme tıklayınca açılan büyük önizleme (lightbox).
  'analysis.preview.modal.close': 'Önizlemeyi kapat',
  'analysis.preview.modal.caption': '{{fileName}} · sayfa {{page}}',
  'analysis.preview.modal.previous': 'Önceki sayfa',
  'analysis.preview.modal.next': 'Sonraki sayfa',

  // Kalem reddi (§20.4, S24) — kalıcı, sunucu tarafı `DELETE`. `analysis.accept.dismiss`
  // ("Yoksay") KALDIRILDI: aynı satırda iki farklı davranışa aynı Türkçe kelime (biri
  // istemci-içi/geri-alınabilir, biri kalıcı) binmesin diye (owner onayı, S24 tasarım
  // review §6/D1).
  'analysis.item.reject': 'Reddet',
  // Reddedilmiş bir satırın sakin çözülmüş hâli — glif TEK BAŞINA anlam TAŞIMAZ (rengin
  // yanında metin zorunlu, bkz. `Ban` glifiyle eşleşir).
  'analysis.item.rejected': 'Reddedildi',
  // FIX 1 (S24 UI-fix) — kapalı satırın sağındaki NÖTR durum etiketi (fiil DEĞİL). `rejected`
  // için ayrı bir anahtar YOK — reddedilmiş satır yukarıdaki `analysis.item.rejected`i kullanır.
  'analysis.item.status.accepted': 'Onaylandı',
  // Sahip geçersiz kılması, 2026-08-11 (AC3 — bkz. dosya üstü not) — gutter glifi artık HER
  // durumu taşır, Bekliyor da dahil (`Circle` + bu sr-only).
  'analysis.item.status.pending': 'Bekliyor',

  // Analizin TÜMÜNden vazgeçme (§20.4, S24) — sayfa başlığında, satır düzeyi reddin
  // uzağında (tasarım review §7). `common.cancel` ("Vazgeç") burada KULLANILMAZ —
  // `ConfirmDialog`'a açık `cancelLabel="Geri dön"` verilir (aksi hâlde diyalog iki kez
  // "Vazgeç" render eder, bkz. `upload.discard.cancel` emsali).
  'analysis.discard.action': 'Analizi sil',
  'analysis.discard.confirmTitle': 'Analizi sil',
  // S25 web kod incelemesi #3 — bu metin YALNIZ sayfa görsellerinden bahsediyordu, oysa uç
  // (§20.5/M9) hiçbir belgeye bağlı olmayan yüklediğiniz kaynak dosyaları da KALICI OLARAK
  // siler; `AnalysisInboxMenu.tsx`'in `deleteConfirmBody`si AYNI endpoint için zaten
  // düzeltilmişti, bu iki yüzey artık ÇELİŞMEZ.
  'analysis.discard.confirmBody':
    'Bu analiz, sakladığı sayfa görselleri ve başka hiçbir belgeye bağlı olmayan yüklediğiniz kaynak dosyalar kalıcı olarak silinir. Bu işlem geri alınamaz. Daha önce onayladığınız belgeler silinmez, kaydınızda kalmaya devam eder.',
  'analysis.discard.failed': 'Analiz silinemedi. Lütfen tekrar deneyin.',

  // Gelen kutusu (plan S25) — Belge Analizi'nin tek-analiz-sayfası yerine geçen tam genişlikte
  // ekran: sol rayda TÜM bekleyen analizler, sağda inceleme paneli (bu dilimde iskelet).
  'analysis.inbox.infoLabel': 'Belge Analizi hakkında',
  'analysis.inbox.infoContent':
    'Bekleyen tüm analizler burada birleşir. Sol raydan bir belge seçip tek tek onaylayın ya da reddedin; onay kalıcıdır ve belgeyi kişiye bağlar.',
  'analysis.inbox.progress': '{{decided}}/{{total}} karar verildi',
  'analysis.inbox.searchLabel': 'Belge veya kişi ara',
  'analysis.inbox.searchPlaceholder': 'Belge veya kişi ara…',
  'analysis.inbox.treeLabel': 'Analiz kuyruğu',
  'analysis.inbox.analysisHeading': 'Analiz · {{date}}',
  // S25 kenar çubuğu hiyerarşisi (§7) — daraltılmış analiz başlığındaki belge sayısı. Türkçe
  // CLDR'de tek çoğul biçim vardır; repodaki `deleteConfirmBody_one/_other` emsaline uyup ikisi
  // de aynı metinle yazılır.
  'analysis.inbox.collapsedCount_one': '{{count}} belge',
  'analysis.inbox.collapsedCount_other': '{{count}} belge',
  'analysis.inbox.companyGroupHeading': 'Firma belgeleri',
  'analysis.inbox.unresolvedGroupHeading': 'Belge sahibi belirlenemedi',
  'analysis.review.target.label': 'Belge kime ait?',
  'analysis.review.target.placeholder': 'Seçin',
  'analysis.review.target.company': 'Firma belgesi',
  'analysis.review.target.personnel': 'Personel belgesi',
  'analysis.inbox.itemPageSpan': '{{fileName}} · s.{{span}}',
  // Ray satırında başlığın YANINDAKİ `Info` glifinin sr-only etiketi — `item.issues.length > 0`
  // iken (reddedilmiş satırlarda BASTIRILIR, bkz. `AnalysisInboxRail.tsx`).
  'analysis.inbox.itemHasIssue': 'Bulgu var',
  'analysis.inbox.menuLabel': 'Analiz seçenekleri',
  // Rev. 3 (S25 kenar çubuğu hiyerarşisi §15) — footer düğmesi silindi, arşiv artık tek bir
  // açılır panel; `analysis.inbox.loadArchived` ölü anahtar olarak SİLİNDİ.
  'analysis.inbox.archivedSectionLabel': 'Arşivlenmiş',
  'analysis.inbox.archivedEmpty': 'Arşivlenmiş analiz yok.',
  'analysis.inbox.archivedCount_one': '{{count}} analiz',
  'analysis.inbox.archivedCount_other': '{{count}} analiz',
  'analysis.inbox.emptyQueue': 'Bekleyen analiz yok.',
  // §14 — BEKLEYEN bölümünün kendi durum satırı; yalnız arama sırasında ulaşılır.
  'analysis.inbox.noPendingMatches': 'Bekleyen analizlerde eşleşen belge yok.',
  'analysis.inbox.noArchivedMatches': 'Arşivlenmiş analizlerde eşleşen belge yok.',
  // S25 web kod incelemesi #5 — sunucu sayfalamasıyla kesildiğinde (`AWAITING_REVIEW_PAGE_SIZE`)
  // dürüst uyarı; hiçbir zaman tamamını gösterdiğini iddia etmez.
  'analysis.inbox.truncated':
    'Yalnız en yeni {{shown}}/{{total}} bekleyen analiz gösteriliyor. En eski bekleyenler, daha yenileri karara bağlandıkça sırayla görünecek.',
  // Rev. 3 §14.3 — `analysis.inbox.noSearchResults` (tüm rayın tek mesajı) iki bölüm-bazlı
  // satırla (yukarıdaki `noPendingMatches`/`noArchivedMatches`) DEĞİŞTİRİLDİ, ölü anahtar SİLİNDİ.
  'analysis.inbox.outOfQueueResolved': 'Bu analizin tüm belgeleri zaten karara bağlanmış.',
  'analysis.inbox.pane.emptyTitle': 'İncelemek için bir belge seçin',
  'analysis.inbox.pane.emptyBody':
    'Sol raydaki listeden bir belge seçtiğinizde ayrıntıları burada görünür.',
  // C12/AC16 — bekleyen kalem kalmadığında (`allDecided`) boş durumun ayrı kopyası.
  'analysis.inbox.pane.allDoneTitle': 'Hepsi karara bağlandı',
  'analysis.inbox.pane.allDoneBody':
    'Bekleyen belge kalmadı. Yeni bir analiz başlattığınızda burada görünecek.',
  // F4 (S25 web güvenlik incelemesi) — seçili analiz detayı hata ile sonuçlandığında (firma
  // değişimi sonrası eski uuid artık bu kapsamda yok, ya da analiz bu arada silindi) sonsuz
  // dönen bir yükleniyor göstergesi yerine.
  'analysis.inbox.pane.errorTitle': 'Bu analiz yüklenemedi',
  // ⋯ menüsü (analiz düzeyi) — dosya manifestosu + arşivle/arşivden çıkar + sil.
  'analysis.inbox.menu.filesHeading': 'Yüklenen dosyalar',
  'analysis.inbox.menu.archive': 'Arşivle',
  'analysis.inbox.menu.archiveFailed': 'Arşivlenemedi. Lütfen tekrar deneyin.',
  // S25 web kod incelemesi #4 — arşivin tersi; yalnız rayın arşiv bölümündeki satırlarda sunulur.
  'analysis.inbox.menu.unarchive': 'Arşivden çıkar',
  'analysis.inbox.menu.deleteAction': 'Analizi sil ({{count}} belge)',
  'analysis.inbox.menu.deleteConfirmTitle': 'Analizi sil',
  // F1 (S25 web güvenlik incelemesi) — bu metin YALNIZ sayfa görsellerinden bahsediyordu, oysa
  // uç hiçbir şeyde onaylı olmayan/başka analizce referanslanmayan kaynak belgeleri de KALICI
  // OLARAK siler (`⋯` menüsü bu dosyaları iki satır üstte ADIYLA listeler). `{{count}}` =
  // `detail.sources.length` — GERÇEKTEN silinecek kaynak dosya sayısı.
  'analysis.inbox.menu.deleteConfirmBody_one':
    'Bu analiz, sakladığı sayfa görselleri ve yüklediğiniz {{count}} kaynak belgenin tamamı kalıcı olarak silinir. Bu işlem geri alınamaz.',
  'analysis.inbox.menu.deleteConfirmBody_other':
    'Bu analiz, sakladığı sayfa görselleri ve yüklediğiniz {{count}} kaynak belgenin tamamı kalıcı olarak silinir. Bu işlem geri alınamaz.',
  'analysis.inbox.menu.deleteFailed': 'Analiz silinemedi. Lütfen tekrar deneyin.',
  'analysis.inbox.menu.deleteBlockedTitle': 'Onaylanmış belgeler var',
  'analysis.inbox.menu.deleteBlockedBody':
    'Bu analizde en az bir onaylanmış belge var; onay kalıcı bir uygunluk kararı olduğundan silinemez. Bunun yerine analiz arşivlenecek.',
  // Reddedilen bir kalemin geri alınması (§20.4 restore) — `analysis.item.reject`in tersi.
  'analysis.item.restore': 'Geri al',
  'analysis.item.restoreAria': '{{title}} reddini geri al',
  'analysis.item.restoreFailed': 'Geri alınamadı. Lütfen tekrar deneyin.',

  // Personelim (§13.6)
  'personnel.title': 'Personelim',
  'personnel.subtitle':
    'Firmanıza bağlı personel. Yeni personel oluşturabilir ve isterseniz hesabını etkinleştirmesi için bağlantı gönderebilirsiniz.',
  'personnel.empty': 'Firmanıza henüz personel bağlanmamış.',
  'personnel.col.name': 'Ad soyad',
  'personnel.col.contact': 'E-posta / telefon',
  'personnel.col.status': 'Durum',
  'personnel.col.access': 'Erişim',
  'personnel.col.date': 'Tarih',
  // Durum rozetleri (aktive personel + bekleyen davet — §13.3/§13.6)
  'personnel.status.active': 'Aktif',
  'personnel.status.inactive': 'Pasif',
  'personnel.status.pending': 'Bekliyor',
  'personnel.status.expired': 'Süresi doldu',
  // Girişsiz personel (§13.3, S25-A7c) — giriş bilgisi olmadan oluşturulmuş, henüz etkinleştirilmemiş.
  'personnel.status.notactivated': 'Etkinleştirilmedi',
  'personnel.createAction': 'Personel oluştur',
  // Erişim seviyesi (§13.3)
  'personnel.access.personeli': 'Personel',
  'personnel.access.yetkili': 'Yetkili',
  // Satır aksiyonu — personel profiline geçiş (S26, `/personnel/:userUuid`); `permits.list.action.detail`
  // ile AYNI terim (Detay) — depo genelinde liste satırı → detay sayfası aksiyonu bu adı taşır.

  // Ortak form etiketleri: isteğe bağlı alan, kaydetmeden kapatma onayı
  'personnel.invite.optional': 'opsiyonel',
  'drawer.discard.title': 'Kaydetmeden kapatılsın mı?',
  'drawer.discard.body':
    'Formda kaydedilmemiş bilgiler var. Paneli kapatırsanız girdiğiniz bilgiler kaydedilmez.',
  'drawer.discard.cancel': 'Geri dön',
  'drawer.discard.confirm': 'Kaydetmeden kapat',

  // Satır ⋮ menüsü
  'personnel.action.openMenu': '{{name}} için işlemler',

  // Personel profili (§13.6 YENİ, S26 — /personnel/:userUuid, GET/PUT/DELETE tekil uçlar)
  'personnel.detail.field.activatedAt': 'Aktivasyon tarihi',
  'personnel.detail.field.createdAt': 'Kayıt tarihi',
  'personnelForm.tc.show': 'Göster',
  'personnelForm.tc.hide': 'Gizle',
  'personnelForm.field.phone': 'Telefon',
  'personnelForm.field.email': 'E-posta',
  'personnelForm.field.tcKimlikNo': 'T.C. kimlik no',
  'personnelForm.masked.notice':
    '“Kişisel veri” yetkiniz olmadığı için kişisel bilgiler kısmen gizlenmiştir.',
  // Ortak personel düzenleme formu (#29, `packages/shared/src/personnel/`) — EP ile aynı anahtarlar.
  'personnelForm.edit.action': 'Düzenle',
  'personnelForm.edit.title': 'Personeli düzenle',
  'personnelForm.field.firstName': 'Ad',
  'personnelForm.field.lastName': 'Soyad',
  'personnelForm.field.tcKimlikNoHint':
    '11 haneli, sağlama toplamı geçerli olmalıdır; yalnız bir kez girilir.',
  'personnelForm.field.accessLevel': 'Erişim seviyesi',
  'personnelForm.access.personeli': 'Personel',
  'personnelForm.access.yetkili': 'Yetkili',
  'personnelForm.field.accessHint':
    'Yetkili, web portalından personel ekleyip firma evrakı yükleyebilir; Personel yalnız mobil uygulamada kendi verisini görür.',
  'personnelForm.field.active': 'Aktif',
  'personnelForm.field.activeHint': 'Pasif personel giriş yapamaz ve sahaya erişemez.',
  'personnelForm.refreshNote':
    'Erişim seviyesi ve aktif/pasif durumu değişiklikleri en geç 15 dakika içinde (bir sonraki oturum yenilemesinde) geçerli olur.',
  'personnelForm.lock.tcSetOnce':
    'T.C. kimlik no bir kez girildikten sonra bu ekrandan değiştirilemez. Değişiklik gerekiyorsa destek ile iletişime geçin.',
  'personnelForm.lock.tcNoPermission':
    "T.C. kimlik no'yu yalnızca “Kişisel veri” yetkisi olan kullanıcılar girebilir.",
  'personnelForm.lock.contact':
    'Telefon ve e-posta, kişi hesabını etkinleştirirken doğrulanıp kaydedilir; buradan değiştirilemez.',
  'personnelForm.submit': 'Kaydet',
  'personnelForm.saved': 'Bilgiler güncellendi.',
  'personnelForm.discardEdit.title': 'Değişiklikler kaydedilmesin mi?',
  'personnelForm.discardEdit.body': 'Düzenlemeden çıkarsanız girdiğiniz değişiklikler kaydedilmez.',
  'personnelForm.discardEdit.cancel': 'Geri dön',
  'personnelForm.discardEdit.confirm': 'Değişiklikleri at',
  'personnelForm.validation.firstNameRequired': 'Ad zorunludur.',
  'personnelForm.validation.lastNameRequired': 'Soyad zorunludur.',
  'personnelForm.validation.firstNameTooLong': 'Ad en fazla {{max}} karakter olabilir.',
  'personnelForm.validation.lastNameTooLong': 'Soyad en fazla {{max}} karakter olabilir.',
  'personnelForm.validation.tcInvalid':
    'Girilen T.C. kimlik no geçersiz. Lütfen kontrol edip tekrar deneyin.',
  'personnelForm.validation.tcExistsFallback':
    'Bu T.C. kimlik no ile kayıtlı bir personel zaten var.',
  'personnelForm.hydrate.loading': 'Kişi kaydı yükleniyor…',
  'personnel.detail.notFound.body':
    'Bu kişi firmanızın personel listesinde yok. Listeden tekrar seçin.',
  'personnel.detail.selfNoticeBody':
    'Kendi hesabınızı buradan düzenleyemez veya firmanızdan çıkaramazsınız.',
  'personnel.detail.remove.title': 'Personeli firmanızdan çıkar',
  'personnel.detail.remove.action': 'Firmadan çıkar',
  'personnel.detail.remove.body':
    '{{name}} firmanızın personel listesinden çıkarılacak. Kişi silinmez; yalnızca firma bağı kopar. Yüklenmiş belgeleri hem sizin hem İSG uzmanının listesinden kalkar. Kişi firmanıza yeniden eklenip hesabını etkinleştirirse belgeleri geri gelir.',
  'personnel.detail.remove.bodyNotActivated':
    '{{name}} firmanızın personel listesinden çıkarılacak. Kişi silinmez; yalnızca firma bağı kopar. Yüklenmiş belgeleri hem sizin hem İSG uzmanının listesinden kalkar. Kişi hesabını hiç etkinleştirmediğinden, yeniden eklenirse yeni bir kayıt oluşur; EK-2, adli sicil belgesi gibi belgeleri bu kayda geri gelmez ve yeniden yüklenmeleri gerekir.',
  'personnel.detail.noLogin.body':
    'Bu kişi hesabını henüz etkinleştirmedi; portala ve mobil uygulamaya giriş yapamaz. Belgeleri yine de yüklenebilir.',

  // Mobil uygulama / indirme (§26 app-store linkleri)
  'layout.mobileApp': 'Mobil Uygulama',
  'mobileApp.title': 'Mobil Uygulama',
  'mobileApp.subtitle':
    'İSG Portal mobil uygulamasını indirin; sahadaki personeliniz belgelerine ve bildirimlerine telefondan erişsin.',
  'appDownload.storesTitle': 'Mağazadan indirin',
  'appDownload.title': 'Mobil uygulamayı indirin',
  'appDownload.personnelBody':
    'Hesabınız mobil uygulama üzerinden kullanılır. Devam etmek için uygulamayı telefonunuza indirin.',
  'appDownload.signedInAs': 'Bağlı hesap: {{name}}',
  'appDownload.ios': "App Store'dan indir",
  'appDownload.android': "Google Play'den indir",
  'appDownload.comingSoon.body':
    'Mobil uygulama yakında mağazalarda olacak. İndirme bağlantıları hazır olduğunda burada görünecektir.',
  'appDownload.loading': 'Uygulama bilgileri yükleniyor…',
  'dashboard.app.title': 'Mobil uygulama',
  'dashboard.app.body':
    'Sahadaki personeliniz belgelerine ve bildirimlerine mobil uygulamadan erişebilir.',

  // Davet gönderim kanalı hata kodları (§5.10.1/§5.10.4) — yerel yedek (backend paketi üzerine yazar).
  NO_CONTACT:
    'Bu davette e-posta adresi veya telefon numarası yok; bu nedenle tekrar gönderilemez. Personeli yeni bir davetle ekleyin.',
  INVITE_CHANNEL_UNAVAILABLE:
    'Seçilen gönderim kanalı bu davetin iletişim bilgileriyle kullanılamıyor. Lütfen davetteki e-posta adresine veya telefon numarasına uygun bir kanal seçin.',
  ACTIVATION_LINK_COOLDOWN:
    'Bu iletişim bilgisine kısa süre önce bir aktivasyon bağlantısı gönderildi. Lütfen biraz bekleyip tekrar deneyin.',
  'personnelCreate.title': 'Personel oluştur',
  'personnelCreate.description':
    'Personeli kaydedin; isterseniz hesabını etkinleştirmesi için bir bağlantı da gönderebilirsiniz.',
  'personnelCreate.submit': 'Oluştur',
  'personnelCreate.another': 'Yeni personel oluştur',
  'personnelCreate.contact.title': 'Aktivasyon bağlantısı (isteğe bağlı)',
  'personnelCreate.contact.hint':
    'E-posta veya telefon girerseniz kişiye hesabını etkinleştirmesi için bir bağlantı gönderilir. Bu bilgi kişinin kaydına yazılmaz.',
  'personnelCreate.success.created': 'Personel oluşturuldu.',
  'personnelCreate.success.linkSent': 'Personel oluşturuldu. Aktivasyon bağlantısı hazırlandı.',
  'personnelCreate.validation.tcRequired': 'T.C. kimlik numarası zorunludur.',
  'personnelCreate.cooldownUntil':
    'Bu iletişim bilgisine kısa süre önce bir bağlantı gönderildi. Saat {{availableAt}} itibarıyla tekrar deneyin ya da iletişim alanlarını boşaltıp kişiyi şimdi oluşturun; bağlantıyı daha sonra gönderebilirsiniz.',
  'personnelCreate.cooldownGeneric':
    'Bu iletişim bilgisine kısa süre önce bir bağlantı gönderildi. Biraz bekleyip tekrar deneyin ya da iletişim alanlarını boşaltıp kişiyi şimdi oluşturun; bağlantıyı daha sonra gönderebilirsiniz.',
  'personnelCreate.dailyLimit':
    'Firmanız için günlük bağlantı gönderim sınırına ulaşıldı. İletişim alanlarını boşaltıp kişiyi şimdi oluşturun; bağlantıyı daha sonra gönderebilirsiniz.',
  'personnelLink.cooldownUntil':
    'Bu kişiye ya da bu iletişim bilgisine kısa süre önce bir aktivasyon bağlantısı gönderildi. Saat {{availableAt}} itibarıyla tekrar deneyebilirsiniz.',
  'personnelLink.field.email': 'E-posta',
  'personnelLink.field.emailPlaceholder': 'ad@firma.com',
  'personnelLink.field.phone': 'Telefon',
  'personnelLink.field.phonePlaceholder': '+90 555 123 45 67',
  'personnelLink.field.phoneHint':
    'Cep telefonu numarası. Yurt dışı numaralarda + ve ülke kodunu yazın.',
  'personnelLink.field.channel': 'Gönderim kanalı',
  'personnelLink.field.channelHint':
    'Aktivasyon bağlantısı seçtiğiniz kanaldan otomatik gönderilir; bağlantı yine ekranda kalır.',
  'personnelLink.channel.email': 'E-posta',
  'personnelLink.channel.sms': 'SMS',
  'personnelLink.channel.both': 'E-posta ve SMS',
  'personnelLink.field.link': 'Aktivasyon bağlantısı',
  'personnelLink.copy': 'Kopyala',
  'personnelLink.copied': 'Kopyalandı',
  'personnelLink.copyFailed': 'Bağlantı kopyalanamadı. Lütfen elle seçip kopyalayın.',
  'personnelLink.expiresAt': 'Bağlantı {{date}} tarihine kadar geçerlidir.',
  'personnelLink.dispatch.emailSent': 'Aktivasyon bağlantısı e-posta ile gönderildi.',
  'personnelLink.dispatch.smsSent': 'Aktivasyon bağlantısı SMS ile gönderildi.',
  'personnelLink.dispatch.emailFailed':
    'Aktivasyon bağlantısı e-posta ile gönderilemedi. Bağlantıyı kopyalayıp personele iletin.',
  'personnelLink.dispatch.smsFailed':
    'Aktivasyon bağlantısı SMS ile gönderilemedi. Bağlantıyı kopyalayıp personele iletin.',
  'personnelLink.dispatch.none':
    'Otomatik gönderim yapılamadı. Lütfen aşağıdaki bağlantıyı kopyalayıp personele iletin.',
  'personnelLink.validation.contactRequired': 'E-posta veya telefon zorunludur.',
  'personnelLink.validation.emailInvalid': 'Geçerli bir e-posta adresi girin.',
  'personnelLink.validation.phoneInvalid':
    'Geçerli bir cep telefonu numarası girin. Yurt dışı numaralarda + ve ülke kodunu yazın.',
  'personnelLink.validation.emailTaken':
    'Bu e-posta adresine aktivasyon bağlantısı gönderilemiyor. Başka bir e-posta adresi veya telefon numarası deneyin.',
  'personnelLink.validation.phoneTaken':
    'Bu telefon numarasına aktivasyon bağlantısı gönderilemiyor. Başka bir telefon numarası veya e-posta adresi deneyin.',
  'personnelLink.validation.contactTaken':
    'Girdiğiniz iletişim bilgisine aktivasyon bağlantısı gönderilemiyor. Başka bir e-posta adresi veya telefon numarası deneyin.',
  'personnelLink.pending.sent': 'Gönderildi',
  'personnelLink.pending.expired': 'Süresi doldu',
  'personnelLink.action.send': 'Aktivasyon bağlantısı gönder',
  'personnelLink.action.resend': 'Bağlantıyı tekrar gönder',
  'personnelLink.action.cancel': 'Bağlantıyı iptal et',
  'personnelLink.cancel.title': 'Bağlantıyı iptal et',
  'personnelLink.cancel.body.person':
    '{{name}} için gönderilen aktivasyon bağlantısı iptal edilir; kişi artık bu bağlantıyla hesabını etkinleştiremez ve listede “Etkinleştirilmedi” olarak kalır.',
  'personnelLink.notFound':
    'Bu bağlantı artık geçerli değil; bu arada yeniden gönderilmiş, iptal edilmiş veya kişi hesabını etkinleştirmiş olabilir. Liste yenilendi; pencereyi kapatıp kişinin güncel durumunu kontrol edin.',
  'personnelLink.cancel.body.invite':
    '{{name}} için gönderilen aktivasyon bağlantısı iptal edilir; kişi artık bu bağlantıyla hesabını etkinleştiremez. Bu satır listeden kaldırılır.',
  'personnelLink.cancel.confirm': 'Bağlantıyı iptal et',
  'personnelLink.send.title': 'Aktivasyon bağlantısı gönder',
  'personnelLink.send.description':
    '{{name}} için bir aktivasyon bağlantısı gönderin. Bağlantı yalnızca girdiğiniz e-posta adresine veya telefon numarasına gider; bu bilgi kişinin kaydına yazılmaz.',
  'personnelLink.send.tcMissing':
    'Bu kişinin kaydında T.C. kimlik numarası yok. Aktivasyon bağlantısı gönderilebilmesi için önce kayda T.C. kimlik numarası eklenmelidir.',
  'personnelLink.send.contactHint':
    'E-posta veya telefondan en az birini girin; ikisini de girebilirsiniz.',
  'personnelLink.send.submit': 'Gönder',
  'personnelLink.resend.title': 'Bağlantıyı tekrar gönder',
  'personnelLink.resend.description':
    '{{name}} için yeni bir aktivasyon bağlantısı oluşturulup gönderilir. Önceki bağlantı geçersiz olur.',
  'personnelLink.resend.channelHint':
    'Yeni bağlantı seçtiğiniz kanaldan gönderilir ve ekranda kopyalanabilir kalır.',
  'personnelLink.resend.via.email': 'Yeni bağlantı e-posta ile gönderilecek.',
  'personnelLink.resend.via.sms': 'Yeni bağlantı SMS ile gönderilecek.',
  'personnelLink.resend.submit': 'Tekrar gönder',
  'personnelLink.resend.noContact':
    'Bu bağlantı için kayıtlı bir e-posta veya telefon yok; tekrar gönderilemez.',
  'personnelLink.success.title': 'Aktivasyon bağlantısı hazır',
  'personnelLink.success.body':
    'Gönderim durumu aşağıdadır. Dilerseniz bağlantıyı kopyalayıp kişiye kendiniz de iletebilirsiniz.',
  ACTIVATION_LINK_DAILY_LIMIT:
    'Günlük bağlantı gönderim sınırına ulaşıldı. Lütfen daha sonra tekrar deneyin.',
  PERSONNEL_INACTIVE:
    'Pasif bir personele aktivasyon bağlantısı gönderilemez. Önce personelin durumunu Aktif yapın.',
  PERSONNEL_TC_REQUIRED:
    'Kişinin kaydında T.C. kimlik numarası yok. Numara kayda eklenmeden aktivasyon bağlantısı gönderilemez ve aktivasyon tamamlanamaz.',
  GUEST_INVITE_CONTACT_ALREADY_EXISTS:
    'Bu e-posta adresi veya telefon numarası başka bir hesapta kayıtlı; davet bu iletişim bilgileriyle tamamlanamaz.',
  PERSONNEL_ALREADY_HAS_LOGIN: 'Bu personelin zaten bir hesabı var; yeni bir davet gönderilemez.',

  // Davetsiz personel oluşturma (§13.6 POST /supplier/contractor/personnel, S25 C9) —
  // eski davet akışından AYRI: davet YOK, kayıt anında oluşur (`status: NoLogin`).
  'personnel.create.title': 'Yeni personel oluştur',
  'personnel.create.description':
    'Kişi hemen personelinize eklenir ve belge onayında seçilebilir. Hesabını etkinleştirebilmesi için daha sonra Personelim sayfasından aktivasyon bağlantısı gönderebilirsiniz; bunun için kayıtta T.C. kimlik numarası bulunmalıdır.',
  'personnel.create.submit': 'Oluştur',
  'personnel.create.field.firstName': 'Ad',
  'personnel.create.field.lastName': 'Soyad',
  'personnel.create.field.tcKimlikNo': 'T.C. kimlik no',
  'personnel.create.field.tcKimlikNoHint': '11 haneli, sağlama toplamı geçerli olmalıdır.',
  'personnel.create.validation.firstNameRequired': 'Ad zorunludur.',
  'personnel.create.validation.lastNameRequired': 'Soyad zorunludur.',
  'personnel.create.validation.tcInvalid':
    'Girilen T.C. kimlik numarası geçersiz. Lütfen kontrol edip tekrar deneyin.',
  'personnel.create.tcExistsFallback': 'Bu T.C. kimlik numarasıyla kayıtlı bir personel zaten var.',

  // Personel belgeleri (§15.2 yol B + §8; KVKK)
  'personnelDrawer.analysis.hint': 'Sonuç hazır olunca onayınız için burada bildirilir.',
  'personnelDocs.title': 'Belgeler',
  'personnelDocs.kvkk':
    'Bu belgeler kişisel veri içerir. Yalnız gerekli evrakı yükleyin; erişim iş amacıyla sınırlıdır.',
  'personnelDocs.add': 'Belge yükle',
  'personnelDocs.empty': 'Bu personel için henüz belge yüklenmemiş.',
  'personnelDocs.col.document': 'Belge',
  'personnelDocs.col.approval': 'Onay durumu',
  // S29 — silme düğmesi yerine `Pending` DIŞINDAKİ satırlarda görünür (bkz. `Badge.tsx`
  // `personnelDocApprovalTone` başlığı). Kısa tutulur; "neden" zaten yanındaki Onay
  // rozetiyle görünür, burada yalnız "şimdi ne yapılır" kalır.
  'personnelDocs.rejectionReason': 'Red gerekçesi: {{reason}}',
  'personnelDocs.add.title': 'Personel belgesi yükle',
  'personnelDocs.add.description':
    'Dosyayı seçin, türünü ve geçerlilik tarihlerini belirtin. Dosya doğrudan güvenli depoya yüklenir.',
  'personnelDocs.add.submit': 'Yükle ve ekle',
  'personnelDocs.add.uploading': 'Yükleniyor…',
  'personnelDocs.add.progress': 'Yükleniyor: %{{percent}}',
  'personnelDocs.field.file': 'Belge dosyası',
  'personnelDocs.field.filePlaceholder': 'Dosya seçin (PDF, görsel veya ofis belgesi)',
  'personnelDocs.field.fileHint': 'En fazla 20 MB. PDF, görsel (PNG/JPG) veya ofis belgesi.',
  'personnelDocs.field.type': 'Belge türü',
  'personnelDocs.field.validFrom': 'Geçerlilik başlangıcı',
  'personnelDocs.field.validUntil': 'Geçerlilik bitişi',
  'personnelDocs.field.note': 'Not (opsiyonel)',
  'personnelDocs.delete.title': 'Belgeyi kaldır',
  'personnelDocs.delete.body': '{{type}} belgesini kaldırmak istediğinize emin misiniz?',
  'personnelDocs.delete.confirm': 'Belgeyi kaldır',

  // supplier-contractor erişim kapısı (iki katmanlı authz — Personeli görmez)
  'access.loading': 'Erişim denetleniyor…',
  'access.forbidden.title': 'Bu bölüme erişiminiz yok',
  'access.forbidden.body':
    'Personel yönetimi yalnız taşeron yetkilisine açıktır. Erişim için firma yetkilinizle görüşebilirsiniz.',
  'access.forbidden.back': 'Panele dön',
  'access.unavailable.title': 'Bölüm şu anda kullanılamıyor',
  'access.unavailable.body': 'Erişim bilgisi alınamadı. Lütfen tekrar deneyin.',
  'access.unavailable.retry': 'Tekrar dene',

  // Durum ekranları (bağ yok / erişim yok / genel hata)
  'state.noContractor.title': 'Firma ataması bulunamadı',
  'state.noContractor.body':
    'Aktif firmada hesabınıza bağlı bir taşeron firma bulunamadı. Birden fazla firmaya bağlıysanız üstteki firma seçiciden doğru firmayı seçebilir; aksi hâlde firma yetkilinizle görüşebilirsiniz.',
  'state.noAccess.title': 'Bu firmaya erişiminiz yok',
  'state.noAccess.body':
    'Seçili firmaya erişim atamanız bulunmuyor. Üstteki firma seçiciden erişebildiğiniz bir firma seçebilir veya firma yetkilinizle görüşebilirsiniz.',
  'state.error.title': 'Bilgiler yüklenemedi',
  'state.error.body': 'Bir sorun oluştu. Lütfen tekrar deneyin.',
  'state.error.retry': 'Tekrar dene',

  'validation.identifierRequired': 'E-posta veya telefon zorunludur.',
  'validation.passwordRequired': 'Parola zorunludur.',
  'validation.codeRequired': 'Doğrulama kodu zorunludur.',
  'validation.passwordPolicy': 'Parola en az 8 karakter, bir harf ve bir rakam içermeli.',

  // Backend hata kodları için yerel yedek (backend paketi geldiğinde üzerine yazılır).
  'error.generic': 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
  NETWORK_ERROR: 'Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.',
  INVALID_CREDENTIALS: 'E-posta/telefon veya parola hatalı.',
  VALIDATION_FAILED: 'Lütfen alanları kontrol edin.',
  UNAUTHORIZED: 'Oturumunuz doğrulanamadı. Lütfen tekrar giriş yapın.',
  PASSWORD_POLICY_ERROR: 'Parola en az 8 karakter, bir harf ve bir rakam içermeli.',
  CODE_INVALID: 'Doğrulama kodu hatalı veya kullanılmış. Yeni kod isteyin.',
  CODE_EXPIRED: 'Doğrulama kodunun süresi doldu. Yeni kod isteyin.',
  CODE_TOO_FREQUENT: 'Çok sık kod istediniz. Lütfen biraz bekleyip tekrar deneyin.',
  SUPPLIER_NO_COMPANY:
    'Hesabınız henüz bir firmaya bağlı değil. Lütfen firma yetkilinizle görüşün.',
  SUPPLIER_INACTIVE: 'Hesabınız pasif durumda. Lütfen firma yetkilinizle görüşün.',
  COMPANY_NOT_ACCESSIBLE:
    'Bu firmaya erişiminiz bulunmuyor. Erişim için firma yetkilinizle görüşebilirsiniz.',
  GUEST_INVITE_INVALID:
    'Bu aktivasyon bağlantısı geçersiz veya daha önce kullanılmış. Hesabınızı bu bağlantıyla zaten etkinleştirdiyseniz giriş yapın; aksi hâlde sizi ekleyen firmadan yeni bir bağlantı isteyin.',
  GUEST_INVITE_EXPIRED:
    'Bu aktivasyon bağlantısının süresi doldu. Lütfen sizi ekleyen firmadan yeni bir bağlantı isteyin.',

  // Belge yükleme / taşeron (§8 + §13.6) hata kodları — yerel yedek (backend paketi üzerine yazar).
  DOCUMENT_TOO_LARGE: 'Dosya boyutu izin verilen sınırı aşıyor (en fazla 20 MB).',
  DOCUMENT_TYPE_UNSUPPORTED:
    'Bu dosya türü desteklenmiyor. PDF, görsel veya ofis belgesi yükleyin.',
  DOCUMENT_UPLOAD_FAILED: 'Dosya yüklenemedi. Lütfen tekrar deneyin.',
  DOCUMENT_UPLOAD_ABORTED: 'Dosya yükleme iptal edildi.',
  DOCUMENT_NOT_UPLOADED: 'Yükleme tamamlanamadı. Lütfen dosyayı tekrar yükleyin.',
  DOCUMENT_NOT_FOUND: 'Aradığınız belge bulunamadı.',
  CONTRACTOR_NOT_FOUND: 'Hesabınız bu firmada bir taşerona bağlı değil.',
  CONTRACTOR_DOCUMENT_NOT_FOUND: 'Belge bulunamadı veya kaldırılmış.',
  // Belge analizi (§20 — S17) hata kodları — yerel yedek (backend paketi üzerine yazar).
  DOCUMENT_ANALYSIS_NOT_FOUND: 'Aradığınız belge analizi bulunamadı.',
  DOCUMENT_ANALYSIS_IN_PROGRESS:
    'Şu anda devam eden bir belge analizi var. Yeni bir analiz başlatmadan önce mevcut analizin tamamlanmasını bekleyin.',
  DOCUMENT_ANALYSIS_QUOTA_EXCEEDED:
    'Bugün için belge analizi kotası doldu. Kota yarın sıfırlanacaktır.',
  DOCUMENT_ANALYSIS_NOT_ENABLED: 'Belge analizi bu firma için etkin değil.',
  DOCUMENT_ANALYSIS_UNAVAILABLE: 'Belge analizi bu ortamda şu anda kullanılamıyor.',
  // Belge analizi kabul (accept, §20.2 — S19) hata kodları — yerel yedek.
  DOCUMENT_ANALYSIS_NOT_COMPLETE: 'Bu analiz henüz tamamlanmadı; şimdi onaylanamaz.',
  DOCUMENT_ANALYSIS_ITEM_NOT_FOUND:
    'Bu analizde böyle bir belge kalemi bulunamadı. Sayfayı yenileyip tekrar deneyin.',
  // Kalem reddi + analizden vazgeçme (§20.4, S24) hata kodları — yerel yedek.
  DOCUMENT_ANALYSIS_ITEM_ALREADY_ACCEPTED:
    'Bu kalem zaten onaylanıp dosyalandı; artık reddedilemez. Sayfayı yenileyin.',
  DOCUMENT_ANALYSIS_NOT_TERMINAL: 'Bu analiz henüz tamamlanmadı; bu işlem şimdi yapılamaz.',
  // `süresi doldu` DEĞİL: backend yalnız `StagingKey`'in ÇÖZÜLEMEDİĞİNİ görür — "süresi doldu",
  // "silindi" ve "hiç yazılmadı" arasında ayrım YAPAMAZ (bugün her zaman sonuncusudur).
  // `bulunamadı` epistemiktir ve üç durumda da doğrudur; ayrıca özne SİSTEMİN kopyasıdır,
  // kullanıcının belgesi değil — kullanıcı yanlış bir şey yapmadı. Backend dil paketindeki
  // (`LocalizationCatalog.cs`) karşılığıyla HARFİ HARFİNE aynı olmak zorunda.
  DOCUMENT_ANALYSIS_ARTIFACT_MISSING:
    'Bu belgenin sistemdeki kopyası bulunamadığı için kaydedilemedi. Belgeyi yeniden yükleyin.',
  DOCUMENT_ANALYSIS_ARTIFACT_COPY_FAILED: 'Belge kopyalanamadı. Lütfen tekrar deneyin.',
  // Personel belgeleri (§15) hata kodları — yerel yedek (backend paketi üzerine yazar).
  PERSONNEL_NOT_FOUND: 'Personel bulunamadı veya firmanıza bağlı değil.',
  PERSONNEL_DOCUMENT_NOT_FOUND: 'Belge bulunamadı veya kaldırılmış.',
  // S29 — yalnız `DELETE .../personnel/{userUuid}/documents/{linkUuid}` (§15.2): liste
  // STALE'ken (satır hâlâ `Pending` görünürken) silme denenmiş, ama belge arada
  // onaylanmış/reddedilmiş. "Sayfayı yenileyip tekrar deneyin" DEMEZ — yenileme
  // `Approved`/`Rejected` gösterir, her yeniden deneme AYNI `409`a çarpar (kanonik metin
  // `LocalizationCatalog.cs` R("PERSONNEL_DOCUMENT_NOT_PENDING", …) — backend zaten
  // yükler + üzerine yazar; burası yalnız o gelene kadarki/başarısız YEDEKtir).
  PERSONNEL_DOCUMENT_NOT_PENDING:
    'Bu belge zaten değerlendirildi; artık silinemez. Yerine yeni bir belge yükleyin ya da kaldırılması için müşteri firmanıza veya İSG uzmanına başvurun.',

  // İş İzinleri (Supplier — §21). Salt-okunur izin bilgisi + kendi personelini atama + readiness.
  'layout.permits': 'Çalışma İzinleri',
  'permits.title': 'Çalışma İzinleri',
  'permits.list.subtitle':
    'Firmanıza açılan çalışma izinlerini görüntüleyin, izne kendi personelinizi atayın ve eğitim durumlarını izleyin.',
  'permits.list.search': 'İzin ara',
  'permits.list.searchPlaceholder': 'Başlığa göre ara',
  'permits.list.filter.status': 'Durum',
  'permits.list.filter.allStatuses': 'Tüm durumlar',
  'permits.list.col.permitType': 'Çalışma izni türü',
  'permits.list.col.title': 'Başlık',
  'permits.list.col.sites': 'Sahalar',
  'permits.list.sitesMore': '+{{count}}',
  'permits.list.col.validity': 'Geçerlilik',
  'permits.list.col.status': 'Durum',
  'permits.list.col.readiness': 'Hazır personel',
  'permits.list.count': '{{count}} izin listeleniyor',
  'permits.list.empty': 'Görüntülenecek çalışma izni bulunamadı.',
  'permits.pagination.nav': 'Sayfalama',
  'permits.pagination.previous': 'Önceki',
  'permits.pagination.next': 'Sonraki',
  'permits.readiness.summary': '{{ready}} / {{total}} hazır',
  'permits.readiness.personnelOnly': '{{total}} personel',
  'permits.readiness.noPersonnel': 'Personel yok',
  'permits.status.Draft': 'Taslak',
  'permits.status.Submitted': 'Onay bekliyor',
  'permits.status.Approved': 'Onaylandı',
  'permits.status.Active': 'Aktif',
  'permits.status.Rejected': 'Reddedildi',
  'permits.status.Expired': 'Süresi doldu',
  'permits.status.Closed': 'Kapatıldı',
  'permits.status.AwaitingSupplierInfo': 'Bilginiz bekleniyor',
  'permits.status.AwaitingAiReview': 'Otomatik incelemede',
  'permits.status.Revision': 'Revize istendi',
  'permits.status.DepartmentReview': 'Kontrol aşamasında',
  'permits.status.AwaitingEntryPermit': 'Giriş izni bekleniyor',
  'permits.list.noResults': 'Filtrelerle eşleşen çalışma izni yok.',
  'personnel.list.count': '{{count}} personel listeleniyor',
  'documents.list.count': '{{count}} belge listeleniyor',
  'common.clearFilters': 'Filtreleri temizle',
  'common.noResults.body': 'Aramayı veya filtreleri değiştirin ya da temizleyin.',
  'permits.detail.back': 'Çalışma izinlerine dön',
  'permits.detail.loading': 'İzin yükleniyor…',
  'permits.detail.readOnlyNote':
    'İzin bilgileri İSG uzmanı tarafından yönetilir. Siz yalnız kendi personelinizi atayabilir/çıkarabilirsiniz.',
  'permits.detail.field.sites': 'Sahalar',
  'permits.detail.field.validityStart': 'Geçerlilik başlangıcı',
  'permits.detail.field.validityEnd': 'Geçerlilik bitişi',
  'permits.detail.field.createdAt': 'Oluşturulma',
  'permits.detail.section.details': 'Bilgiler',
  'permits.detail.section.requirements': 'Gereksinimler',
  'permits.detail.section.personnel': 'Kapsanan personel',
  'permits.detail.section.trainings': 'Gerekli eğitimler',
  'permits.detail.requiredDocuments': 'İstenen belgeler',
  'permits.detail.requiredDocumentsEmpty': 'Bu izin tipinde belge istenmiyor.',
  'permits.trainings.empty': 'Bu izin için gerekli eğitim tanımlanmamış.',
  'permits.detail.protectiveEquipment': 'İstenen KKD',
  'permits.detail.protectiveEquipmentHint':
    'İznin tipinde istenen kişisel koruyucu donanımlar; bu donanımları çalışma alanına siz getirirsiniz.',
  'permits.detail.protectiveEquipmentEmpty': 'Bu izin tipinde KKD istenmiyor.',
  'permits.detail.protectiveEquipmentMinimumNotice':
    'Yukarıda listelenen kişisel koruyucu donanımlar asgari gereksinimdir. İşinizin ve sağlığınızın gerektirdiği diğer koruyucu donanımları da yanınızda bulundurunuz.',
  'permits.personnel.add': 'Personel ata',
  'permits.personnel.col.name': 'Ad soyad',
  'permits.personnel.col.training': 'Eğitim',
  'permits.personnel.col.documents': 'Belgeler',
  'permits.personnel.col.readiness': 'Hazırlık',
  'permits.personnel.requiredDocuments': 'İstenen personel belgeleri',
  'permits.personnel.requiredDocumentsEmpty': 'Bu izin tipinde personel belgesi istenmiyor.',
  'permits.personnel.ready': 'Hazır',
  'permits.personnel.notReady': 'Eksik',
  'permits.personnel.missingDocuments': 'Eksik belgeler',
  'permits.personnel.empty': 'Bu izne henüz personel atanmamış.',
  'permits.personnel.action.remove': 'Personeli çıkar',
  'permits.personnel.action.openMenu': '{{name}} için işlemler',
  'permits.personnel.remove.title': 'Personeli çıkar',
  'permits.personnel.remove.body': '"{{name}}" bu iznin kapsamından çıkarılsın mı?',
  'permits.personnel.remove.confirm': 'Personeli çıkar',
  'permits.personnel.add.title': 'İzne personel ata',
  'permits.personnel.add.description':
    'Kendi personelinizden bir veya birden fazla kişiyi seçerek bu izne atayın. Hesabını henüz etkinleştirmemiş kişiler de atanabilir.',
  'permits.personnel.add.submit': 'Ata',
  'permits.personnel.add.empty':
    'Atanabilecek uygun personel bulunmuyor. Aşağıdan yeni personel oluşturabilirsiniz.',
  'permits.personnel.add.createNew': 'Yeni personel oluştur',
  'permits.personnel.notActivated': 'Etkinleştirilmedi',
  'permits.personnel.notActivated.hint':
    'Kişi, hesabını etkinleştirmeden bu iznin gerekli eğitimlerini tamamlayamaz. Aktivasyon bağlantısı Personelim sayfasından gönderilir.',
  // İş İzni — Araçlar (§23.2; taşeron Yetkilisi araç ekler + araç evrakı yükler/siler, onay İSG uzmanında)
  'permits.vehicles.section': 'Araçlar',
  'permits.detail.tab.personnel': 'Personel',
  'permits.detail.tabs.label': 'Çalışma izni bölümleri',
  'permits.detail.tab.personnelIncomplete_one': '{{count}} kişi hazır değil',
  'permits.detail.tab.personnelIncomplete_other': '{{count}} kişi hazır değil',
  'permits.detail.tab.vehiclesIncomplete_one': '{{count}} araç hazır değil',
  'permits.detail.tab.vehiclesIncomplete_other': '{{count}} araç hazır değil',
  'permits.vehicles.add': 'Araç ekle',
  'permits.vehicles.requiredDocuments': 'İstenen araç belgeleri',
  'permits.vehicles.requiredDocumentsEmpty': 'Bu izin tipinde araç belgesi istenmiyor.',
  'permits.vehicles.empty': 'Bu izne henüz araç eklenmemiş.',
  'permits.vehicles.ready': 'Hazır',
  'permits.vehicles.notReady': 'Eksik',
  'permits.vehicles.missingDocuments': 'Eksik araç belgeleri',
  'permits.vehicles.upload.title': 'Araç belgesi yükle',
  'permits.vehicles.upload.description':
    '{{plate}} plakalı araca belge yükleyin. Belge, İSG uzmanının onayına gönderilir.',
  'permits.vehicles.upload.chooseFile': 'Dosya seç',
  'permits.vehicles.upload.submit': 'Yükle',
  'permits.vehicles.docs.col.type': 'Belge türü',
  'permits.vehicles.docs.col.approval': 'Onay durumu',
  'permits.vehicles.docs.rejectionReason': 'Red gerekçesi: {{reason}}',
  'permits.vehicles.docs.action.download': 'Belgeyi indir',
  'permits.vehicles.docs.action.delete': 'Belgeyi sil',
  'permits.vehicles.docs.delete.title': 'Belgeyi sil',
  'permits.vehicles.docs.delete.body':
    '"{{type}}" belgesi silinsin mi? Belge, aracın eklendiği izinlerde de artık görünmez.',
  'permits.vehicles.docs.delete.confirm': 'Sil',
  'permits.docApproval.pending': 'Onay bekliyor',
  'permits.docApproval.approved': 'Onaylandı',
  'permits.docApproval.rejected': 'Reddedildi',
  'vehicles.docStatus.allApproved': 'Tümü onaylı',
  'vehicles.docStatus.none': 'Belge yok',
  'vehicles.docStatus.missingEnd': 'Bitiş tarihi yok',
  'vehicles.openPermits.yes': 'Açık izinde',
  'vehicles.sheet.docs.title': 'Araç belgeleri',
  'vehicles.sheet.docs.upload': 'Belge yükle',
  'vehicles.sheet.docs.empty': 'Bu araca henüz belge eklenmemiş.',
  'vehicles.sheet.docs.note':
    'Belgeler araçla birlikte tutulur; onay, aracın eklendiği tüm izinlerde geçerlidir.',
  'vehicles.sheet.plateLocked': 'Plaka kilitli',
  'vehicles.upload.noteTooLong': 'Not en fazla {{max}} karakter olabilir.',
  'vehicles.validation.plateInvalid':
    'Plaka geçersiz: en fazla {{max}} karakter ve en fazla {{keyMax}} harf ve rakam olabilir, görünmeyen karakter içeremez. Plakayı elle yeniden yazın.',
  'vehicles.title': 'Araçlar',
  'vehicles.subtitle':
    'Firmanızın araçları. Bir belge bir kez onaylanır ve aracın eklendiği tüm izinlerde geçerli olur.',
  'vehicles.add': 'Araç ekle',
  'vehicles.list.count_one': '{{count}} araç listeleniyor',
  'vehicles.list.count_other': '{{count}} araç listeleniyor',
  'vehicles.empty': 'Henüz araç eklenmemiş.',
  'vehicles.col.plate': 'Plaka',
  'vehicles.col.description': 'Açıklama',
  'vehicles.col.documents': 'Belgeler',
  'vehicles.col.docStatus': 'Belge durumu',
  'vehicles.col.openPermits': 'Açık izin',
  'vehicles.action.openMenu': '{{plate}} plakalı araç işlemleri',
  'vehicles.action.upload': 'Belge yükle',
  'vehicles.action.edit': 'Düzenle',
  'vehicles.action.delete': 'Sil',
  'vehicles.action.deleteBlocked': 'Sil (önce açık izinlerden çıkarın)',
  'vehicles.action.deleteBlockedApproved': 'Sil (onaylı belgesi var)',
  'vehicles.delete.title': 'Aracı sil',
  'vehicles.delete.body':
    '{{plate}} plakalı araç ve belgeleri silinsin mi? Geçmiş izinlerde plaka görünmeye devam eder.',
  'vehicles.delete.confirm': 'Sil',
  'vehicles.form.edit.title': 'Aracı düzenle',
  'vehicles.form.edit.description': 'Değişiklik, aracın eklendiği tüm izinlerde görünür.',
  'vehicles.form.create.description': 'Firmanızın araç listesine yeni bir araç ekleyin.',
  'vehicles.form.submit.edit': 'Kaydet',
  'vehicles.form.submit.create': 'Ekle',
  'vehicles.form.field.plate': 'Plaka',
  'vehicles.form.field.description': 'Açıklama',
  'vehicles.form.platePlaceholder': 'Örn. 34 ABC 123',
  'vehicles.form.plateLocked':
    'Plaka artık değiştirilemez: araç daha önce bir izne eklenmiş ya da belgelerinden biri onaylanmış. Farklı bir plaka için yeni araç ekleyin.',
  'vehicles.permitAdd.title': 'Araç ekle',
  'vehicles.permitAdd.description':
    'Firmanızın araçlarından seçin ya da yeni bir plaka girin. Yeni plaka araç listenize de eklenir.',
  'vehicles.permitAdd.submit': 'Ekle',
  'vehicles.permitAdd.registered': 'Kayıtlı araçlar',
  'vehicles.permitAdd.registeredEmpty': 'İzne eklenebilecek kayıtlı araç yok.',
  'vehicles.permitAdd.newVehicle': 'Yeni araç',
  'vehicles.permitAdd.plateOnPermit': 'Bu araç zaten izinde.',
  'vehicles.permitAdd.plateExisting': 'Bu plaka listede var; mevcut araç izne eklenecek.',
  'vehicles.permitAdd.plateNew': 'Yeni araç; araç listesine de eklenecek.',
  'vehicles.permitAdd.partialFailure': '{{plate}} plakalı araç eklenemedi.',
  'vehicles.unlink.action': 'İzinden çıkar',
  'vehicles.unlink.title': 'Aracı izinden çıkar',
  'vehicles.unlink.body':
    '{{plate}} plakalı araç bu izinden çıkarılsın mı? Araç ve belgeleri araç listesinde kalır.',
  'vehicles.unlink.confirm': 'Çıkar',
  'permits.vehicles.col.readiness': 'Hazırlık',
  'vehicles.validation.plateRequired': 'Plaka zorunludur.',
  'vehicles.validation.plateTooLong': 'Plaka en fazla {{max}} karakter olabilir.',
  'vehicles.validation.plateKeyTooLong': 'Plakada en fazla {{max}} harf ve rakam olabilir.',
  'vehicles.validation.descriptionTooLong': 'Açıklama en fazla {{max}} karakter olabilir.',
  VEHICLE_NOT_FOUND: 'Araç bulunamadı; silinmiş ya da izinden çıkarılmış olabilir.',
  VEHICLE_DOCUMENT_NOT_FOUND: 'Bu araç belgesi bulunamadı ya da artık mevcut değil.',
  VEHICLE_PLATE_ALREADY_EXISTS:
    'Bu plakayla kayıtlı bir araç zaten var (boşluk ve noktalama dikkate alınmaz). Listedeki mevcut aracı kullanın.',
  VEHICLE_PLATE_LOCKED:
    'Bu aracın plakası artık değiştirilemez: araç daha önce bir izne eklenmiş ya da belgelerinden biri onaylanmış. Farklı bir plaka için yeni bir araç ekleyin.',
  VEHICLE_HAS_OPEN_PERMITS:
    'Bu araç açık bir izinde olduğu için silinemez. Önce aracı açık izinlerden çıkarın.',
  VEHICLE_HAS_LOCKED_DOCUMENTS:
    'Bu araç silinemez: onaylı bir belgesi var ya da belgelerinden biri kullanımda (araca bu belge yüklüyken saha giriş izni verildi veya araç aktif bir izinde). Araç listede kalır; farklı bir araç için yeni bir araç ekleyin.',
  VEHICLE_DOCUMENT_NOT_PENDING:
    'Bu belge zaten değerlendirildi; artık silinemez. Yerine yeni bir belge yükleyin.',
  VEHICLE_DOCUMENT_IN_USE:
    'Bu belge kullanımda olduğu için silinemez: araca bu belge yüklüyken saha giriş izni verildi ya da araç aktif bir izinde. Belge hatalıysa reddedin; güncel belge için yenisini yükleyin.',
  PERMIT_NOT_FOUND: 'Çalışma izni bulunamadı veya firmanıza ait değil.',
} satisfies Record<string, string>;

const en: Record<keyof typeof tr, string> = {
  'pagination.summary': '{{from}}–{{to}} of {{total}}',
  'pagination.summaryEmpty': '0 records',
  'app.name': 'İSG Portal',
  'app.supplierPortal': 'Supplier Portal',
  'app.tagline': "Manage your subcontractor company's health and safety from one place.",

  'login.title': 'Sign in to the Supplier Portal',
  'login.subtitle': 'Enter your email or phone and password to access your account.',
  'login.identifier': 'Email or phone',
  'login.identifierPlaceholder': 'name@company.com or +90 555 123 45 67',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.forgotPassword': 'Forgot password',

  'selectWorkspace.title': 'Select a company',
  'selectWorkspace.subtitle': 'You are linked to more than one company. Choose one to continue.',
  'selectWorkspace.continue': 'Continue with company',
  'selectWorkspace.backToLogin': 'Back to sign in',
  'selectWorkspace.expired':
    'Your company selection has expired or the session was not found. Please sign in again.',

  'switcher.label': 'Active company',
  'switcher.change': 'Switch company',
  'switcher.switching': 'Switching company…',
  'switcher.noAccess': 'You do not have access to this company. Please contact your company admin.',
  'switcher.menu.heading': 'Clients',
  'switcher.menu.fanoutCap': '{{shown}} / {{total}} companies summarized',
  'switcher.menu.footer': 'Switching moves the entire panel to the selected client.',
  'switcher.badge.ariaLabel_one': '{{count}} client needs attention',
  'switcher.badge.ariaLabel_other': '{{count}} clients need attention',
  'switcher.summary.loading': 'Loading counts…',
  'switcher.activeNote': 'You are here',
  'switcher.state.blocked': 'Blocked today',
  'switcher.state.atRisk': 'Due this week',
  'switcher.row.clean': 'clear',
  'switcher.row.unavailable': 'Could not load right now',
  'switcher.row.goToPanel': 'Go to panel',

  'guest.title': 'Activate your account',
  'guest.subtitle': 'Complete the steps below to join the company that added you.',
  'guest.intro':
    'Start the activation to receive a verification code; then activate your account with the code, your T.C. kimlik number and a new password.',
  'guest.start': 'Start activation',
  'guest.sentTo': 'We sent a verification code to {{target}}.',
  'guest.sentToEach':
    'We sent a separate verification code to each of your contacts: {{target}}. You will sign in with the contact whose code you enter.',
  'guest.code': 'Verification code',
  'guest.newPassword': 'New password',
  'guest.passwordHint': 'At least 8 characters, including a letter and a digit.',
  'guest.activate': 'Activate account',
  'guest.resend': 'Resend code',
  'guest.invalidLink':
    'The activation link is invalid or missing. Please check the link you received.',
  'guest.tc': 'T.C. kimlik number',
  'guest.tcHint':
    'Enter your 11-digit T.C. kimlik number to activate your account. It must match the number recorded by the company that added you.',
  'guest.validation.tcRequired': 'The T.C. kimlik number is required.',
  'guest.tcRequired':
    "Your account cannot be activated right now; your T.C. kimlik number is missing from the company's records. Please contact the company that added you; your link stays valid.",
  'guest.tcAlreadyExists':
    "Your account cannot be activated right now; the company's records need to be corrected. Please contact the company that added you; your link stays valid.",
  'guest.linkDead':
    'This activation link can no longer be used. If you have received a newer link, use that one; otherwise, ask the company that added you for a new link.',
  TC_KIMLIK_MISMATCH:
    'The T.C. kimlik number you entered does not match our records. If you typed it correctly, contact the company that added you.',
  'guest.activatedNote': 'Your account is activated; taking you to the dashboard.',

  'forgot.title': 'Reset password',
  'forgot.subtitle': 'Enter the email or phone linked to your account and we will send a code.',
  'forgot.identifier': 'Email or phone',
  'forgot.submit': 'Send code',
  'forgot.backToLogin': 'Back to sign in',

  'reset.title': 'Set a new password',
  'reset.subtitle': 'Enter the verification code you received and your new password.',
  'reset.code': 'Verification code',
  'reset.newPassword': 'New password',
  'reset.passwordHint': 'At least 8 characters, including a letter and a digit.',
  'reset.submit': 'Update password',
  'reset.successTitle': 'Your password has been updated',
  'reset.successBody': 'You can now sign in with your new password.',
  'reset.toLogin': 'Go to sign in',

  'layout.dashboard': 'Dashboard',
  'layout.documents': 'My documents',
  'layout.personnel': 'My personnel',
  'layout.vehicles': 'Vehicles',
  'layout.account': 'Account',
  'layout.profile': 'Profile',
  'layout.logout': 'Sign out',
  'layout.nav.primary': 'Main navigation',
  'layout.rail.collapse': 'Collapse menu',
  'layout.rail.expand': 'Expand menu',
  'layout.skipToContent': 'Skip to content',
  'layout.user.menu': 'User menu',
  'layout.user.signedInAs': 'Signed in as',
  'layout.user.company': 'Company',
  'layout.user.language': 'Language',

  // Profile (Self) — api-contract §18.2
  'profile.title': 'Profile',
  'profile.subtitle': 'View and update your account details.',
  'profile.loading': 'Loading profile...',
  'profile.info.title': 'Account details',
  'profile.info.subtitle': 'These details are read-only.',
  'profile.field.fullName': 'Full name',
  'profile.field.firstName': 'First name',
  'profile.field.lastName': 'Last name',
  'profile.field.emailOrPhone': 'Email / Phone',
  'profile.field.company': 'Company',
  'profile.edit.title': 'Edit name',
  'profile.edit.subtitle': 'Update your display name.',
  'profile.edit.save': 'Save',
  'profile.updated': 'Profile updated.',
  'profile.validation.firstNameRequired': 'First name is required.',
  'profile.validation.lastNameRequired': 'Last name is required.',
  'profile.password.title': 'Change password',
  'profile.password.subtitle': 'Choose a strong password for your security.',
  'profile.password.current': 'Current password',
  'profile.password.new': 'New password',
  'profile.password.confirm': 'New password (repeat)',
  'profile.password.hint': 'At least 8 characters, including a letter and a digit.',
  'profile.password.save': 'Update password',
  'profile.password.updated': 'Your password has been updated.',
  'profile.password.wrongCurrent': 'Current password is incorrect.',
  'profile.validation.currentPasswordRequired': 'Current password is required.',
  'profile.validation.confirmRequired': 'Please repeat the password.',
  'profile.validation.passwordMismatch': 'Passwords do not match.',

  // Common (buttons/labels)
  'common.close': 'Close',
  'common.cancel': 'Cancel',
  'common.actions': 'Actions',
  'common.compactRows': 'Compact rows',
  'common.loading': 'Loading…',

  // Dashboard (§28.3 GET /supplier/dashboard) — "what's blocking me at this company today?"
  'dashboard.title': 'Dashboard',
  'dashboard.subtitle': "Your company's status at a glance.",
  'dashboard.loading': 'Loading dashboard…',
  'dashboard.status.notEntryReady': 'Not entry-ready',

  // Dashboard — "Missing" (§28.3 items; ALL item kinds)
  'dashboard.missing.title': 'Missing',
  'dashboard.missing.empty': 'Nothing missing.',
  'dashboard.missing.filterEmpty': 'Nothing in this filter.',
  'dashboard.missing.filter.all': 'All',
  'dashboard.missing.filter.document': 'Document',
  'dashboard.missing.filter.training': 'Training',
  'dashboard.missing.filter.groupLabel': 'Item type filter',
  'dashboard.missing.companyDocument': 'Company document',
  'dashboard.missing.unknownType': 'Document',
  'dashboard.missing.status.missing': 'Missing',
  'dashboard.missing.status.expired': 'Expired',
  'dashboard.missing.status.noValidity': 'No expiry date',
  'dashboard.missing.status.rejected': 'Rejected',
  'dashboard.missing.rejectionReason.label': 'Rejection reason',
  'dashboard.missing.trainingGeneric': 'Training not completed',
  'dashboard.missing.permitApprovalGeneric': "Awaiting approval from the client's OHS expert",
  'dashboard.missing.showMore': 'Show more',

  // Dashboard — "Site readiness" (§28.3 counts.personnelReady/personnelBlocked/atRiskThisWeek)
  'dashboard.readiness.title': 'Site readiness',
  'dashboard.readiness.blocked': "Can't enter site today",
  'dashboard.readiness.atRisk': "Won't be able to enter within 7 days",
  'dashboard.readiness.clear': 'No obstacle this week',
  'dashboard.readiness.denominator': '{{count}} people in open work permits',

  // Dashboard — "Active work permits" (§28.3 upcomingPermits)
  'dashboard.permits.title': 'Active work permits',
  'dashboard.permits.empty': 'No open work permits.',
  'dashboard.permits.ready': 'Ready',
  'dashboard.permits.blockedDocuments': 'Documents {{ready}}/{{total}}',
  'dashboard.permits.blockedTrainings': 'Trainings {{ready}}/{{total}}',
  'dashboard.permits.metrics.personnelLabel': 'Assigned personnel',
  'dashboard.permits.metrics.documentsLabel': 'Personnel meeting the document requirement',
  'dashboard.permits.metrics.trainingsLabel': 'Personnel who completed training',
  'dashboard.permits.metrics.complianceLabel': 'Compliance',
  'dashboard.permits.metrics.complianceTooltip':
    '{{ready}}/{{total}} personnel meet both the document and training requirements ({{percent}}%)',
  'dashboard.permits.viewAll': 'All work permits',

  // Dashboard — column headers + the three icon-header tooltips' explainer content for the
  // "Active work permits" table (`UpcomingPermitsCard.tsx` — this design won the owner's
  // 2026-08-16 A/B comparison)
  'dashboard.permits.table.col.readiness': 'Readiness',
  'dashboard.permits.table.col.title': 'Work permit',
  'dashboard.permits.table.col.hazard': 'Hazard',
  'dashboard.permits.table.col.validity': 'Validity',
  'dashboard.permits.table.col.status': 'Status',
  'dashboard.permits.table.col.personnelHint': 'Number of personnel assigned to this work permit',
  'dashboard.permits.table.col.documentsHint':
    'Personnel meeting the document requirement / assigned personnel',
  'dashboard.permits.table.col.trainingsHint':
    'Personnel who completed training / assigned personnel',
  'dashboard.permits.table.col.complianceHint':
    'Personnel meeting both the document and the training requirement; not the sum of the two sub-counts.',

  // Dashboard — "Awaiting analysis" (§20.3 awaiting-review — same data as the Documents
  // page's `PendingAnalysesStrip`, the dashboard's own peer)
  'dashboard.awaitingAnalysis.title': 'Files to review',

  // Hazard class (§13; numeric wire)
  'hazard.1': 'Low hazard',
  'hazard.2': 'Hazardous',
  'hazard.3': 'Highly hazardous',

  // Contractor status (§13)
  'status.active': 'Active',
  'status.suspended': 'Suspended',
  'status.inactive': 'Inactive',

  // Compliance / document validity (§13 derived)
  'compliance.valid': 'Valid',
  'compliance.expiring': 'Expiring soon',
  'compliance.expired': 'Expired',
  'compliance.missing': 'Missing',

  // My documents (§13.6 + §8)
  'documents.title': 'My compliance documents',
  'documents.subtitle': "Upload your company's compliance documents and track their validity.",
  'documents.add': 'Upload document',
  'documents.empty': 'No documents uploaded yet. Start by adding your compliance documents.',
  'documents.col.type': 'Document type',
  'documents.col.file': 'File',
  'documents.col.validity': 'Validity',
  'documents.col.status': 'Status',
  'documents.action.download': 'Download',
  'documents.action.delete': 'Delete',
  'documents.upload.title': 'Upload compliance document',
  'documents.upload.description':
    'Select the file, then set its type and validity dates. The file is uploaded directly to secure storage.',
  'documents.upload.submit': 'Upload and add',
  'documents.upload.uploading': 'Uploading…',
  'documents.upload.progress': 'Uploading: {{percent}}%',
  'documents.field.file': 'Document file',
  'documents.field.filePlaceholder': 'Choose a file (PDF, image or office document)',
  'documents.field.fileHint': 'Up to 20 MB. PDF, image (PNG/JPG) or office document.',
  'documents.field.type': 'Document type',
  'documents.field.validFrom': 'Valid from',
  'documents.field.validUntil': 'Valid until',
  'documents.validity.fromOnly': 'Valid from {{date}}',
  'documents.validity.untilOnly': 'Valid until {{date}}',
  'documents.field.note': 'Note (optional)',
  'documents.delete.title': 'Remove document',
  'documents.delete.body': 'Are you sure you want to remove the {{type}} document?',
  'documents.delete.confirm': 'Remove document',
  'documentTypes.placeholder': 'Select a document type',
  'documentTypes.loading': 'Loading…',
  'documentTypes.loadError': 'Document types could not be loaded.',
  'documentTypes.retry': 'Try again',
  'documentTypes.empty':
    "No document type is available for upload. Contact your client's OHS expert.",
  'documentTypes.typeRejected':
    'This document type can no longer be used. The type list has been refreshed; please choose again.',
  'documentTypes.inactiveMissing':
    'This document type cannot be uploaded; the OHS expert needs to update this requirement.',
  'documentTypes.inactiveSuffix': '(inactive)',
  'documents.expiryHint.EndDateRequired':
    'An end date is required; the document becomes invalid once it passes.',
  'documents.expiryHint.EndDateOptional':
    'An end date is optional; if entered, its expiry is tracked.',
  'documents.field.validUntilRequired': 'An end date is required for this document type.',
  'documents.field.saved': 'Saved',

  // Document Analysis (doc-check integration, §20 — S17)
  'analysis.title': 'Document analysis',
  // Unrecognised item title + vehicle reject-only note (§20, #33).
  'analysis.item.unrecognised': 'Type could not be determined',
  'analysis.review.vehicleRejectOnly':
    'Vehicle documents cannot be approved here. Reject this document and upload it to the vehicle on the "Vehicles" page.',
  'analysis.review.recognisedInactive':
    'AI recognized this document as “{{label}}”, but that type cannot be selected here. Choose another type.',
  'analysis.parse.tc-malformed': 'Read; not shaped like a T.C. number',
  'analysis.parse.tc-checksum-fail': 'Read; fails the checksum',
  'analysis.parse.date-unparseable': 'Read; date could not be parsed reliably',
  'analysis.parse.not-normalized': 'Read; free text, not validated',
  // Low-confidence warning (see `tr` comment above the same key).
  'analysis.field.lowConfidence': 'This field may not have been read clearly — please check it.',

  // Document Analysis — copy shared across the inbox review pane (`AnalysisReviewPane.tsx`,
  // `AnalysisInboxRail.tsx`, `lib/analysisInboxTree.ts`; the old one-analysis-per-page result
  // view was DELETED in C14).
  'analysis.result.loading': 'Loading analysis…',
  'analysis.result.disclaimerReading':
    'This is a machine reading; it is not a compliance decision.',
  'analysis.result.disclaimerNotSaved':
    'Documents you have not approved are not saved and will not appear in "My documents".',
  'analysis.result.sourcePageCount_one': '{{count}} page',
  'analysis.result.sourcePageCount_other': '{{count}} pages',
  'analysis.result.subjectUnnamed': 'Name could not be read',
  'analysis.result.pages': 'Page {{span}}',
  'analysis.result.derivedHeading': 'Calculated validity date (by hazard class)',
  'analysis.result.startNew': 'Start a new analysis',

  // doc-check field ids — open key set (S17-D7). An unknown key renders raw (label = key);
  // this block only supplies translations for the KNOWN keys.
  'docCheckField.tcKimlikNo': 'T.C. ID number',
  'docCheckField.soyad': 'Surname',
  'docCheckField.ad': 'First name',
  'docCheckField.dogumTarihi': 'Date of birth',
  'docCheckField.belgeSonGecerlilik': 'Expiry date',
  'docCheckField.soyadiAdi': 'Full name (surname first)',
  'docCheckField.verilmeTarihi': 'Issue date',
  'docCheckField.sonuc': 'Result',
  'docCheckField.adSoyad': 'Full name',
  'docCheckField.muayeneTarihi': 'Examination date',
  'docCheckField.kanaatSonuc': 'Medical opinion and result',
  'docCheckField.iseBaslamaTarihi': 'Employment start date',
  'docCheckField.egitimKonusu': 'Training subject',
  'docCheckField.egitimTarihi': 'Training date',
  'docCheckField.egitimSaati': 'Training hours',
  'docCheckField.tehlikeSinifi': 'Hazard class',
  'docCheckField.belgeDuzenlemeTarihi': 'Document issue date',
  'docCheckField.belgeGecerlilikTarihi': 'Document validity date',
  'docCheckField.firmaUnvani': 'Company legal name',
  'docCheckField.vergiNo': 'Tax number',
  'docCheckField.sgkIsyeriSicilNo': 'SGK workplace registration no.',
  'docCheckField.duzenlemeTarihi': 'Issue date',

  // Document Analysis — status tray (§8 — S17-D11/D13). The one surface that stays
  // on screen from the upload queue through to the analysis result, across routes.
  'analysis.tray.regionLabel': 'Upload status',
  'analysis.tray.uploading': '{{done}}/{{total}} files uploaded',
  'analysis.tray.uploadFailed': 'Upload failed',
  'analysis.tray.cancelUpload': 'Cancel upload of {{name}}',
  'analysis.tray.cancelAll': 'Cancel all uploads',
  'analysis.tray.collapse': 'Collapse',
  'analysis.tray.expand': 'Expand',
  'analysis.tray.starting': 'Starting analysis…',
  'analysis.tray.queued': 'Analysis queued',
  'analysis.tray.running': 'Analysis running',
  'analysis.tray.succeeded': 'Analysis complete',
  'analysis.tray.succeededPartial': 'Partially complete',
  'analysis.tray.failed': 'Analysis failed',
  'analysis.tray.startFailedTitle':
    'Your files were uploaded, but the analysis could not be started.',
  'analysis.tray.viewResults': 'View results',
  'analysis.tray.viewDetail': 'View detail',
  'analysis.tray.retry': 'Try again',
  'analysis.tray.goToOngoing': 'Go to ongoing analysis',

  // S19 — merged upload = analysis flow on My documents (AI-always upload, queue, accept).

  // Drag-and-drop overlay — My documents page body + personnel documents panel
  'documents.dropHere': 'Drop files here',
  'documents.dropHint': 'PDF, image or office document · up to 10 files, 60 MB total',
  'documents.dropCapExceeded': 'You can upload at most 10 files, 60 MB in total.',

  // Upload modal — title, file summary, footer buttons
  'upload.modal.title': 'Your files were received; they are being read',
  'upload.modal.titleOff': 'Your files were received; enter their details',
  'upload.modal.titleManual': 'Enter the details for these files',
  'upload.modal.titleRejected': 'No files could be accepted',
  'upload.modal.filesSummaryMore_one': '+{{count}} file',
  'upload.modal.filesSummaryMore_other': '+{{count}} files',
  'upload.cancelAll': 'Cancel upload',
  'upload.save': 'Save',
  'upload.done': 'OK',

  // "Automatic reading" switch — both states + turn-off / close hints
  'upload.ai.switchLabelOn': 'Automatic reading on',
  'upload.ai.switchLabelOff': 'Automatic reading off',
  'upload.ai.switchOffHint':
    "If you turn this off, you'll enter the document type and dates yourself.",

  // Closing without saving = delete confirmation (F1)
  'upload.discard.title': 'Delete uploaded files',
  'upload.discard.body_one':
    'The {{count}} file you uploaded has not been added to My documents yet. If you close this window, it will be deleted.',
  'upload.discard.body_other':
    'The {{count}} files you uploaded have not been added to My documents yet. If you close this window, they will be deleted.',
  'upload.discard.cancel': 'Go back',
  'upload.discard.confirm': 'Delete files',

  // Explainer box — shown when the switch is on
  'upload.ai.box.title': 'What happens when you upload?',
  'upload.ai.box.l1': "Recognizes the document's type",
  'upload.ai.box.l2': 'Groups documents by the same person',
  'upload.ai.box.l3': 'Splits it apart if it holds more than one person',
  'upload.ai.box.l4': 'Up to 10 files, 60 MB per batch',
  'upload.ai.box.confirm': 'You confirm the results.',

  // Manual branch — unreadable files (Word/Excel/HEIC/WebP) and rejected files
  'upload.unreadable.title_one': '{{count}} file cannot be read by AI',
  'upload.unreadable.title_other': '{{count}} files cannot be read by AI',
  'upload.unreadable.hint':
    'Word, Excel, HEIC and WebP files cannot be read. Enter their details yourself.',

  'upload.failed.title_one': '{{count}} file could not be uploaded',
  'upload.failed.title_other': '{{count}} files could not be uploaded',
  'upload.failed.hint': 'You can retry, or continue saving the other files.',
  'upload.failed.retryItem': 'Retry: {{name}}',
  'upload.rejected.title_one': '{{count}} file could not be accepted',
  'upload.rejected.title_other': '{{count}} files could not be accepted',
  'upload.rejected.overCap': 'This upload can include at most {{max}} files.',
  'upload.rejected.overSize': 'The {{max}} total limit was exceeded.',
  'upload.personnelScope': 'These documents will be uploaded for {{name}}.',

  // My documents — pending / stranded analysis strips
  'documents.pending.title': '{{count}} documents are waiting for your approval',
  'documents.pending.personnel':
    '{{count}} of them are personnel documents — added to My personnel once approved',
  'documents.pending.queuedAt': 'Analysis: {{date}}',
  'documents.pending.cta': 'Review and approve',
  'documents.analysisInbox.pendingSr_one': '{{count}} document is awaiting your approval',
  'documents.analysisInbox.pendingSr_other': '{{count}} documents are awaiting your approval',
  'documents.analysisInbox.pendingSrAtLeast':
    'At least {{count}} documents are awaiting your approval',
  'documents.analysisInbox.badgeAtLeast': '{{count}}+',
  'documents.stranded.title': 'Analysis could not complete — {{count}} files are waiting',
  'documents.stranded.cta': 'Enter details manually',
  'documents.stranded.allLinked': 'Every file from this analysis has already been linked.',

  // KAYIT DIŞI ("unregistered") tag + mismatch warning (plan S25 C8, `lib/personMatch.ts`) —
  // read by the rail's level 2 AND the review pane's Person field.
  'analysis.person.unregistered': 'Not in your personnel',
  'analysis.person.invited': 'Invite pending',
  'analysis.person.invitedHint':
    'This person was invited to your company but has not activated their account yet. The document cannot be linked to them until they do.',
  'analysis.person.createNew': '+ Create new personnel',
  'analysis.person.mismatch.tcLabel': 'T.C. kimlik number does not match the document',
  'analysis.person.mismatch.tcContent':
    "The selected person's T.C. kimlik number does not match the one read from the document. You can still approve.",
  'analysis.person.mismatch.nameLabel': 'Name does not match the document',
  'analysis.person.mismatch.nameContent':
    "The selected person's name does not match the one read from the document. You can still approve.",
  // See `tr` comment above the same key (FIX 2).
  'analysis.person.mismatch.tcNameConflictLabel': 'The name looks different on the document',
  'analysis.person.mismatch.tcNameConflictContent':
    'The T.C. kimlik number matches this person, but the name read from the document looks different. This is usually a misread — please check the document. You can still approve.',

  // Accept surface — approve + receipt
  'analysis.accept.subjectPicker': 'Person',
  'analysis.accept.confirm': 'Approve',
  'analysis.accept.success':
    'Filed into My documents with its type and dates; the validity period has started.',
  // FIX 5 (S24 UI-fix) — shown when "Valid until" was prefilled from the hazard-class
  // calculation instead of the document's own printed date; the field stays editable.
  'analysis.accept.validUntilInferredHint':
    'The document has no printed validity date; this date was calculated from the hazard class.',

  // Review pane (plan S25 C5-C12, `AnalysisReviewPane.tsx`) — extracted-fields card, footer
  // ⓘ, confirm dialog (C10, ALWAYS opens — not only on mismatch).
  'analysis.review.extractedHeading': 'Fields read from the document',
  // `droppedCount` is three-state — shown only when `> 0`; `null` (not measured) and `0`
  // (measured, clean) never trigger this line (see `tr` comment above the same key).
  'analysis.review.unplacedFields_one':
    '{{count}} field could not be linked to a page; upload the missing page, or enter it manually.',
  'analysis.review.unplacedFields_other':
    '{{count}} fields could not be linked to a page; upload the missing page, or enter them manually.',
  // Every code in the `issues` array resolves to `DOCCHECK_<code>` (backend language pack,
  // `/resources`) — this is only the placeholder shown while that resolution isn't possible
  // yet (before the pack loads). This is an advisory finding, NOT an error — never
  // `error.generic`.
  'analysis.issue.generic': 'There is a finding for this document.',
  'analysis.review.kanaatSonucInfoLabel': 'About the assessment and result',
  'analysis.review.kanaatSonucInfoContent':
    "The physician's own wording on the document, shown unchanged.",
  'analysis.review.footer.infoLabel': 'Before you approve',
  'analysis.review.footer.infoContent':
    'Approve permanently links the document to the person or company you choose. Reject is one click and can be undone with "undo" in the rail.',
  'analysis.review.confirm.title': 'Approve document',
  'analysis.review.confirm.document': 'Document',
  'analysis.review.confirm.person': 'Person',
  'analysis.review.confirm.validity': 'Validity',
  'analysis.review.confirm.validityEmpty': 'No date entered',
  'analysis.review.confirm.warning':
    'Once approved, this document is linked to your record; the link cannot be undone.',
  // C8 §3 — extra warning line added to the confirm dialog when a mismatch is detected (screen
  // 3c); never blocks approval, only names the disagreement.
  'analysis.review.confirm.mismatch.tc':
    "The selected person's T.C. kimlik number does not match the document.",
  'analysis.review.confirm.mismatch.name':
    "The selected person's name does not match the document.",
  // FIX 2 — T.C. matches, name conflicts: softer tone, "likely a misread".
  'analysis.review.confirm.mismatch.tcNameConflict':
    'The T.C. kimlik number matches this person, but the name on the document looks different. This is likely a misread — please check the document.',
  'analysis.review.confirm.failed': 'The document could not be approved. Please try again.',

  // Page preview (S24, §20 `DocumentAnalysisPageDto`) — expired presigned URL guard + placeholder
  // (`DocumentAnalysisPreview.tsx`).
  'analysis.preview.unavailable': 'Preview unavailable',
  // Review pane single-page carousel (plan S25 C5) — page chip, expand button, caption.
  'analysis.preview.pageChip': 'page {{page}}',
  'analysis.preview.itemCaption': '{{fileName}} · page {{span}}',
  'analysis.preview.expandAria': 'Expand page',
  // FIX 3 (S24 UI-fix) — large preview (lightbox) opened by clicking a thumbnail.
  'analysis.preview.modal.close': 'Close preview',
  'analysis.preview.modal.caption': '{{fileName}} · page {{page}}',
  'analysis.preview.modal.previous': 'Previous page',
  'analysis.preview.modal.next': 'Next page',

  // Item reject (§20.4, S24) — permanent, server-side `DELETE`. `analysis.accept.dismiss`
  // ("Dismiss") REMOVED: same row must not carry two different behaviours under one word.
  'analysis.item.reject': 'Reject',
  'analysis.item.rejected': 'Rejected',
  // FIX 1 (S24 UI-fix) — neutral status label on the collapsed row (not a verb). No separate key
  // for `rejected` — a rejected row uses the key above.
  'analysis.item.status.accepted': 'Approved',
  // Owner override, 2026-08-11 (AC3 — see file-top note) — the gutter glyph now carries every
  // status, pending included (`Circle` + this sr-only).
  'analysis.item.status.pending': 'Pending',

  // Discard the whole analysis (§20.4, S24).
  'analysis.discard.action': 'Delete analysis',
  'analysis.discard.confirmTitle': 'Delete analysis',
  'analysis.discard.confirmBody':
    'This analysis, its stored page images, and any of your uploaded source files not linked to another document are permanently deleted. This cannot be undone. Documents you already approved are not deleted and remain on file.',
  'analysis.discard.failed': 'The analysis could not be deleted. Please try again.',

  // Inbox (plan S25) — full-width screen that replaces the one-analysis-per-page result view:
  // left rail lists every pending analysis, right pane is the review panel (skeleton in this
  // slice).
  'analysis.inbox.infoLabel': 'About Document Analysis',
  'analysis.inbox.infoContent':
    'All pending analyses are combined here. Select a document from the left rail and approve or reject it individually; approval is permanent and links the document to a person.',
  'analysis.inbox.progress': '{{decided}}/{{total}} decided',
  'analysis.inbox.searchLabel': 'Search document or person',
  'analysis.inbox.searchPlaceholder': 'Search document or person…',
  'analysis.inbox.treeLabel': 'Analysis queue',
  'analysis.inbox.analysisHeading': 'Analysis · {{date}}',
  'analysis.inbox.collapsedCount_one': '{{count}} document',
  'analysis.inbox.collapsedCount_other': '{{count}} documents',
  'analysis.inbox.companyGroupHeading': 'Company documents',
  'analysis.inbox.unresolvedGroupHeading': 'Owner could not be determined',
  'analysis.review.target.label': 'Who does this document belong to?',
  'analysis.review.target.placeholder': 'Select',
  'analysis.review.target.company': 'Company document',
  'analysis.review.target.personnel': 'Personnel document',
  'analysis.inbox.itemPageSpan': '{{fileName}} · p.{{span}}',
  // sr-only label for the `Info` glyph next to the title in the tree row — shown when
  // `item.issues.length > 0` (suppressed on rejected rows, see `AnalysisInboxRail.tsx`).
  'analysis.inbox.itemHasIssue': 'Has a finding',
  'analysis.inbox.menuLabel': 'Analysis options',
  'analysis.inbox.archivedSectionLabel': 'Archived',
  'analysis.inbox.archivedEmpty': 'No archived analyses.',
  'analysis.inbox.archivedCount_one': '{{count}} analysis',
  'analysis.inbox.archivedCount_other': '{{count}} analyses',
  'analysis.inbox.emptyQueue': 'No pending analyses.',
  'analysis.inbox.noPendingMatches': 'No matching document in the pending analyses.',
  'analysis.inbox.noArchivedMatches': 'No matching document in the archived analyses.',
  'analysis.inbox.truncated':
    'Showing only the {{shown}}/{{total}} most recent pending analyses. Older ones will appear in turn as newer ones are decided.',
  'analysis.inbox.outOfQueueResolved': 'Every document in this analysis has already been decided.',
  'analysis.inbox.pane.emptyTitle': 'Select a document to review',
  'analysis.inbox.pane.emptyBody':
    'Details appear here once you select a document from the list on the left.',
  // C12/AC16 — separate empty-state copy once no pending item is left (`allDecided`).
  'analysis.inbox.pane.allDoneTitle': 'Everything has been decided',
  'analysis.inbox.pane.allDoneBody':
    'No pending documents left. New ones will appear here once you start another analysis.',
  'analysis.inbox.pane.errorTitle': 'Could not load this analysis',
  // `⋯` menu (analysis level) — file manifest + archive/unarchive + delete.
  'analysis.inbox.menu.filesHeading': 'Uploaded files',
  'analysis.inbox.menu.archive': 'Archive',
  'analysis.inbox.menu.archiveFailed': 'Could not archive. Please try again.',
  'analysis.inbox.menu.unarchive': 'Remove from archive',
  'analysis.inbox.menu.deleteAction': 'Delete analysis ({{count}} documents)',
  'analysis.inbox.menu.deleteConfirmTitle': 'Delete analysis',
  'analysis.inbox.menu.deleteConfirmBody_one':
    'This analysis, its stored page images, and the {{count}} source file you uploaded for it will all be permanently deleted. This cannot be undone.',
  'analysis.inbox.menu.deleteConfirmBody_other':
    'This analysis, its stored page images, and all {{count}} source files you uploaded for it will be permanently deleted. This cannot be undone.',
  'analysis.inbox.menu.deleteFailed': 'The analysis could not be deleted. Please try again.',
  'analysis.inbox.menu.deleteBlockedTitle': 'Approved documents exist',
  'analysis.inbox.menu.deleteBlockedBody':
    'This analysis has at least one approved document; approvals are permanent compliance decisions and cannot be deleted. The analysis will be archived instead.',
  // Undoing a rejected item (§20.4 restore) — the opposite of `analysis.item.reject`.
  'analysis.item.restore': 'Undo',
  'analysis.item.restoreAria': 'Undo rejection of {{title}}',
  'analysis.item.restoreFailed': 'Could not undo. Please try again.',

  // My personnel (§13.6)
  'personnel.title': 'My personnel',
  'personnel.subtitle':
    'Personnel linked to your company. You can create new personnel and optionally send them a link to activate their account.',
  'personnel.empty': 'No personnel linked to your company yet.',
  'personnel.col.name': 'Full name',
  'personnel.col.contact': 'Email / phone',
  'personnel.col.status': 'Status',
  'personnel.col.access': 'Access',
  'personnel.col.date': 'Date',
  // Status badges (active personnel + pending invitations — §13.3/§13.6)
  'personnel.status.active': 'Active',
  'personnel.status.inactive': 'Inactive',
  'personnel.status.pending': 'Pending',
  'personnel.status.expired': 'Expired',
  // Personnel with no login (§13.3, S25-A7c) — created without an invitation, no credentials yet.
  'personnel.status.notactivated': 'Not activated',
  'personnel.createAction': 'Create personnel',
  // Access level (§13.3)
  'personnel.access.personeli': 'Staff',
  'personnel.access.yetkili': 'Manager',
  // Row action — jump to the personnel profile (S26, `/personnel/:userUuid`)

  // Shared form labels: optional field, discard-changes confirmation
  'personnel.invite.optional': 'optional',
  'drawer.discard.title': 'Close without saving?',
  'drawer.discard.body':
    'The form contains unsaved information. If you close this panel, what you entered will not be saved.',
  'drawer.discard.cancel': 'Go back',
  'drawer.discard.confirm': 'Close without saving',

  // Row ⋮ menu
  'personnel.action.openMenu': 'Actions for {{name}}',

  // Personnel profile (§13.6 NEW, S26 — /personnel/:userUuid, single GET/PUT/DELETE endpoints)
  'personnel.detail.field.activatedAt': 'Activation date',
  'personnel.detail.field.createdAt': 'Registration date',
  'personnelForm.tc.show': 'Show',
  'personnelForm.tc.hide': 'Hide',
  'personnelForm.field.phone': 'Phone',
  'personnelForm.field.email': 'Email',
  'personnelForm.field.tcKimlikNo': 'T.C. kimlik number',
  'personnelForm.masked.notice':
    "Personal information is partly hidden because you don't have the “Personal data” permission.",
  // Shared personnel edit form (#29) — same keys as EP.
  'personnelForm.edit.action': 'Edit',
  'personnelForm.edit.title': 'Edit personnel',
  'personnelForm.field.firstName': 'First name',
  'personnelForm.field.lastName': 'Last name',
  'personnelForm.field.tcKimlikNoHint':
    'Must be 11 digits with a valid checksum; can only be entered once.',
  'personnelForm.field.accessLevel': 'Access level',
  'personnelForm.access.personeli': 'Staff',
  'personnelForm.access.yetkili': 'Manager',
  'personnelForm.field.accessHint':
    'A Manager can add personnel and upload company documents from the web portal; Staff only see their own data in the mobile app.',
  'personnelForm.field.active': 'Active',
  'personnelForm.field.activeHint': 'Inactive personnel cannot sign in or access sites.',
  'personnelForm.refreshNote':
    'Changes to access level and active/inactive status take effect within 15 minutes at the latest (at the next session refresh).',
  'personnelForm.lock.tcSetOnce':
    'Once entered, the T.C. kimlik number cannot be changed from this screen. Contact support if a change is needed.',
  'personnelForm.lock.tcNoPermission':
    'Only users with the “Personal data” permission can enter the T.C. kimlik number.',
  'personnelForm.lock.contact':
    "Phone and email are verified and saved when the person activates their account; they can't be changed here.",
  'personnelForm.submit': 'Save',
  'personnelForm.saved': 'Information updated.',
  'personnelForm.discardEdit.title': 'Discard changes?',
  'personnelForm.discardEdit.body':
    'If you leave editing, the changes you entered will not be saved.',
  'personnelForm.discardEdit.cancel': 'Go back',
  'personnelForm.discardEdit.confirm': 'Discard changes',
  'personnelForm.validation.firstNameRequired': 'First name is required.',
  'personnelForm.validation.lastNameRequired': 'Last name is required.',
  'personnelForm.validation.firstNameTooLong': 'The first name can be at most {{max}} characters.',
  'personnelForm.validation.lastNameTooLong': 'The last name can be at most {{max}} characters.',
  'personnelForm.validation.tcInvalid':
    'The T.C. kimlik number you entered is invalid. Please check it and try again.',
  'personnelForm.validation.tcExistsFallback':
    'A personnel record with this T.C. kimlik number already exists.',
  'personnelForm.hydrate.loading': 'Loading person record…',
  'personnel.detail.notFound.body':
    "This person is not on your company's personnel list. Please select again from the list.",
  'personnel.detail.selfNoticeBody':
    'You cannot edit your own account or remove yourself from the company here.',
  'personnel.detail.remove.title': 'Remove personnel from your company',
  'personnel.detail.remove.action': 'Remove from company',
  'personnel.detail.remove.body':
    "{{name}} will be removed from your company's personnel list. The person is not deleted — only the company link is removed. Their uploaded documents disappear from both your list and the OHS expert's list. If the person is added to your company again and activates their account, the documents return.",
  'personnel.detail.remove.bodyNotActivated':
    "{{name}} will be removed from your company's personnel list. The person is not deleted — only the company link is removed. Their uploaded documents disappear from both your list and the OHS expert's list. Because the person never activated their account, adding them again creates a new record; documents such as their EK-2 and criminal record certificate do not come back to it and must be uploaded again.",
  'personnel.detail.noLogin.body':
    'This person has not activated their account yet and cannot sign in to the portal or the mobile app. Their documents can still be uploaded.',

  // Mobile app / download (§26 app-store links)
  'layout.mobileApp': 'Mobile app',
  'mobileApp.title': 'Mobile app',
  'mobileApp.subtitle':
    'Download the İSG Portal mobile app so your field personnel can reach their documents and notifications from their phones.',
  'appDownload.storesTitle': 'Download from the stores',
  'appDownload.title': 'Download the mobile app',
  'appDownload.personnelBody':
    'Your account is used through the mobile app. Download the app to your phone to continue.',
  'appDownload.signedInAs': 'Signed in as {{name}}',
  'appDownload.ios': 'Download on the App Store',
  'appDownload.android': 'Get it on Google Play',
  'appDownload.comingSoon.body':
    'The mobile app will be available in the stores soon. The download links will appear here once they are ready.',
  'appDownload.loading': 'Loading app information…',
  'dashboard.app.title': 'Mobile app',
  'dashboard.app.body':
    'Your field personnel can reach their documents and notifications from the mobile app.',

  // Invite delivery-channel error codes (§5.10.1/§5.10.4) — local fallback (backend pack overrides).
  NO_CONTACT:
    'This invitation has no email address or phone number, so it cannot be resent. Add the person with a new invitation.',
  INVITE_CHANNEL_UNAVAILABLE:
    "The selected delivery channel cannot be used with this invitation's contact details. Please choose a channel that matches the email address or phone number on the invitation.",
  ACTIVATION_LINK_COOLDOWN:
    'An activation link was just sent to this contact detail. Please wait a little and try again.',
  'personnelCreate.title': 'Create personnel',
  'personnelCreate.description':
    'Add the person; you can also send them a link to activate their account.',
  'personnelCreate.submit': 'Create',
  'personnelCreate.another': 'Create another',
  'personnelCreate.contact.title': 'Activation link (optional)',
  'personnelCreate.contact.hint':
    "If you enter an email or phone, the person receives a link to activate their account. This is not saved on the person's record.",
  'personnelCreate.success.created': 'Personnel created.',
  'personnelCreate.success.linkSent': 'Personnel created. The activation link is ready.',
  'personnelCreate.validation.tcRequired': 'The T.C. kimlik number is required.',
  'personnelCreate.cooldownUntil':
    'A link was sent to this contact a moment ago. Try again from {{availableAt}}, or clear the contact fields and create the person now; you can send the link later.',
  'personnelCreate.cooldownGeneric':
    'A link was sent to this contact a moment ago. Wait a little and try again, or clear the contact fields and create the person now; you can send the link later.',
  'personnelCreate.dailyLimit':
    'Your company has reached its daily limit for sending links. Clear the contact fields and create the person now; you can send the link later.',
  'personnelLink.cooldownUntil':
    'An activation link was just sent to this person or this contact detail. You can try again from {{availableAt}}.',
  'personnelLink.field.email': 'Email',
  'personnelLink.field.emailPlaceholder': 'name@company.com',
  'personnelLink.field.phone': 'Phone',
  'personnelLink.field.phonePlaceholder': '+90 555 123 45 67',
  'personnelLink.field.phoneHint':
    'Mobile number. For numbers outside Türkiye, include + and the country code.',
  'personnelLink.field.channel': 'Delivery channel',
  'personnelLink.field.channelHint':
    'The activation link is sent automatically via the channel you choose; it also stays on screen.',
  'personnelLink.channel.email': 'Email',
  'personnelLink.channel.sms': 'SMS',
  'personnelLink.channel.both': 'Email and SMS',
  'personnelLink.field.link': 'Activation link',
  'personnelLink.copy': 'Copy',
  'personnelLink.copied': 'Copied',
  'personnelLink.copyFailed': 'Could not copy the link. Please select and copy it manually.',
  'personnelLink.expiresAt': 'The link is valid until {{date}}.',
  'personnelLink.dispatch.emailSent': 'The activation link was sent by email.',
  'personnelLink.dispatch.smsSent': 'The activation link was sent by SMS.',
  'personnelLink.dispatch.emailFailed':
    'The activation link could not be sent by email. Copy the link and share it with the person.',
  'personnelLink.dispatch.smsFailed':
    'The activation link could not be sent by SMS. Copy the link and share it with the person.',
  'personnelLink.dispatch.none':
    'Automatic delivery could not be completed. Please copy the link below and share it with the person.',
  'personnelLink.validation.contactRequired': 'Email or phone is required.',
  'personnelLink.validation.emailInvalid': 'Enter a valid email address.',
  'personnelLink.validation.phoneInvalid':
    'Enter a valid mobile number. For numbers outside Türkiye, include + and the country code.',
  'personnelLink.validation.emailTaken':
    'An activation link cannot be sent to this email address. Try another email address or phone number.',
  'personnelLink.validation.phoneTaken':
    'An activation link cannot be sent to this phone number. Try another phone number or email address.',
  'personnelLink.validation.contactTaken':
    'An activation link cannot be sent to the contact you entered. Try another email address or phone number.',
  'personnelLink.pending.sent': 'Sent',
  'personnelLink.pending.expired': 'Expired',
  'personnelLink.action.send': 'Send activation link',
  'personnelLink.action.resend': 'Resend link',
  'personnelLink.action.cancel': 'Cancel link',
  'personnelLink.cancel.title': 'Cancel link',
  'personnelLink.cancel.body.person':
    'The activation link sent for {{name}} is cancelled; the person can no longer use it to activate their account and stays in the list as “Not activated”.',
  'personnelLink.notFound':
    "This link is no longer valid; it may have been resent or cancelled in the meantime, or the person may have activated their account. The list has been refreshed; close this window and check the person's current status.",
  'personnelLink.cancel.body.invite':
    'The activation link sent for {{name}} is cancelled; the person can no longer use it to activate their account. This row is removed from the list.',
  'personnelLink.cancel.confirm': 'Cancel link',
  'personnelLink.send.title': 'Send activation link',
  'personnelLink.send.description':
    "Send an activation link for {{name}}. It goes only to the email address or phone number you enter; this contact is not saved on the person's record.",
  'personnelLink.send.tcMissing':
    "This person's record has no T.C. kimlik number. It must be added to the record before an activation link can be sent.",
  'personnelLink.send.contactHint':
    'Enter at least an email or a phone number; you can enter both.',
  'personnelLink.send.submit': 'Send',
  'personnelLink.resend.title': 'Resend link',
  'personnelLink.resend.description':
    'A new activation link is created and sent for {{name}}. The previous link stops working.',
  'personnelLink.resend.channelHint':
    'The new link is sent via the channel you choose and stays here so you can copy it.',
  'personnelLink.resend.via.email': 'The new link will be sent by email.',
  'personnelLink.resend.via.sms': 'The new link will be sent by SMS.',
  'personnelLink.resend.submit': 'Resend',
  'personnelLink.resend.noContact':
    'There is no email or phone on record for this link, so it cannot be resent.',
  'personnelLink.success.title': 'Activation link ready',
  'personnelLink.success.body':
    'The delivery status is below. You can also copy the link and pass it to the person yourself.',
  ACTIVATION_LINK_DAILY_LIMIT:
    'The daily limit for sending links has been reached. Please try again later.',
  PERSONNEL_INACTIVE:
    'An activation link cannot be sent to inactive personnel. Set the person to Active first.',
  PERSONNEL_TC_REQUIRED:
    "The person's record has no T.C. kimlik number. Until it is added to the record, no activation link can be sent and activation cannot be completed.",
  GUEST_INVITE_CONTACT_ALREADY_EXISTS:
    'This email address or phone number is already registered to another account; the invitation cannot be completed with these contact details.',
  PERSONNEL_ALREADY_HAS_LOGIN:
    'This person already has an account; a new invitation cannot be sent.',

  // Create personnel without an invitation (§13.6 POST /supplier/contractor/personnel, S25 C9) —
  // SEPARATE from the old invite flow: no invitation, the record exists immediately
  // (`status: NoLogin`).
  'personnel.create.title': 'Create new personnel',
  'personnel.create.description':
    'The person is added to your personnel immediately and can be selected when approving documents. You can send them an activation link later from My personnel so they can activate their account; this requires a T.C. kimlik number on their record.',
  'personnel.create.submit': 'Create',
  'personnel.create.field.firstName': 'First name',
  'personnel.create.field.lastName': 'Last name',
  'personnel.create.field.tcKimlikNo': 'T.C. kimlik number',
  'personnel.create.field.tcKimlikNoHint': 'Must be 11 digits with a valid checksum.',
  'personnel.create.validation.firstNameRequired': 'First name is required.',
  'personnel.create.validation.lastNameRequired': 'Last name is required.',
  'personnel.create.validation.tcInvalid':
    'The T.C. kimlik number you entered is invalid. Please check it and try again.',
  'personnel.create.tcExistsFallback':
    'A personnel record with this T.C. kimlik number already exists.',

  // Personnel documents (§15.2 path B + §8; data protection)
  'personnelDrawer.analysis.hint':
    "When the result is ready, you'll be notified here to approve it.",
  'personnelDocs.title': 'Documents',
  'personnelDocs.kvkk':
    'These documents contain personal data. Upload only the required paperwork; access is limited to business purposes.',
  'personnelDocs.add': 'Upload document',
  'personnelDocs.empty': 'No documents uploaded for this person yet.',
  'personnelDocs.col.document': 'Document',
  'personnelDocs.col.approval': 'Approval status',
  'personnelDocs.rejectionReason': 'Rejection reason: {{reason}}',
  'personnelDocs.add.title': 'Upload personnel document',
  'personnelDocs.add.description':
    'Select the file, its type and validity dates. The file is uploaded directly to secure storage.',
  'personnelDocs.add.submit': 'Upload and add',
  'personnelDocs.add.uploading': 'Uploading…',
  'personnelDocs.add.progress': 'Uploading: {{percent}}%',
  'personnelDocs.field.file': 'Document file',
  'personnelDocs.field.filePlaceholder': 'Select a file (PDF, image or office document)',
  'personnelDocs.field.fileHint': 'Up to 20 MB. PDF, image (PNG/JPG) or office document.',
  'personnelDocs.field.type': 'Document type',
  'personnelDocs.field.validFrom': 'Valid from',
  'personnelDocs.field.validUntil': 'Valid until',
  'personnelDocs.field.note': 'Note (optional)',
  'personnelDocs.delete.title': 'Remove document',
  'personnelDocs.delete.body': 'Are you sure you want to remove the {{type}} document?',
  'personnelDocs.delete.confirm': 'Remove document',

  // supplier-contractor access gate (two-tier authz — Staff cannot see it)
  'access.loading': 'Checking access…',
  'access.forbidden.title': 'You do not have access to this section',
  'access.forbidden.body':
    'Personnel management is available to contractor managers only. Please contact your company admin for access.',
  'access.forbidden.back': 'Back to dashboard',
  'access.unavailable.title': 'This section is currently unavailable',
  'access.unavailable.body': 'Access information could not be retrieved. Please try again.',
  'access.unavailable.retry': 'Try again',

  // State screens (no bond / no access / generic error)
  'state.noContractor.title': 'No company assignment found',
  'state.noContractor.body':
    'No subcontractor company is linked to your account in the active company. If you belong to multiple companies, pick the right one from the switcher above; otherwise contact your company admin.',
  'state.noAccess.title': 'You do not have access to this company',
  'state.noAccess.body':
    'You have no access assignment to the selected company. Pick a company you can access from the switcher above, or contact your company admin.',
  'state.error.title': 'Could not load information',
  'state.error.body': 'Something went wrong. Please try again.',
  'state.error.retry': 'Try again',

  'validation.identifierRequired': 'Email or phone is required.',
  'validation.passwordRequired': 'Password is required.',
  'validation.codeRequired': 'Verification code is required.',
  'validation.passwordPolicy': 'Password must be at least 8 characters with a letter and a digit.',

  'error.generic': 'An unexpected error occurred. Please try again.',
  NETWORK_ERROR: 'Could not reach the server. Check your connection and try again.',
  INVALID_CREDENTIALS: 'Email/phone or password is incorrect.',
  VALIDATION_FAILED: 'Please check the fields.',
  UNAUTHORIZED: 'Your session could not be verified. Please sign in again.',
  PASSWORD_POLICY_ERROR: 'Password must be at least 8 characters with a letter and a digit.',
  CODE_INVALID: 'The verification code is incorrect or used. Request a new code.',
  CODE_EXPIRED: 'The verification code has expired. Request a new code.',
  CODE_TOO_FREQUENT: 'You requested codes too often. Please wait and try again.',
  SUPPLIER_NO_COMPANY:
    'Your account is not linked to a company yet. Please contact your company admin.',
  SUPPLIER_INACTIVE: 'Your account is inactive. Please contact your company admin.',
  COMPANY_NOT_ACCESSIBLE:
    'You do not have access to this company. Please contact your company admin.',
  GUEST_INVITE_INVALID:
    'This activation link is invalid or has already been used. If you have already activated your account with it, sign in; otherwise, ask the company that added you for a new link.',
  GUEST_INVITE_EXPIRED:
    'This activation link has expired. Please ask the company that added you for a new link.',

  // Document upload / contractor (§8 + §13.6) error codes — local fallback (backend pack overrides).
  DOCUMENT_TOO_LARGE: 'The file exceeds the allowed size limit (up to 20 MB).',
  DOCUMENT_TYPE_UNSUPPORTED:
    'This file type is not supported. Upload a PDF, image or office document.',
  DOCUMENT_UPLOAD_FAILED: 'The file could not be uploaded. Please try again.',
  DOCUMENT_UPLOAD_ABORTED: 'The file upload was cancelled.',
  DOCUMENT_NOT_UPLOADED: 'The upload did not complete. Please upload the file again.',
  DOCUMENT_NOT_FOUND: 'The document you are looking for was not found.',
  CONTRACTOR_NOT_FOUND: 'Your account is not linked to a contractor in this company.',
  CONTRACTOR_DOCUMENT_NOT_FOUND: 'The document was not found or has been removed.',
  // Document analysis (§20 — S17) error codes — local fallback (backend pack overrides).
  DOCUMENT_ANALYSIS_NOT_FOUND: 'The document analysis you are looking for was not found.',
  DOCUMENT_ANALYSIS_IN_PROGRESS:
    'A document analysis is currently in progress. Wait for the current analysis to finish before starting a new one.',
  DOCUMENT_ANALYSIS_QUOTA_EXCEEDED:
    "Today's document analysis quota has been used up. It resets tomorrow.",
  DOCUMENT_ANALYSIS_NOT_ENABLED: 'Document analysis is not enabled for this company.',
  DOCUMENT_ANALYSIS_UNAVAILABLE: 'Document analysis is currently unavailable in this environment.',
  // Document analysis accept (§20.2 — S19) error codes — local fallback.
  DOCUMENT_ANALYSIS_NOT_COMPLETE: 'This analysis has not finished yet; it cannot be approved now.',
  DOCUMENT_ANALYSIS_ITEM_NOT_FOUND:
    'No such document item was found in this analysis. Refresh the page and try again.',
  // Item reject + analysis discard (§20.4, S24) error codes — local fallback.
  DOCUMENT_ANALYSIS_ITEM_ALREADY_ACCEPTED:
    'This item has already been approved and filed; it can no longer be rejected. Refresh the page.',
  DOCUMENT_ANALYSIS_NOT_TERMINAL:
    'This analysis has not finished yet; this action cannot be performed now.',
  DOCUMENT_ANALYSIS_ARTIFACT_MISSING:
    "This document's stored copy could not be found, so it was not filed. Please upload the document again.",
  DOCUMENT_ANALYSIS_ARTIFACT_COPY_FAILED: 'The document could not be copied. Please try again.',
  // Personnel document (§15) error codes — local fallback (backend pack overrides).
  PERSONNEL_NOT_FOUND: 'Personnel not found or not linked to your company.',
  PERSONNEL_DOCUMENT_NOT_FOUND: 'The document was not found or has been removed.',
  PERSONNEL_DOCUMENT_NOT_PENDING:
    'This document has already been reviewed and can no longer be deleted. Upload a replacement, or ask the client company or the OHS expert to remove it.',

  // Work permits (Supplier — §21). Read-only permit info + assigning own personnel + readiness.
  'layout.permits': 'Work permits',
  'permits.title': 'Work permits',
  'permits.list.subtitle':
    'View the work permits opened for your company, assign your own personnel, and track their training readiness.',
  'permits.list.search': 'Search permits',
  'permits.list.searchPlaceholder': 'Search by title',
  'permits.list.filter.status': 'Status',
  'permits.list.filter.allStatuses': 'All statuses',
  'permits.list.col.permitType': 'Permit type',
  'permits.list.col.title': 'Title',
  'permits.list.col.sites': 'Sites',
  'permits.list.sitesMore': '+{{count}}',
  'permits.list.col.validity': 'Validity',
  'permits.list.col.status': 'Status',
  'permits.list.col.readiness': 'Ready personnel',
  'permits.list.count': 'Showing {{count}} permits',
  'permits.list.empty': 'No work permits to display.',
  'permits.pagination.nav': 'Pagination',
  'permits.pagination.previous': 'Previous',
  'permits.pagination.next': 'Next',
  'permits.readiness.summary': '{{ready}} / {{total}} ready',
  'permits.readiness.personnelOnly': '{{total}} personnel',
  'permits.readiness.noPersonnel': 'No personnel',
  'permits.status.Draft': 'Draft',
  'permits.status.Submitted': 'Awaiting approval',
  'permits.status.Approved': 'Approved',
  'permits.status.Active': 'Active',
  'permits.status.Rejected': 'Rejected',
  'permits.status.Expired': 'Expired',
  'permits.status.Closed': 'Closed',
  'permits.status.AwaitingSupplierInfo': 'Awaiting your input',
  'permits.status.AwaitingAiReview': 'In automatic review',
  'permits.status.Revision': 'Revision requested',
  'permits.status.DepartmentReview': 'In department review',
  'permits.status.AwaitingEntryPermit': 'Awaiting entry permit',
  'permits.list.noResults': 'No work permits match your filters.',
  'personnel.list.count': '{{count}} personnel listed',
  'documents.list.count': '{{count}} documents listed',
  'common.clearFilters': 'Clear filters',
  'common.noResults.body': 'Try changing or clearing your search and filters.',
  'permits.detail.back': 'Back to work permits',
  'permits.detail.loading': 'Loading permit…',
  'permits.detail.readOnlyNote':
    'Permit details are managed by the OHS expert. You can only assign or remove your own personnel.',
  'permits.detail.field.sites': 'Sites',
  'permits.detail.field.validityStart': 'Validity start',
  'permits.detail.field.validityEnd': 'Validity end',
  'permits.detail.field.createdAt': 'Created',
  'permits.detail.section.details': 'Details',
  'permits.detail.section.requirements': 'Requirements',
  'permits.detail.section.personnel': 'Covered personnel',
  'permits.detail.section.trainings': 'Required trainings',
  'permits.detail.requiredDocuments': 'Required documents',
  'permits.detail.requiredDocumentsEmpty': 'No documents required for this permit type.',
  'permits.trainings.empty': 'No required trainings are defined for this permit.',
  'permits.detail.protectiveEquipment': 'Required PPE',
  'permits.detail.protectiveEquipmentHint':
    'Personal protective equipment required by the permit type; you provide this equipment on site.',
  'permits.detail.protectiveEquipmentEmpty': 'No PPE is required for this permit type.',
  'permits.detail.protectiveEquipmentMinimumNotice':
    'The personal protective equipment listed above is the minimum requirement. Please also keep any additional protective equipment that your work and your safety require.',
  'permits.personnel.add': 'Assign personnel',
  'permits.personnel.col.name': 'Name',
  'permits.personnel.col.training': 'Training',
  'permits.personnel.col.documents': 'Documents',
  'permits.personnel.col.readiness': 'Readiness',
  'permits.personnel.requiredDocuments': 'Required personnel documents',
  'permits.personnel.requiredDocumentsEmpty': 'This permit type requires no personnel documents.',
  'permits.personnel.ready': 'Ready',
  'permits.personnel.notReady': 'Incomplete',
  'permits.personnel.missingDocuments': 'Missing documents',
  'permits.personnel.empty': 'No personnel assigned to this permit yet.',
  'permits.personnel.action.remove': 'Remove personnel',
  'permits.personnel.action.openMenu': 'Actions for {{name}}',
  'permits.personnel.remove.title': 'Remove personnel',
  'permits.personnel.remove.body': 'Are you sure you want to remove {{name}} from this permit?',
  'permits.personnel.remove.confirm': 'Remove personnel',
  'permits.personnel.add.title': 'Assign personnel to permit',
  'permits.personnel.add.description':
    'Select one or more people from your own personnel to assign to this permit. People who have not activated their account yet can also be assigned.',
  'permits.personnel.add.submit': 'Assign',
  'permits.personnel.add.empty':
    'There is no suitable personnel to assign. You can create new personnel below.',
  'permits.personnel.add.createNew': 'Create new personnel',
  'permits.personnel.notActivated': 'Not activated',
  'permits.personnel.notActivated.hint':
    "The person cannot complete this permit's required trainings until they activate their account. Activation links are sent from My personnel.",
  // Work permit — Vehicles (§23.2; subcontractor Authorized user adds vehicles + uploads/deletes vehicle documents, OHS specialist approves)
  'permits.vehicles.section': 'Vehicles',
  'permits.detail.tab.personnel': 'Personnel',
  'permits.detail.tabs.label': 'Permit sections',
  'permits.detail.tab.personnelIncomplete_one': '{{count}} person incomplete',
  'permits.detail.tab.personnelIncomplete_other': '{{count}} people incomplete',
  'permits.detail.tab.vehiclesIncomplete_one': '{{count}} vehicle incomplete',
  'permits.detail.tab.vehiclesIncomplete_other': '{{count}} vehicles incomplete',
  'permits.vehicles.add': 'Add vehicle',
  'permits.vehicles.requiredDocuments': 'Required vehicle documents',
  'permits.vehicles.requiredDocumentsEmpty': 'This permit type requires no vehicle documents.',
  'permits.vehicles.empty': 'No vehicle has been added to this permit yet.',
  'permits.vehicles.ready': 'Ready',
  'permits.vehicles.notReady': 'Incomplete',
  'permits.vehicles.missingDocuments': 'Missing vehicle documents',
  'permits.vehicles.upload.title': 'Upload vehicle document',
  'permits.vehicles.upload.description':
    'Upload a document for the vehicle with plate {{plate}}. It is sent for OHS specialist approval.',
  'permits.vehicles.upload.chooseFile': 'Choose file',
  'permits.vehicles.upload.submit': 'Upload',
  'permits.vehicles.docs.col.type': 'Document type',
  'permits.vehicles.docs.col.approval': 'Approval status',
  'permits.vehicles.docs.rejectionReason': 'Rejection reason: {{reason}}',
  'permits.vehicles.docs.action.download': 'Download document',
  'permits.vehicles.docs.action.delete': 'Delete document',
  'permits.vehicles.docs.delete.title': 'Delete document',
  'permits.vehicles.docs.delete.body':
    'Delete the "{{type}}" document? It will also disappear from every permit the vehicle is on.',
  'permits.vehicles.docs.delete.confirm': 'Delete',
  'permits.docApproval.pending': 'Pending approval',
  'permits.docApproval.approved': 'Approved',
  'permits.docApproval.rejected': 'Rejected',
  'vehicles.docStatus.allApproved': 'All approved',
  'vehicles.docStatus.none': 'No documents',
  'vehicles.docStatus.missingEnd': 'No end date',
  'vehicles.openPermits.yes': 'On an open permit',
  'vehicles.sheet.docs.title': 'Vehicle documents',
  'vehicles.sheet.docs.upload': 'Upload document',
  'vehicles.sheet.docs.empty': 'No documents added to this vehicle yet.',
  'vehicles.sheet.docs.note':
    'Documents are kept with the vehicle; an approval counts on every permit the vehicle is added to.',
  'vehicles.sheet.plateLocked': 'Plate locked',
  'vehicles.upload.noteTooLong': 'The note can be at most {{max}} characters.',
  'vehicles.validation.plateInvalid':
    'The plate is invalid: it can have at most {{max}} characters and at most {{keyMax}} letters and digits, and no invisible characters. Retype the plate by hand.',
  'vehicles.title': 'Vehicles',
  'vehicles.subtitle':
    "Your company's vehicles. A document is approved once and counts on every permit the vehicle is added to.",
  'vehicles.add': 'Add vehicle',
  'vehicles.list.count_one': '{{count}} vehicle listed',
  'vehicles.list.count_other': '{{count}} vehicles listed',
  'vehicles.empty': 'No vehicles have been added yet.',
  'vehicles.col.plate': 'Plate',
  'vehicles.col.description': 'Description',
  'vehicles.col.documents': 'Documents',
  'vehicles.col.docStatus': 'Document status',
  'vehicles.col.openPermits': 'Open permit',
  'vehicles.action.openMenu': 'Actions for vehicle {{plate}}',
  'vehicles.action.upload': 'Upload document',
  'vehicles.action.edit': 'Edit',
  'vehicles.action.delete': 'Delete',
  'vehicles.action.deleteBlocked': 'Delete (remove from open permits first)',
  'vehicles.action.deleteBlockedApproved': 'Delete (has an approved document)',
  'vehicles.delete.title': 'Delete vehicle',
  'vehicles.delete.body':
    'Delete vehicle {{plate}} and its documents? Past permits will still show the plate.',
  'vehicles.delete.confirm': 'Delete',
  'vehicles.form.edit.title': 'Edit vehicle',
  'vehicles.form.edit.description': 'Changes apply on every permit the vehicle is on.',
  'vehicles.form.create.description': "Add a new vehicle to your company's vehicle list.",
  'vehicles.form.submit.edit': 'Save',
  'vehicles.form.submit.create': 'Add',
  'vehicles.form.field.plate': 'Plate',
  'vehicles.form.field.description': 'Description',
  'vehicles.form.platePlaceholder': 'e.g. 34 ABC 123',
  'vehicles.form.plateLocked':
    'The plate can no longer be changed: the vehicle has been added to a permit or one of its documents has been approved. To use a different plate, add a new vehicle.',
  'vehicles.permitAdd.title': 'Add vehicle',
  'vehicles.permitAdd.description':
    "Pick from your company's vehicles or enter a new plate. A new plate is also added to your vehicle list.",
  'vehicles.permitAdd.submit': 'Add',
  'vehicles.permitAdd.registered': 'Registered vehicles',
  'vehicles.permitAdd.registeredEmpty': 'No registered vehicles available to add to the permit.',
  'vehicles.permitAdd.newVehicle': 'New vehicle',
  'vehicles.permitAdd.plateOnPermit': 'This vehicle is already on the permit.',
  'vehicles.permitAdd.plateExisting':
    'This plate is already in the list; the existing vehicle will be added to the permit.',
  'vehicles.permitAdd.plateNew': 'New vehicle; it will also be added to the vehicle list.',
  'vehicles.permitAdd.partialFailure': 'Vehicle {{plate}} could not be added.',
  'vehicles.unlink.action': 'Remove from permit',
  'vehicles.unlink.title': 'Remove vehicle from permit',
  'vehicles.unlink.body':
    'Remove vehicle {{plate}} from this permit? The vehicle and its documents stay in the vehicle list.',
  'vehicles.unlink.confirm': 'Remove',
  'permits.vehicles.col.readiness': 'Readiness',
  'vehicles.validation.plateRequired': 'The plate is required.',
  'vehicles.validation.plateTooLong': 'The plate can be at most {{max}} characters.',
  'vehicles.validation.plateKeyTooLong':
    'The plate can contain at most {{max}} letters and digits.',
  'vehicles.validation.descriptionTooLong': 'The description can be at most {{max}} characters.',
  VEHICLE_NOT_FOUND: 'Vehicle not found; it may have been deleted or removed from the permit.',
  VEHICLE_DOCUMENT_NOT_FOUND: 'This vehicle document could not be found or no longer exists.',
  VEHICLE_PLATE_ALREADY_EXISTS:
    'A vehicle with this plate is already registered (spaces and punctuation are ignored). Use the existing vehicle in the list.',
  VEHICLE_PLATE_LOCKED:
    "This vehicle's plate can no longer be changed: the vehicle has been added to a permit or one of its documents has been approved. To use a different plate, add a new vehicle.",
  VEHICLE_HAS_OPEN_PERMITS:
    'This vehicle is on an open permit and cannot be deleted. Remove it from its open permits first.',
  VEHICLE_HAS_LOCKED_DOCUMENTS:
    'This vehicle cannot be deleted: it has an approved document, or one of its documents is in use (site entry was granted while it was on file, or the vehicle is on an active permit). The vehicle stays in the list; for a different vehicle, add a new one.',
  VEHICLE_DOCUMENT_NOT_PENDING:
    'This document has already been reviewed and can no longer be deleted. Upload a replacement instead.',
  VEHICLE_DOCUMENT_IN_USE:
    'This document is in use and cannot be deleted: site entry was granted to the vehicle while it was on file, or the vehicle is on an active permit. If the document is wrong, reject it; to update it, upload a new one.',
  PERMIT_NOT_FOUND: 'Work permit not found or not owned by your company.',
};

const de: Record<keyof typeof tr, string> = {
  'pagination.summary': '{{from}}–{{to}} von {{total}}',
  'pagination.summaryEmpty': '0 Einträge',
  'app.name': 'İSG Portal',
  'app.supplierPortal': 'Nachunternehmer-Portal',
  'app.tagline':
    'Arbeitssicherheit und Gesundheitsschutz Ihres Nachunternehmens an einem Ort verwalten.',

  'login.title': 'Beim Nachunternehmer-Portal anmelden',
  'login.subtitle': 'Geben Sie E-Mail oder Telefon und Passwort ein, um auf Ihr Konto zuzugreifen.',
  'login.identifier': 'E-Mail oder Telefon',
  'login.identifierPlaceholder': 'name@firma.com oder +90 555 123 45 67',
  'login.password': 'Passwort',
  'login.submit': 'Anmelden',
  'login.forgotPassword': 'Passwort vergessen',

  'selectWorkspace.title': 'Unternehmen auswählen',
  'selectWorkspace.subtitle':
    'Sie sind mit mehreren Unternehmen verknüpft. Wählen Sie eines aus, um fortzufahren.',
  'selectWorkspace.continue': 'Mit Unternehmen fortfahren',
  'selectWorkspace.backToLogin': 'Zurück zur Anmeldung',
  'selectWorkspace.expired':
    'Ihre Unternehmensauswahl ist abgelaufen oder die Sitzung wurde nicht gefunden. Bitte melden Sie sich erneut an.',

  'switcher.label': 'Aktives Unternehmen',
  'switcher.change': 'Unternehmen wechseln',
  'switcher.switching': 'Unternehmen wird gewechselt…',
  'switcher.noAccess':
    'Sie haben keinen Zugriff auf dieses Unternehmen. Bitte wenden Sie sich an Ihren Unternehmensadministrator.',
  'switcher.menu.heading': 'Kunden',
  'switcher.menu.fanoutCap': '{{shown}} / {{total}} Unternehmen zusammengefasst',
  'switcher.menu.footer': 'Der Wechsel verschiebt das gesamte Panel zum ausgewählten Kunden.',
  'switcher.badge.ariaLabel_one': '{{count}} Kunde benötigt Aufmerksamkeit',
  'switcher.badge.ariaLabel_other': '{{count}} Kunden benötigen Aufmerksamkeit',
  'switcher.summary.loading': 'Zahlen werden geladen…',
  'switcher.activeNote': 'Sie sind hier',
  'switcher.state.blocked': 'Heute blockiert',
  'switcher.state.atRisk': 'Diese Woche fällig',
  'switcher.row.clean': 'frei',
  'switcher.row.unavailable': 'Momentan nicht ladbar',
  'switcher.row.goToPanel': 'Zum Panel',

  'guest.title': 'Konto aktivieren',
  'guest.subtitle':
    'Schließen Sie die folgenden Schritte ab, um dem Unternehmen beizutreten, das Sie hinzugefügt hat.',
  'guest.intro':
    'Starten Sie die Aktivierung, um einen Bestätigungscode zu erhalten; aktivieren Sie dann Ihr Konto mit dem Code, Ihrer T.C.-Kimlik-Nummer und einem neuen Passwort.',
  'guest.start': 'Aktivierung starten',
  'guest.sentTo': 'Wir haben einen Bestätigungscode an {{target}} gesendet.',
  'guest.sentToEach':
    'Wir haben an jede Ihrer Kontaktangaben einen eigenen Bestätigungscode gesendet: {{target}}. Sie melden sich mit der Kontaktangabe an, deren Code Sie eingeben.',
  'guest.code': 'Bestätigungscode',
  'guest.newPassword': 'Neues Passwort',
  'guest.passwordHint': 'Mindestens 8 Zeichen, davon ein Buchstabe und eine Ziffer.',
  'guest.activate': 'Konto aktivieren',
  'guest.resend': 'Code erneut senden',
  'guest.invalidLink':
    'Der Aktivierungslink ist ungültig oder fehlt. Bitte überprüfen Sie den erhaltenen Link.',
  'guest.tc': 'T.C.-Kimlik-Nummer',
  'guest.tcHint':
    'Geben Sie Ihre 11-stellige T.C.-Kimlik-Nummer ein, um Ihr Konto zu aktivieren. Sie muss mit der Nummer übereinstimmen, die von dem Unternehmen hinterlegt wurde, das Sie hinzugefügt hat.',
  'guest.validation.tcRequired': 'Die T.C.-Kimlik-Nummer ist erforderlich.',
  'guest.tcRequired':
    'Ihr Konto kann derzeit nicht aktiviert werden; in den Unterlagen des Unternehmens fehlt Ihre T.C.-Kimlik-Nummer. Bitte wenden Sie sich an das Unternehmen, das Sie hinzugefügt hat; Ihr Link bleibt gültig.',
  'guest.tcAlreadyExists':
    'Ihr Konto kann derzeit nicht aktiviert werden; die Unterlagen des Unternehmens müssen korrigiert werden. Bitte wenden Sie sich an das Unternehmen, das Sie hinzugefügt hat; Ihr Link bleibt gültig.',
  'guest.linkDead':
    'Dieser Aktivierungslink kann nicht mehr verwendet werden. Wenn Sie einen neueren Link erhalten haben, verwenden Sie diesen; andernfalls fordern Sie bei dem Unternehmen, das Sie hinzugefügt hat, einen neuen Link an.',
  TC_KIMLIK_MISMATCH:
    'Die T.C.-Kimlik-Nummer stimmt nicht mit den hinterlegten Daten überein. Wenn Sie sie richtig eingegeben haben, wenden Sie sich an das Unternehmen, das Sie hinzugefügt hat.',
  'guest.activatedNote': 'Ihr Konto ist aktiviert; Sie werden zur Übersicht weitergeleitet.',

  'forgot.title': 'Passwort zurücksetzen',
  'forgot.subtitle':
    'Geben Sie die mit Ihrem Konto verknüpfte E-Mail oder Telefonnummer ein; wir senden einen Code.',
  'forgot.identifier': 'E-Mail oder Telefon',
  'forgot.submit': 'Code senden',
  'forgot.backToLogin': 'Zurück zur Anmeldung',

  'reset.title': 'Neues Passwort festlegen',
  'reset.subtitle': 'Geben Sie den erhaltenen Bestätigungscode und Ihr neues Passwort ein.',
  'reset.code': 'Bestätigungscode',
  'reset.newPassword': 'Neues Passwort',
  'reset.passwordHint': 'Mindestens 8 Zeichen, davon ein Buchstabe und eine Ziffer.',
  'reset.submit': 'Passwort aktualisieren',
  'reset.successTitle': 'Ihr Passwort wurde aktualisiert',
  'reset.successBody': 'Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
  'reset.toLogin': 'Zur Anmeldung',

  'layout.dashboard': 'Übersicht',
  'layout.documents': 'Meine Dokumente',
  'layout.personnel': 'Mein Personal',
  'layout.vehicles': 'Fahrzeuge',
  'layout.account': 'Konto',
  'layout.profile': 'Profil',
  'layout.logout': 'Abmelden',
  'layout.nav.primary': 'Hauptnavigation',
  'layout.rail.collapse': 'Menü einklappen',
  'layout.rail.expand': 'Menü ausklappen',
  'layout.skipToContent': 'Zum Inhalt springen',
  'layout.user.menu': 'Benutzermenü',
  'layout.user.signedInAs': 'Angemeldet als',
  'layout.user.company': 'Unternehmen',
  'layout.user.language': 'Sprache',

  // Profil (Self) — api-contract §18.2
  'profile.title': 'Profil',
  'profile.subtitle': 'Sehen Sie Ihre Kontodaten ein und aktualisieren Sie sie.',
  'profile.loading': 'Profil wird geladen...',
  'profile.info.title': 'Kontodaten',
  'profile.info.subtitle': 'Diese Angaben sind schreibgeschützt.',
  'profile.field.fullName': 'Vor- und Nachname',
  'profile.field.firstName': 'Vorname',
  'profile.field.lastName': 'Nachname',
  'profile.field.emailOrPhone': 'E-Mail / Telefon',
  'profile.field.company': 'Unternehmen',
  'profile.edit.title': 'Namen bearbeiten',
  'profile.edit.subtitle': 'Aktualisieren Sie Ihren angezeigten Namen.',
  'profile.edit.save': 'Speichern',
  'profile.updated': 'Profil aktualisiert.',
  'profile.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'profile.validation.lastNameRequired': 'Nachname ist erforderlich.',
  'profile.password.title': 'Passwort ändern',
  'profile.password.subtitle': 'Wählen Sie zu Ihrer Sicherheit ein starkes Passwort.',
  'profile.password.current': 'Aktuelles Passwort',
  'profile.password.new': 'Neues Passwort',
  'profile.password.confirm': 'Neues Passwort (wiederholen)',
  'profile.password.hint': 'Mindestens 8 Zeichen, davon ein Buchstabe und eine Ziffer.',
  'profile.password.save': 'Passwort aktualisieren',
  'profile.password.updated': 'Ihr Passwort wurde aktualisiert.',
  'profile.password.wrongCurrent': 'Das aktuelle Passwort ist falsch.',
  'profile.validation.currentPasswordRequired': 'Aktuelles Passwort ist erforderlich.',
  'profile.validation.confirmRequired': 'Bitte wiederholen Sie das Passwort.',
  'profile.validation.passwordMismatch': 'Die Passwörter stimmen nicht überein.',

  // Allgemein (Schaltflächen/Beschriftungen)
  'common.close': 'Schließen',
  'common.cancel': 'Abbrechen',
  'common.actions': 'Aktionen',
  'common.compactRows': 'Kompakte Zeilen',
  'common.loading': 'Wird geladen…',

  // Übersicht (§28.3 GET /supplier/dashboard) — "was blockiert mich heute bei dieser Firma?"
  'dashboard.title': 'Übersicht',
  'dashboard.subtitle': 'Der Status Ihres Nachunternehmens auf einen Blick.',
  'dashboard.loading': 'Übersicht wird geladen…',
  'dashboard.status.notEntryReady': 'Nicht einsatzbereit',

  // Übersicht — "Fehlende" (§28.3 items; ALLE Positionstypen)
  'dashboard.missing.title': 'Fehlende',
  'dashboard.missing.empty': 'Nichts fehlt.',
  'dashboard.missing.filterEmpty': 'In diesem Filter gibt es nichts.',
  'dashboard.missing.filter.all': 'Alle',
  'dashboard.missing.filter.document': 'Dokument',
  'dashboard.missing.filter.training': 'Schulung',
  'dashboard.missing.filter.groupLabel': 'Positionstyp-Filter',
  'dashboard.missing.companyDocument': 'Firmendokument',
  'dashboard.missing.unknownType': 'Dokument',
  'dashboard.missing.status.missing': 'Fehlt',
  'dashboard.missing.status.expired': 'Abgelaufen',
  'dashboard.missing.status.noValidity': 'Kein Ablaufdatum',
  'dashboard.missing.status.rejected': 'Abgelehnt',
  'dashboard.missing.rejectionReason.label': 'Ablehnungsgrund',
  'dashboard.missing.trainingGeneric': 'Schulung nicht abgeschlossen',
  'dashboard.missing.permitApprovalGeneric':
    'Wartet auf Genehmigung durch den Arbeitsschutzexperten des Kunden',
  'dashboard.missing.showMore': 'Mehr anzeigen',

  // Übersicht — "Standortbereitschaft" (§28.3 counts.personnelReady/personnelBlocked/atRiskThisWeek)
  'dashboard.readiness.title': 'Standortbereitschaft',
  'dashboard.readiness.blocked': 'Heute kein Zutritt',
  'dashboard.readiness.atRisk': 'In 7 Tagen kein Zutritt',
  'dashboard.readiness.clear': 'Diese Woche kein Hindernis',
  'dashboard.readiness.denominator': '{{count}} Personen in offenen Arbeitserlaubnissen',

  // Übersicht — "Aktive Arbeitserlaubnisse" (§28.3 upcomingPermits)
  'dashboard.permits.title': 'Aktive Arbeitserlaubnisse',
  'dashboard.permits.empty': 'Keine offenen Arbeitserlaubnisse.',
  'dashboard.permits.ready': 'Bereit',
  'dashboard.permits.blockedDocuments': 'Dokumente {{ready}}/{{total}}',
  'dashboard.permits.blockedTrainings': 'Schulungen {{ready}}/{{total}}',
  'dashboard.permits.metrics.personnelLabel': 'Zugewiesenes Personal',
  'dashboard.permits.metrics.documentsLabel': 'Personal, das die Dokumentenanforderung erfüllt',
  'dashboard.permits.metrics.trainingsLabel': 'Personal, das die Schulung abgeschlossen hat',
  'dashboard.permits.metrics.complianceLabel': 'Konformität',
  'dashboard.permits.metrics.complianceTooltip':
    '{{ready}}/{{total}} Personen erfüllen sowohl die Dokumenten- als auch die Schulungsanforderung ({{percent}}%)',
  'dashboard.permits.viewAll': 'Alle Arbeitserlaubnisse',

  // Übersicht — Spaltenüberschriften + die erklärenden Inhalte der drei Icon-Header-Tooltips
  // für die Tabelle "Aktive Arbeitserlaubnisse" (`UpcomingPermitsCard.tsx` — dieses Design
  // gewann den Owner-A/B-Vergleich am 2026-08-16)
  'dashboard.permits.table.col.readiness': 'Bereitschaft',
  'dashboard.permits.table.col.title': 'Arbeitserlaubnis',
  'dashboard.permits.table.col.hazard': 'Gefahr',
  'dashboard.permits.table.col.validity': 'Gültigkeit',
  'dashboard.permits.table.col.status': 'Status',
  'dashboard.permits.table.col.personnelHint':
    'Anzahl des dieser Arbeitserlaubnis zugewiesenen Personals',
  'dashboard.permits.table.col.documentsHint':
    'Personal, das die Dokumentenanforderung erfüllt / zugewiesenes Personal',
  'dashboard.permits.table.col.trainingsHint':
    'Personal, das die Schulung abgeschlossen hat / zugewiesenes Personal',
  'dashboard.permits.table.col.complianceHint':
    'Personal, das sowohl die Dokumenten- als auch die Schulungsanforderung erfüllt; nicht die Summe der beiden Teilzahlen.',

  // Übersicht — "Analyse ausstehend" (§20.3 awaiting-review — dieselben Daten wie
  // `PendingAnalysesStrip` auf der Dokumente-Seite, das Pendant im Dashboard)
  'dashboard.awaitingAnalysis.title': 'Zu überprüfende Dateien',

  // Gefahrenklasse (§13; numerisch)
  'hazard.1': 'Wenig gefährlich',
  'hazard.2': 'Gefährlich',
  'hazard.3': 'Sehr gefährlich',

  // Nachunternehmer-Status (§13)
  'status.active': 'Aktiv',
  'status.suspended': 'Ausgesetzt',
  'status.inactive': 'Inaktiv',

  // Konformität / Dokumentgültigkeit (§13 abgeleitet)
  'compliance.valid': 'Gültig',
  'compliance.expiring': 'Läuft bald ab',
  'compliance.expired': 'Abgelaufen',
  'compliance.missing': 'Fehlt',

  // Meine Dokumente (§13.6 + §8)
  'documents.title': 'Meine Konformitätsdokumente',
  'documents.subtitle':
    'Laden Sie die Konformitätsdokumente Ihrer Firma hoch und verfolgen Sie deren Gültigkeit.',
  'documents.add': 'Dokument hochladen',
  'documents.empty':
    'Noch keine Dokumente hochgeladen. Beginnen Sie mit dem Hinzufügen Ihrer Konformitätsdokumente.',
  'documents.col.type': 'Dokumenttyp',
  'documents.col.file': 'Datei',
  'documents.col.validity': 'Gültigkeit',
  'documents.col.status': 'Status',
  'documents.action.download': 'Herunterladen',
  'documents.action.delete': 'Löschen',
  'documents.upload.title': 'Konformitätsdokument hochladen',
  'documents.upload.description':
    'Wählen Sie die Datei aus und legen Sie Typ sowie Gültigkeitsdaten fest. Die Datei wird direkt in den sicheren Speicher hochgeladen.',
  'documents.upload.submit': 'Hochladen und hinzufügen',
  'documents.upload.uploading': 'Wird hochgeladen…',
  'documents.upload.progress': 'Wird hochgeladen: {{percent}}%',
  'documents.field.file': 'Dokumentdatei',
  'documents.field.filePlaceholder': 'Datei auswählen (PDF, Bild oder Office-Dokument)',
  'documents.field.fileHint': 'Bis zu 20 MB. PDF, Bild (PNG/JPG) oder Office-Dokument.',
  'documents.field.type': 'Dokumenttyp',
  'documents.field.validFrom': 'Gültig ab',
  'documents.field.validUntil': 'Gültig bis',
  'documents.validity.fromOnly': 'Gültig ab {{date}}',
  'documents.validity.untilOnly': 'Gültig bis {{date}}',
  'documents.field.note': 'Notiz (optional)',
  'documents.delete.title': 'Dokument entfernen',
  'documents.delete.body': 'Möchten Sie das Dokument {{type}} wirklich entfernen?',
  'documents.delete.confirm': 'Dokument entfernen',
  'documentTypes.placeholder': 'Dokumenttyp auswählen',
  'documentTypes.loading': 'Wird geladen…',
  'documentTypes.loadError': 'Dokumenttypen konnten nicht geladen werden.',
  'documentTypes.retry': 'Erneut versuchen',
  'documentTypes.empty':
    'Es ist kein Dokumenttyp zum Hochladen verfügbar. Wenden Sie sich an die Arbeitssicherheitsfachkraft Ihres Kunden.',
  'documentTypes.typeRejected':
    'Dieser Dokumenttyp kann nicht mehr verwendet werden. Die Typliste wurde aktualisiert; bitte erneut auswählen.',
  'documentTypes.inactiveMissing':
    'Dieser Dokumenttyp kann nicht hochgeladen werden; die Arbeitssicherheitsfachkraft muss diese Anforderung anpassen.',
  'documentTypes.inactiveSuffix': '(inaktiv)',
  'documents.expiryHint.EndDateRequired':
    'Ein Enddatum ist erforderlich; nach Ablauf gilt das Dokument als ungültig.',
  'documents.expiryHint.EndDateOptional':
    'Ein Enddatum ist optional; wenn angegeben, wird der Ablauf überwacht.',
  'documents.field.validUntilRequired': 'Für diesen Dokumenttyp ist ein Enddatum erforderlich.',
  'documents.field.saved': 'Gespeichert',

  // Dokumentenanalyse (doc-check-Integration, §20 — S17)
  'analysis.title': 'Dokumentenanalyse',
  // Titel eines nicht erkannten Elements + Hinweis für Fahrzeugdokumente (§20, #33).
  'analysis.item.unrecognised': 'Typ konnte nicht bestimmt werden',
  'analysis.review.vehicleRejectOnly':
    'Fahrzeugdokumente können hier nicht genehmigt werden. Lehnen Sie dieses Dokument ab und laden Sie es auf der Seite „Fahrzeuge“ beim betreffenden Fahrzeug hoch.',
  'analysis.review.recognisedInactive':
    'Die KI hat dieses Dokument als „{{label}}“ erkannt; dieser Typ ist hier nicht auswählbar. Wählen Sie einen anderen Typ.',
  'analysis.parse.tc-malformed': 'Gelesen; entspricht nicht dem Format einer T.C.-Nummer',
  'analysis.parse.tc-checksum-fail': 'Gelesen; Prüfsumme stimmt nicht',
  'analysis.parse.date-unparseable': 'Gelesen; Datum konnte nicht zuverlässig erkannt werden',
  'analysis.parse.not-normalized': 'Gelesen; Freitext, nicht geprüft',
  // Warnung bei niedriger Erkennungssicherheit (siehe `tr`-Kommentar über demselben Schlüssel).
  'analysis.field.lowConfidence':
    'Dieses Feld wurde möglicherweise nicht klar erkannt — bitte prüfen.',

  // Dokumentenanalyse — gemeinsame Texte des Posteingangs-Prüfungspanels
  // (`AnalysisReviewPane.tsx`, `AnalysisInboxRail.tsx`, `lib/analysisInboxTree.ts`; die alte
  // Ein-Analyse-pro-Seite-Ansicht wurde in C14 GELÖSCHT).
  'analysis.result.loading': 'Analyseinformationen werden geladen…',
  'analysis.result.disclaimerReading':
    'Dies ist eine maschinelle Lesung; keine Konformitätsentscheidung.',
  'analysis.result.disclaimerNotSaved':
    'Nicht bestätigte Dokumente werden nicht gespeichert und erscheinen nicht unter „Meine Dokumente“.',
  'analysis.result.sourcePageCount_one': '{{count}} Seite',
  'analysis.result.sourcePageCount_other': '{{count}} Seiten',
  'analysis.result.subjectUnnamed': 'Name konnte nicht gelesen werden',
  'analysis.result.pages': 'Seite {{span}}',
  'analysis.result.derivedHeading': 'Berechnetes Gültigkeitsdatum (nach Gefahrenklasse)',
  'analysis.result.startNew': 'Neue Analyse starten',

  // doc-check-Feld-IDs — offene Schlüsselmenge (S17-D7). Ein unbekannter Schlüssel wird
  // roh angezeigt (Label = Schlüssel); dieser Block übersetzt nur die BEKANNTEN Schlüssel.
  'docCheckField.tcKimlikNo': 'T.C.-Kennnummer',
  'docCheckField.soyad': 'Nachname',
  'docCheckField.ad': 'Vorname',
  'docCheckField.dogumTarihi': 'Geburtsdatum',
  'docCheckField.belgeSonGecerlilik': 'Ablaufdatum',
  'docCheckField.soyadiAdi': 'Nachname Vorname (in dieser Reihenfolge)',
  'docCheckField.verilmeTarihi': 'Ausstellungsdatum',
  'docCheckField.sonuc': 'Ergebnis',
  'docCheckField.adSoyad': 'Vollständiger Name',
  'docCheckField.muayeneTarihi': 'Untersuchungsdatum',
  'docCheckField.kanaatSonuc': 'Beurteilung und Ergebnis',
  'docCheckField.iseBaslamaTarihi': 'Beschäftigungsbeginn',
  'docCheckField.egitimKonusu': 'Schulungsthema',
  'docCheckField.egitimTarihi': 'Schulungsdatum',
  'docCheckField.egitimSaati': 'Schulungsstunden',
  'docCheckField.tehlikeSinifi': 'Gefahrenklasse',
  'docCheckField.belgeDuzenlemeTarihi': 'Ausstellungsdatum des Dokuments',
  'docCheckField.belgeGecerlilikTarihi': 'Gültigkeitsdatum des Dokuments',
  'docCheckField.firmaUnvani': 'Firmenname',
  'docCheckField.vergiNo': 'Steuernummer',
  'docCheckField.sgkIsyeriSicilNo': 'SGK-Betriebsnummer',
  'docCheckField.duzenlemeTarihi': 'Ausstellungsdatum',

  // Dokumentenanalyse — Statusleiste (Tray, §8 — S17-D11/D13). Die einzige Oberfläche,
  // die von der Upload-Warteschlange bis zum Analyseergebnis routenübergreifend bleibt.
  'analysis.tray.regionLabel': 'Status des Hochladens',
  'analysis.tray.uploading': '{{done}}/{{total}} Dateien hochgeladen',
  'analysis.tray.uploadFailed': 'Hochladen fehlgeschlagen',
  'analysis.tray.cancelUpload': 'Upload von {{name}} abbrechen',
  'analysis.tray.cancelAll': 'Alle Uploads abbrechen',
  'analysis.tray.collapse': 'Einklappen',
  'analysis.tray.expand': 'Ausklappen',
  'analysis.tray.starting': 'Analyse wird gestartet…',
  'analysis.tray.queued': 'Analyse in der Warteschlange',
  'analysis.tray.running': 'Analyse läuft',
  'analysis.tray.succeeded': 'Analyse abgeschlossen',
  'analysis.tray.succeededPartial': 'Teilweise abgeschlossen',
  'analysis.tray.failed': 'Analyse fehlgeschlagen',
  'analysis.tray.startFailedTitle':
    'Ihre Dateien wurden hochgeladen, aber die Analyse konnte nicht gestartet werden.',
  'analysis.tray.viewResults': 'Ergebnisse ansehen',
  'analysis.tray.viewDetail': 'Details ansehen',
  'analysis.tray.retry': 'Erneut versuchen',
  'analysis.tray.goToOngoing': 'Zur laufenden Analyse',

  // S19 — Zusammengeführter Upload = Analyseablauf auf Meine Dokumente
  // (KI immer aktiv, Warteschlange, Annahme).

  // Drag-and-Drop-Overlay — Seitenkörper von Meine Dokumente + Personaldokumente-Panel
  'documents.dropHere': 'Dateien hier ablegen',
  'documents.dropHint': 'PDF, Bild oder Office-Dokument · bis zu 10 Dateien, insgesamt 60 MB',
  'documents.dropCapExceeded': 'Sie können höchstens 10 Dateien mit insgesamt 60 MB hochladen.',

  // Upload-Modal — Titel, Dateizusammenfassung, Fußzeilen-Schaltflächen
  'upload.modal.title': 'Ihre Dateien wurden empfangen und werden gelesen',
  'upload.modal.titleOff': 'Ihre Dateien wurden empfangen — bitte Angaben eingeben',
  'upload.modal.titleManual': 'Geben Sie die Angaben zu diesen Dateien ein',
  'upload.modal.titleRejected': 'Es konnten keine Dateien übernommen werden',
  'upload.modal.filesSummaryMore_one': '+{{count}} Datei',
  'upload.modal.filesSummaryMore_other': '+{{count}} Dateien',
  'upload.cancelAll': 'Upload abbrechen',
  'upload.save': 'Speichern',
  'upload.done': 'OK',

  // Schalter „Automatisches Lesen“ — beide Zustände + Hinweise beim Deaktivieren/Schließen
  'upload.ai.switchLabelOn': 'Automatisches Lesen an',
  'upload.ai.switchLabelOff': 'Automatisches Lesen aus',
  'upload.ai.switchOffHint':
    'Wenn Sie dies deaktivieren, geben Sie Dokumenttyp und Daten selbst ein.',

  // Schließen ohne Speichern = Löschbestätigung (F1)
  'upload.discard.title': 'Hochgeladene Dateien löschen',
  'upload.discard.body_one':
    'Die {{count}} hochgeladene Datei wurde noch nicht zu „Meine Dokumente“ hinzugefügt. Wenn Sie dieses Fenster schließen, wird sie gelöscht.',
  'upload.discard.body_other':
    'Die {{count}} hochgeladenen Dateien wurden noch nicht zu „Meine Dokumente“ hinzugefügt. Wenn Sie dieses Fenster schließen, werden sie gelöscht.',
  'upload.discard.cancel': 'Zurück',
  'upload.discard.confirm': 'Dateien löschen',

  // Erklärungsbox — wird angezeigt, wenn der Schalter aktiv ist
  'upload.ai.box.title': 'Was passiert beim Hochladen?',
  'upload.ai.box.l1': 'Erkennt den Dokumenttyp',
  'upload.ai.box.l2': 'Gruppiert Dokumente nach derselben Person',
  'upload.ai.box.l3': 'Trennt sie, wenn mehr als eine Person enthalten ist',
  'upload.ai.box.l4': 'Bis zu 10 Dateien, 60 MB pro Vorgang',
  'upload.ai.box.confirm': 'Sie bestätigen die Ergebnisse.',

  // Manueller Zweig — nicht lesbare Dateien (Word/Excel/HEIC/WebP) und abgelehnte Dateien
  'upload.unreadable.title_one': '{{count}} Datei kann von der KI nicht gelesen werden',
  'upload.unreadable.title_other': '{{count}} Dateien können von der KI nicht gelesen werden',
  'upload.unreadable.hint':
    'Word-, Excel-, HEIC- und WebP-Dateien können nicht gelesen werden. Geben Sie die Angaben selbst ein.',

  'upload.failed.title_one': '{{count}} Datei konnte nicht hochgeladen werden',
  'upload.failed.title_other': '{{count}} Dateien konnten nicht hochgeladen werden',
  'upload.failed.hint':
    'Sie können es erneut versuchen oder mit dem Speichern der anderen Dateien fortfahren.',
  'upload.failed.retryItem': 'Erneut versuchen: {{name}}',
  'upload.rejected.title_one': '{{count}} Datei konnte nicht angenommen werden',
  'upload.rejected.title_other': '{{count}} Dateien konnten nicht angenommen werden',
  'upload.rejected.overCap': 'Dieser Upload kann höchstens {{max}} Dateien enthalten.',
  'upload.rejected.overSize': 'Das Gesamtlimit von {{max}} wurde überschritten.',
  'upload.personnelScope': 'Diese Dokumente werden für {{name}} hochgeladen.',

  // Meine Dokumente — Streifen für ausstehende / gescheiterte Analysen
  'documents.pending.title': '{{count}} Dokumente warten auf Ihre Bestätigung',
  'documents.pending.personnel':
    'Davon sind {{count}} Personaldokumente — werden nach Bestätigung zu Mein Personal hinzugefügt',
  'documents.pending.queuedAt': 'Analyse: {{date}}',
  'documents.pending.cta': 'Prüfen und bestätigen',
  'documents.analysisInbox.pendingSr_one': '{{count}} Dokument wartet auf Ihre Bestätigung',
  'documents.analysisInbox.pendingSr_other': '{{count}} Dokumente warten auf Ihre Bestätigung',
  'documents.analysisInbox.pendingSrAtLeast':
    'Mindestens {{count}} Dokumente warten auf Ihre Bestätigung',
  'documents.analysisInbox.badgeAtLeast': '{{count}}+',
  'documents.stranded.title':
    'Analyse konnte nicht abgeschlossen werden — {{count}} Dateien warten',
  'documents.stranded.cta': 'Angaben manuell eingeben',
  'documents.stranded.allLinked': 'Alle Dateien dieser Analyse wurden bereits verknüpft.',

  // KAYIT DIŞI-Kennzeichen ("nicht registriert") + Abweichungswarnung (Plan S25 C8,
  // `lib/personMatch.ts`) — von der Leiste (2. Ebene) UND dem Personenfeld des Prüfungspanels
  // gelesen.
  'analysis.person.unregistered': 'Nicht im Personal',
  'analysis.person.invited': 'Einladung ausstehend',
  'analysis.person.invitedHint':
    'Diese Person wurde zu Ihrem Unternehmen eingeladen, hat ihr Konto aber noch nicht aktiviert. Das Dokument kann erst nach der Aktivierung mit ihr verknüpft werden.',
  'analysis.person.createNew': '+ Neues Personal anlegen',
  'analysis.person.mismatch.tcLabel': 'T.C.-Kimlik-Nummer stimmt nicht mit dem Dokument überein',
  'analysis.person.mismatch.tcContent':
    'Die T.C.-Kimlik-Nummer der ausgewählten Person stimmt nicht mit der aus dem Dokument gelesenen überein. Sie können trotzdem genehmigen.',
  'analysis.person.mismatch.nameLabel': 'Name stimmt nicht mit dem Dokument überein',
  'analysis.person.mismatch.nameContent':
    'Der Name der ausgewählten Person stimmt nicht mit dem aus dem Dokument gelesenen überein. Sie können trotzdem genehmigen.',
  // Siehe `tr`-Kommentar über demselben Schlüssel (FIX 2).
  'analysis.person.mismatch.tcNameConflictLabel': 'Der Name auf dem Dokument sieht anders aus',
  'analysis.person.mismatch.tcNameConflictContent':
    'Die T.C.-Kimlik-Nummer stimmt mit dieser Person überein, aber der aus dem Dokument gelesene Name sieht anders aus. Das ist meist ein Lesefehler — bitte prüfen Sie das Dokument. Sie können trotzdem genehmigen.',

  // Annahme-Oberfläche — Bestätigung + Beleg
  'analysis.accept.subjectPicker': 'Person',
  'analysis.accept.confirm': 'Bestätigen',
  'analysis.accept.success':
    'In Meine Dokumente mit Typ und Daten gespeichert; die Gültigkeitsfrist hat begonnen.',
  // FIX 5 (S24 UI-fix) — wird angezeigt, wenn „Gültig bis“ nicht aus dem gedruckten Datum
  // des Dokuments, sondern aus der Gefahrenklassen-Berechnung vorausgefüllt wurde; das Feld
  // bleibt bearbeitbar.
  'analysis.accept.validUntilInferredHint':
    'Das Dokument enthält kein gedrucktes Gültigkeitsdatum; dieses Datum wurde nach der Gefahrenklasse berechnet.',

  // Prüfungspanel (Plan S25 C5-C12, `AnalysisReviewPane.tsx`) — Karte der ausgelesenen Felder,
  // Fußzeilen-ⓘ, Bestätigungsdialog (C10, ÖFFNET SICH IMMER — nicht nur bei Abweichung).
  'analysis.review.extractedHeading': 'Aus dem Dokument gelesene Felder',
  // `droppedCount` ist dreiwertig — erscheint nur bei `> 0`; `null` (nicht gemessen) und `0`
  // (gemessen, sauber) lösen diese Zeile NIE aus (siehe `tr`-Kommentar über demselben Schlüssel).
  'analysis.review.unplacedFields_one':
    '{{count}} Feld konnte keiner Seite zugeordnet werden; laden Sie die fehlende Seite hoch oder tragen Sie es manuell ein.',
  'analysis.review.unplacedFields_other':
    '{{count}} Felder konnten keiner Seite zugeordnet werden; laden Sie die fehlende Seite hoch oder tragen Sie sie manuell ein.',
  // Jeder Code im `issues`-Array wird zu `DOCCHECK_<code>` aufgelöst (Backend-Sprachpaket,
  // `/resources`) — dies ist nur der Platzhalter, solange diese Auflösung noch nicht möglich
  // ist (bevor das Paket geladen wurde). Kein Fehler, sondern ein Befund-Hinweis — niemals
  // `error.generic`.
  'analysis.issue.generic': 'Zu diesem Dokument liegt ein Hinweis vor.',
  'analysis.review.kanaatSonucInfoLabel': 'Über Beurteilung und Ergebnis',
  'analysis.review.kanaatSonucInfoContent':
    'Die eigene Formulierung des Arztes auf dem Dokument, unverändert angezeigt.',
  'analysis.review.footer.infoLabel': 'Vor der Genehmigung',
  'analysis.review.footer.infoContent':
    'Genehmigen verknüpft das Dokument dauerhaft mit der ausgewählten Person oder Firma. Ablehnen ist ein Klick und kann über „Rückgängig“ in der Leiste rückgängig gemacht werden.',
  'analysis.review.confirm.title': 'Dokument genehmigen',
  'analysis.review.confirm.document': 'Dokument',
  'analysis.review.confirm.person': 'Person',
  'analysis.review.confirm.validity': 'Gültigkeit',
  'analysis.review.confirm.validityEmpty': 'Kein Datum eingegeben',
  'analysis.review.confirm.warning':
    'Nach der Genehmigung wird dieses Dokument mit Ihrem Datensatz verknüpft; die Verknüpfung kann nicht rückgängig gemacht werden.',
  // C8 §3 — zusätzliche Warnzeile im Bestätigungsdialog bei einer Abweichung (Bildschirm 3c);
  // blockiert die Genehmigung NIE, benennt nur die Abweichung.
  'analysis.review.confirm.mismatch.tc':
    'Die T.C.-Kimlik-Nummer der ausgewählten Person stimmt nicht mit dem Dokument überein.',
  'analysis.review.confirm.mismatch.name':
    'Der Name der ausgewählten Person stimmt nicht mit dem Dokument überein.',
  // FIX 2 — T.C. stimmt überein, Name weicht ab: milderer Ton, „vermutlich ein Lesefehler“.
  'analysis.review.confirm.mismatch.tcNameConflict':
    'Die T.C.-Kimlik-Nummer stimmt mit dieser Person überein, aber der Name im Dokument sieht anders aus. Das ist vermutlich ein Lesefehler — bitte prüfen Sie das Dokument.',
  'analysis.review.confirm.failed':
    'Das Dokument konnte nicht genehmigt werden. Bitte versuchen Sie es erneut.',

  // Seitenvorschau (S24, §20 `DocumentAnalysisPageDto`) — Guard für abgelaufene presigned URLs +
  // Platzhalter (`DocumentAnalysisPreview.tsx`).
  'analysis.preview.unavailable': 'Keine Vorschau verfügbar',
  // Ein-Seiten-Karussell des Prüfungspanels (Plan S25 C5) — Seitenchip, Vergrößern-Schaltfläche, Bildunterschrift.
  'analysis.preview.pageChip': 'Seite {{page}}',
  'analysis.preview.itemCaption': '{{fileName}} · Seite {{span}}',
  'analysis.preview.expandAria': 'Seite vergrößern',
  // FIX 3 (S24 UI-fix) — Großansicht (Lightbox), die durch Klicken auf eine Miniaturansicht geöffnet wird.
  'analysis.preview.modal.close': 'Vorschau schließen',
  'analysis.preview.modal.caption': '{{fileName}} · Seite {{page}}',
  'analysis.preview.modal.previous': 'Vorherige Seite',
  'analysis.preview.modal.next': 'Nächste Seite',

  // Element ablehnen (§20.4, S24) — endgültig, serverseitiges `DELETE`.
  // `analysis.accept.dismiss` ("Verwerfen") ENTFERNT: dieselbe Zeile darf nicht zwei
  // unterschiedliche Verhaltensweisen unter einem Wort tragen.
  'analysis.item.reject': 'Ablehnen',
  'analysis.item.rejected': 'Abgelehnt',
  // FIX 1 (S24 UI-fix) — neutrales Statuslabel in der eingeklappten Zeile (kein Verb). Kein
  // eigener Schlüssel für `rejected` — eine abgelehnte Zeile verwendet den obigen Schlüssel.
  'analysis.item.status.accepted': 'Genehmigt',
  // Owner-Override, 2026-08-11 (AC3 — siehe Kommentar am Dateianfang) — das Gutter-Symbol trägt
  // jetzt jeden Status, auch Ausstehend (`Circle` + dieser sr-only).
  'analysis.item.status.pending': 'Ausstehend',

  // Gesamte Analyse verwerfen (§20.4, S24).
  'analysis.discard.action': 'Analyse löschen',
  'analysis.discard.confirmTitle': 'Analyse löschen',
  'analysis.discard.confirmBody':
    'Diese Analyse, ihre gespeicherten Seitenbilder und alle hochgeladenen Quelldateien, die mit keinem anderen Dokument verknüpft sind, werden endgültig gelöscht. Dies kann nicht rückgängig gemacht werden. Bereits genehmigte Dokumente werden nicht gelöscht und bleiben erhalten.',
  'analysis.discard.failed':
    'Die Analyse konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',

  // Posteingang (Plan S25) — Vollbild-Bildschirm anstelle der Ein-Analyse-pro-Seite-Ansicht:
  // links alle ausstehenden Analysen, rechts das Prüfungspanel (in diesem Abschnitt nur ein
  // Gerüst).
  'analysis.inbox.infoLabel': 'Über die Dokumentenanalyse',
  'analysis.inbox.infoContent':
    'Hier werden alle ausstehenden Analysen zusammengeführt. Wählen Sie links ein Dokument aus und genehmigen oder lehnen Sie es einzeln ab; die Genehmigung ist endgültig und verknüpft das Dokument mit einer Person.',
  'analysis.inbox.progress': '{{decided}}/{{total}} entschieden',
  'analysis.inbox.searchLabel': 'Dokument oder Person suchen',
  'analysis.inbox.searchPlaceholder': 'Dokument oder Person suchen…',
  'analysis.inbox.treeLabel': 'Analyse-Warteschlange',
  'analysis.inbox.analysisHeading': 'Analyse · {{date}}',
  'analysis.inbox.collapsedCount_one': '{{count}} Dokument',
  'analysis.inbox.collapsedCount_other': '{{count}} Dokumente',
  'analysis.inbox.companyGroupHeading': 'Firmendokumente',
  'analysis.inbox.unresolvedGroupHeading': 'Zuordnung konnte nicht ermittelt werden',
  'analysis.review.target.label': 'Wem gehört dieses Dokument?',
  'analysis.review.target.placeholder': 'Auswählen',
  'analysis.review.target.company': 'Firmendokument',
  'analysis.review.target.personnel': 'Personaldokument',
  'analysis.inbox.itemPageSpan': '{{fileName}} · S.{{span}}',
  // sr-only-Label für das `Info`-Symbol neben dem Titel in der Baumzeile — sichtbar bei
  // `item.issues.length > 0` (bei abgelehnten Zeilen unterdrückt, siehe `AnalysisInboxRail.tsx`).
  'analysis.inbox.itemHasIssue': 'Hinweis vorhanden',
  'analysis.inbox.menuLabel': 'Analyseoptionen',
  'analysis.inbox.archivedSectionLabel': 'Archiviert',
  'analysis.inbox.archivedEmpty': 'Keine archivierten Analysen.',
  'analysis.inbox.archivedCount_one': '{{count}} Analyse',
  'analysis.inbox.archivedCount_other': '{{count}} Analysen',
  'analysis.inbox.emptyQueue': 'Keine ausstehenden Analysen.',
  'analysis.inbox.noPendingMatches': 'Keine passenden Dokumente in den ausstehenden Analysen.',
  'analysis.inbox.noArchivedMatches': 'Keine passenden Dokumente in den archivierten Analysen.',
  'analysis.inbox.truncated':
    'Es werden nur die {{shown}}/{{total}} neuesten ausstehenden Analysen angezeigt. Ältere erscheinen der Reihe nach, sobald neuere entschieden wurden.',
  'analysis.inbox.outOfQueueResolved':
    'Über alle Dokumente dieser Analyse wurde bereits entschieden.',
  'analysis.inbox.pane.emptyTitle': 'Wählen Sie ein Dokument zur Prüfung aus',
  'analysis.inbox.pane.emptyBody':
    'Details werden hier angezeigt, sobald Sie ein Dokument aus der Liste links auswählen.',
  // C12/AC16 — eigener Leerzustand-Text, sobald kein ausstehendes Element mehr übrig ist (`allDecided`).
  'analysis.inbox.pane.allDoneTitle': 'Alles entschieden',
  'analysis.inbox.pane.allDoneBody':
    'Keine ausstehenden Dokumente mehr. Neue erscheinen hier, sobald Sie eine weitere Analyse starten.',
  'analysis.inbox.pane.errorTitle': 'Diese Analyse konnte nicht geladen werden',
  // `⋯`-Menü (Analyseebene) — Dateimanifest + Archivieren/Aus Archiv entfernen + Löschen.
  'analysis.inbox.menu.filesHeading': 'Hochgeladene Dateien',
  'analysis.inbox.menu.archive': 'Archivieren',
  'analysis.inbox.menu.archiveFailed': 'Archivierung fehlgeschlagen. Bitte erneut versuchen.',
  'analysis.inbox.menu.unarchive': 'Aus Archiv entfernen',
  'analysis.inbox.menu.deleteAction': 'Analyse löschen ({{count}} Dokumente)',
  'analysis.inbox.menu.deleteConfirmTitle': 'Analyse löschen',
  'analysis.inbox.menu.deleteConfirmBody_one':
    'Diese Analyse, die gespeicherten Seitenbilder und die {{count}} von Ihnen hochgeladene Quelldatei werden vollständig und dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.',
  'analysis.inbox.menu.deleteConfirmBody_other':
    'Diese Analyse, die gespeicherten Seitenbilder und alle {{count}} von Ihnen hochgeladenen Quelldateien werden vollständig und dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.',
  'analysis.inbox.menu.deleteFailed':
    'Die Analyse konnte nicht gelöscht werden. Bitte erneut versuchen.',
  'analysis.inbox.menu.deleteBlockedTitle': 'Es gibt genehmigte Dokumente',
  'analysis.inbox.menu.deleteBlockedBody':
    'Diese Analyse enthält mindestens ein genehmigtes Dokument; Genehmigungen sind endgültige Compliance-Entscheidungen und können nicht gelöscht werden. Die Analyse wird stattdessen archiviert.',
  // Ablehnung eines Elements rückgängig machen (§20.4 restore) — das Gegenteil von
  // `analysis.item.reject`.
  'analysis.item.restore': 'Rückgängig',
  'analysis.item.restoreAria': 'Ablehnung von {{title}} rückgängig machen',
  'analysis.item.restoreFailed': 'Rückgängig machen fehlgeschlagen. Bitte erneut versuchen.',

  // Mein Personal (§13.6)
  'personnel.title': 'Mein Personal',
  'personnel.subtitle':
    'Mit Ihrem Unternehmen verknüpftes Personal. Sie können neues Personal anlegen und optional einen Link zur Kontoaktivierung senden.',
  'personnel.empty': 'Noch kein Personal mit Ihrer Firma verknüpft.',
  'personnel.col.name': 'Vollständiger Name',
  'personnel.col.contact': 'E-Mail / Telefon',
  'personnel.col.status': 'Status',
  'personnel.col.access': 'Zugriff',
  'personnel.col.date': 'Datum',
  // Statusabzeichen (aktives Personal + ausstehende Einladungen — §13.3/§13.6)
  'personnel.status.active': 'Aktiv',
  'personnel.status.inactive': 'Inaktiv',
  'personnel.status.pending': 'Ausstehend',
  'personnel.status.expired': 'Abgelaufen',
  // Personal ohne Zugang (§13.3, S25-A7c) — ohne Einladung angelegt, noch keine Zugangsdaten.
  'personnel.status.notactivated': 'Nicht aktiviert',
  'personnel.createAction': 'Personal anlegen',
  // Zugriffsebene (§13.3)
  'personnel.access.personeli': 'Mitarbeiter',
  'personnel.access.yetkili': 'Verantwortlicher',
  // Zeilenaktion — Wechsel zum Personalprofil (S26, `/personnel/:userUuid`)

  // Gemeinsame Formularbezeichnungen: optionales Feld, Bestätigung beim Verwerfen
  'personnel.invite.optional': 'optional',
  'drawer.discard.title': 'Ohne Speichern schließen?',
  'drawer.discard.body':
    'Das Formular enthält nicht gespeicherte Eingaben. Wenn Sie das Panel schließen, werden sie nicht gespeichert.',
  'drawer.discard.cancel': 'Zurück',
  'drawer.discard.confirm': 'Ohne Speichern schließen',

  // Zeilenmenü ⋮
  'personnel.action.openMenu': 'Aktionen für {{name}}',

  // Personalprofil (§13.6 NEU, S26 — /personnel/:userUuid, einzelne GET/PUT/DELETE-Endpunkte)
  'personnel.detail.field.activatedAt': 'Aktivierungsdatum',
  'personnel.detail.field.createdAt': 'Erfassungsdatum',
  'personnelForm.tc.show': 'Anzeigen',
  'personnelForm.tc.hide': 'Ausblenden',
  'personnelForm.field.phone': 'Telefon',
  'personnelForm.field.email': 'E-Mail',
  'personnelForm.field.tcKimlikNo': 'T.C.-Kimlik-Nummer',
  'personnelForm.masked.notice':
    'Persönliche Angaben sind teilweise ausgeblendet, da Ihnen die Berechtigung „Personenbezogene Daten“ fehlt.',
  // Gemeinsames Personal-Bearbeitungsformular (#29) — dieselben Schlüssel wie EP.
  'personnelForm.edit.action': 'Bearbeiten',
  'personnelForm.edit.title': 'Personal bearbeiten',
  'personnelForm.field.firstName': 'Vorname',
  'personnelForm.field.lastName': 'Nachname',
  'personnelForm.field.tcKimlikNoHint':
    '11 Ziffern mit gültiger Prüfsumme; kann nur einmal erfasst werden.',
  'personnelForm.field.accessLevel': 'Zugriffsebene',
  'personnelForm.access.personeli': 'Mitarbeiter',
  'personnelForm.access.yetkili': 'Verantwortlicher',
  'personnelForm.field.accessHint':
    'Ein Verantwortlicher kann im Web-Portal Personal hinzufügen und Firmendokumente hochladen; ein Mitarbeiter sieht nur seine eigenen Daten in der mobilen App.',
  'personnelForm.field.active': 'Aktiv',
  'personnelForm.field.activeHint':
    'Inaktives Personal kann sich nicht anmelden und hat keinen Zugang zu Standorten.',
  'personnelForm.refreshNote':
    'Änderungen der Zugriffsebene und des Aktiv-/Inaktiv-Status werden spätestens innerhalb von 15 Minuten (bei der nächsten Sitzungsaktualisierung) wirksam.',
  'personnelForm.lock.tcSetOnce':
    'Nach der Eingabe kann die T.C.-Kimlik-Nummer über diesen Bildschirm nicht mehr geändert werden. Wenden Sie sich bei Änderungsbedarf an den Support.',
  'personnelForm.lock.tcNoPermission':
    'Die T.C.-Kimlik-Nummer können nur Benutzer mit der Berechtigung „Personenbezogene Daten“ erfassen.',
  'personnelForm.lock.contact':
    'Telefon und E-Mail werden bei der Aktivierung des Kontos durch die Person bestätigt und gespeichert; sie können hier nicht geändert werden.',
  'personnelForm.submit': 'Speichern',
  'personnelForm.saved': 'Informationen aktualisiert.',
  'personnelForm.discardEdit.title': 'Änderungen verwerfen?',
  'personnelForm.discardEdit.body':
    'Wenn Sie die Bearbeitung verlassen, werden Ihre Änderungen nicht gespeichert.',
  'personnelForm.discardEdit.cancel': 'Zurück',
  'personnelForm.discardEdit.confirm': 'Änderungen verwerfen',
  'personnelForm.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'personnelForm.validation.lastNameRequired': 'Nachname ist erforderlich.',
  'personnelForm.validation.firstNameTooLong':
    'Der Vorname darf höchstens {{max}} Zeichen lang sein.',
  'personnelForm.validation.lastNameTooLong':
    'Der Nachname darf höchstens {{max}} Zeichen lang sein.',
  'personnelForm.validation.tcInvalid':
    'Die eingegebene T.C.-Kimlik-Nummer ist ungültig. Bitte überprüfen Sie sie und versuchen Sie es erneut.',
  'personnelForm.validation.tcExistsFallback':
    'Es existiert bereits ein Mitarbeiterdatensatz mit dieser T.C.-Kimlik-Nummer.',
  'personnelForm.hydrate.loading': 'Personendatensatz wird geladen …',
  'personnel.detail.notFound.body':
    'Diese Person steht nicht auf der Personalliste Ihres Unternehmens. Bitte erneut aus der Liste auswählen.',
  'personnel.detail.selfNoticeBody':
    'Sie können Ihr eigenes Konto hier nicht bearbeiten oder sich selbst aus dem Unternehmen entfernen.',
  'personnel.detail.remove.title': 'Personal aus Ihrem Unternehmen entfernen',
  'personnel.detail.remove.action': 'Aus Unternehmen entfernen',
  'personnel.detail.remove.body':
    '{{name}} wird von der Personalliste Ihres Unternehmens entfernt. Die Person wird nicht gelöscht — nur die Firmenverknüpfung wird aufgehoben. Die hochgeladenen Dokumente verschwinden sowohl aus Ihrer als auch aus der Liste der Arbeitssicherheitsfachkraft. Wird die Person erneut zu Ihrem Unternehmen hinzugefügt und aktiviert sie ihr Konto, kehren die Dokumente zurück.',
  'personnel.detail.remove.bodyNotActivated':
    '{{name}} wird von der Personalliste Ihres Unternehmens entfernt. Die Person wird nicht gelöscht — nur die Firmenverknüpfung wird aufgehoben. Die hochgeladenen Dokumente verschwinden sowohl aus Ihrer als auch aus der Liste der Arbeitssicherheitsfachkraft. Da die Person ihr Konto nie aktiviert hat, entsteht beim erneuten Hinzufügen ein neuer Datensatz; Dokumente wie EK-2 und Führungszeugnis kehren nicht dorthin zurück und müssen erneut hochgeladen werden.',
  'personnel.detail.noLogin.body':
    'Diese Person hat ihr Konto noch nicht aktiviert und kann sich nicht im Portal oder in der mobilen App anmelden. Ihre Dokumente können dennoch hochgeladen werden.',

  // Mobile App / Download (§26 App-Store-Links)
  'layout.mobileApp': 'Mobile App',
  'mobileApp.title': 'Mobile App',
  'mobileApp.subtitle':
    'Laden Sie die İSG-Portal-App herunter, damit Ihr Personal vor Ort seine Dokumente und Benachrichtigungen per Telefon erreichen kann.',
  'appDownload.storesTitle': 'In den Stores herunterladen',
  'appDownload.title': 'Mobile App herunterladen',
  'appDownload.personnelBody':
    'Ihr Konto wird über die mobile App genutzt. Laden Sie die App auf Ihr Telefon, um fortzufahren.',
  'appDownload.signedInAs': 'Angemeldet als {{name}}',
  'appDownload.ios': 'Im App Store laden',
  'appDownload.android': 'Bei Google Play holen',
  'appDownload.comingSoon.body':
    'Die mobile App ist bald in den Stores verfügbar. Die Download-Links erscheinen hier, sobald sie bereit sind.',
  'appDownload.loading': 'App-Informationen werden geladen…',
  'dashboard.app.title': 'Mobile App',
  'dashboard.app.body':
    'Ihr Personal vor Ort kann seine Dokumente und Benachrichtigungen über die mobile App erreichen.',

  // Fehlercodes für Versandkanal (§5.10.1/§5.10.4) — lokaler Fallback (Backend-Paket überschreibt).
  NO_CONTACT:
    'Diese Einladung enthält weder eine E-Mail-Adresse noch eine Telefonnummer und kann daher nicht erneut gesendet werden. Fügen Sie die Person mit einer neuen Einladung hinzu.',
  INVITE_CHANNEL_UNAVAILABLE:
    'Der gewählte Versandkanal kann mit den Kontaktdaten dieser Einladung nicht verwendet werden. Bitte wählen Sie einen Kanal, der zur E-Mail-Adresse oder Telefonnummer der Einladung passt.',
  ACTIVATION_LINK_COOLDOWN:
    'An diese Kontaktangabe wurde gerade erst ein Aktivierungslink gesendet. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
  'personnelCreate.title': 'Personal anlegen',
  'personnelCreate.description':
    'Legen Sie die Person an; optional können Sie ihr auch einen Link zur Kontoaktivierung senden.',
  'personnelCreate.submit': 'Anlegen',
  'personnelCreate.another': 'Weitere Person anlegen',
  'personnelCreate.contact.title': 'Aktivierungslink (optional)',
  'personnelCreate.contact.hint':
    'Wenn Sie eine E-Mail-Adresse oder Telefonnummer eingeben, erhält die Person einen Link zur Kontoaktivierung. Diese Angabe wird nicht im Datensatz der Person gespeichert.',
  'personnelCreate.success.created': 'Person angelegt.',
  'personnelCreate.success.linkSent': 'Person angelegt. Der Aktivierungslink ist bereit.',
  'personnelCreate.validation.tcRequired': 'Die T.C.-Kimlik-Nummer ist erforderlich.',
  'personnelCreate.cooldownUntil':
    'An diese Kontaktangabe wurde gerade erst ein Link gesendet. Versuchen Sie es ab {{availableAt}} Uhr erneut oder leeren Sie die Kontaktfelder und legen Sie die Person jetzt an; den Link können Sie später senden.',
  'personnelCreate.cooldownGeneric':
    'An diese Kontaktangabe wurde gerade erst ein Link gesendet. Warten Sie einen Moment und versuchen Sie es erneut oder leeren Sie die Kontaktfelder und legen Sie die Person jetzt an; den Link können Sie später senden.',
  'personnelCreate.dailyLimit':
    'Ihr Unternehmen hat das Tageslimit für den Versand von Links erreicht. Leeren Sie die Kontaktfelder und legen Sie die Person jetzt an; den Link können Sie später senden.',
  'personnelLink.cooldownUntil':
    'An diese Person oder diese Kontaktangabe wurde gerade erst ein Aktivierungslink gesendet. Sie können es ab {{availableAt}} Uhr erneut versuchen.',
  'personnelLink.field.email': 'E-Mail',
  'personnelLink.field.emailPlaceholder': 'name@firma.com',
  'personnelLink.field.phone': 'Telefon',
  'personnelLink.field.phonePlaceholder': '+90 555 123 45 67',
  'personnelLink.field.phoneHint':
    'Mobilnummer. Bei Nummern außerhalb der Türkei + und Ländervorwahl angeben.',
  'personnelLink.field.channel': 'Versandkanal',
  'personnelLink.field.channelHint':
    'Der Aktivierungslink wird automatisch über den gewählten Kanal gesendet; er bleibt außerdem auf dem Bildschirm.',
  'personnelLink.channel.email': 'E-Mail',
  'personnelLink.channel.sms': 'SMS',
  'personnelLink.channel.both': 'E-Mail und SMS',
  'personnelLink.field.link': 'Aktivierungslink',
  'personnelLink.copy': 'Kopieren',
  'personnelLink.copied': 'Kopiert',
  'personnelLink.copyFailed':
    'Der Link konnte nicht kopiert werden. Bitte markieren und kopieren Sie ihn manuell.',
  'personnelLink.expiresAt': 'Der Link ist gültig bis {{date}}.',
  'personnelLink.dispatch.emailSent': 'Der Aktivierungslink wurde per E-Mail gesendet.',
  'personnelLink.dispatch.smsSent': 'Der Aktivierungslink wurde per SMS gesendet.',
  'personnelLink.dispatch.emailFailed':
    'Der Aktivierungslink konnte nicht per E-Mail gesendet werden. Kopieren Sie den Link und leiten Sie ihn an die Person weiter.',
  'personnelLink.dispatch.smsFailed':
    'Der Aktivierungslink konnte nicht per SMS gesendet werden. Kopieren Sie den Link und leiten Sie ihn an die Person weiter.',
  'personnelLink.dispatch.none':
    'Der automatische Versand war nicht möglich. Bitte kopieren Sie den untenstehenden Link und leiten Sie ihn an die Person weiter.',
  'personnelLink.validation.contactRequired': 'E-Mail oder Telefon ist erforderlich.',
  'personnelLink.validation.emailInvalid': 'Geben Sie eine gültige E-Mail-Adresse ein.',
  'personnelLink.validation.phoneInvalid':
    'Geben Sie eine gültige Mobilnummer ein. Bei Nummern außerhalb der Türkei + und Ländervorwahl angeben.',
  'personnelLink.validation.emailTaken':
    'An diese E-Mail-Adresse kann kein Aktivierungslink gesendet werden. Versuchen Sie eine andere E-Mail-Adresse oder Telefonnummer.',
  'personnelLink.validation.phoneTaken':
    'An diese Telefonnummer kann kein Aktivierungslink gesendet werden. Versuchen Sie eine andere Telefonnummer oder E-Mail-Adresse.',
  'personnelLink.validation.contactTaken':
    'An die eingegebene Kontaktangabe kann kein Aktivierungslink gesendet werden. Versuchen Sie eine andere E-Mail-Adresse oder Telefonnummer.',
  'personnelLink.pending.sent': 'Gesendet',
  'personnelLink.pending.expired': 'Abgelaufen',
  'personnelLink.action.send': 'Aktivierungslink senden',
  'personnelLink.action.resend': 'Link erneut senden',
  'personnelLink.action.cancel': 'Link widerrufen',
  'personnelLink.cancel.title': 'Link widerrufen',
  'personnelLink.cancel.body.person':
    'Der für {{name}} gesendete Aktivierungslink wird widerrufen; die Person kann ihr Konto damit nicht mehr aktivieren und bleibt als „Nicht aktiviert“ in der Liste.',
  'personnelLink.notFound':
    'Dieser Link ist nicht mehr gültig; er wurde möglicherweise inzwischen erneut gesendet oder widerrufen, oder die Person hat ihr Konto bereits aktiviert. Die Liste wurde aktualisiert; schließen Sie das Fenster und prüfen Sie den aktuellen Status der Person.',
  'personnelLink.cancel.body.invite':
    'Der für {{name}} gesendete Aktivierungslink wird widerrufen; die Person kann ihr Konto damit nicht mehr aktivieren. Diese Zeile wird aus der Liste entfernt.',
  'personnelLink.cancel.confirm': 'Link widerrufen',
  'personnelLink.send.title': 'Aktivierungslink senden',
  'personnelLink.send.description':
    'Senden Sie einen Aktivierungslink für {{name}}. Er geht nur an die eingegebene E-Mail-Adresse oder Telefonnummer; diese Angabe wird nicht im Datensatz der Person gespeichert.',
  'personnelLink.send.tcMissing':
    'Im Datensatz dieser Person ist keine T.C.-Kimlik-Nummer hinterlegt. Sie muss zuerst eingetragen werden, bevor ein Aktivierungslink gesendet werden kann.',
  'personnelLink.send.contactHint':
    'Geben Sie mindestens eine E-Mail-Adresse oder eine Telefonnummer ein; Sie können auch beides angeben.',
  'personnelLink.send.submit': 'Senden',
  'personnelLink.resend.title': 'Link erneut senden',
  'personnelLink.resend.description':
    'Für {{name}} wird ein neuer Aktivierungslink erstellt und gesendet. Der bisherige Link wird ungültig.',
  'personnelLink.resend.channelHint':
    'Der neue Link wird über den gewählten Kanal gesendet und bleibt hier zum Kopieren.',
  'personnelLink.resend.via.email': 'Der neue Link wird per E-Mail gesendet.',
  'personnelLink.resend.via.sms': 'Der neue Link wird per SMS gesendet.',
  'personnelLink.resend.submit': 'Erneut senden',
  'personnelLink.resend.noContact':
    'Für diesen Link sind weder E-Mail noch Telefon hinterlegt; er kann nicht erneut gesendet werden.',
  'personnelLink.success.title': 'Aktivierungslink bereit',
  'personnelLink.success.body':
    'Der Versandstatus steht unten. Sie können den Link auch kopieren und selbst an die Person weitergeben.',
  ACTIVATION_LINK_DAILY_LIMIT:
    'Das Tageslimit für den Versand von Links ist erreicht. Bitte versuchen Sie es später erneut.',
  PERSONNEL_INACTIVE:
    'Ein Aktivierungslink kann nicht gesendet werden, da diese Person inaktiv ist. Setzen Sie die Person zuerst auf Aktiv.',
  PERSONNEL_TC_REQUIRED:
    'Im Datensatz der Person ist keine T.C.-Kimlik-Nummer hinterlegt. Solange sie dort nicht eingetragen ist, kann weder ein Aktivierungslink gesendet noch die Aktivierung abgeschlossen werden.',
  GUEST_INVITE_CONTACT_ALREADY_EXISTS:
    'Diese E-Mail-Adresse oder Telefonnummer ist bereits einem anderen Konto zugeordnet; die Einladung kann mit diesen Kontaktdaten nicht abgeschlossen werden.',
  PERSONNEL_ALREADY_HAS_LOGIN:
    'Diese Person hat bereits ein Konto; es kann keine neue Einladung gesendet werden.',

  // Personal ohne Einladung anlegen (§13.6 POST /supplier/contractor/personnel, S25 C9) —
  // GETRENNT vom alten Einladungsablauf: keine Einladung, der Datensatz existiert sofort
  // (`status: NoLogin`).
  'personnel.create.title': 'Neues Personal anlegen',
  'personnel.create.description':
    'Die Person wird sofort zu Ihrem Personal hinzugefügt und kann bei der Dokumentgenehmigung ausgewählt werden. Damit sie ihr Konto aktivieren kann, können Sie ihr später über Mein Personal einen Aktivierungslink senden; dafür muss in ihrem Datensatz eine T.C.-Kimlik-Nummer hinterlegt sein.',
  'personnel.create.submit': 'Anlegen',
  'personnel.create.field.firstName': 'Vorname',
  'personnel.create.field.lastName': 'Nachname',
  'personnel.create.field.tcKimlikNo': 'T.C.-Kimlik-Nummer',
  'personnel.create.field.tcKimlikNoHint': 'Muss 11 Ziffern mit gültiger Prüfsumme haben.',
  'personnel.create.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'personnel.create.validation.lastNameRequired': 'Nachname ist erforderlich.',
  'personnel.create.validation.tcInvalid':
    'Die eingegebene T.C.-Kimlik-Nummer ist ungültig. Bitte überprüfen Sie sie und versuchen Sie es erneut.',
  'personnel.create.tcExistsFallback':
    'Es existiert bereits ein Mitarbeiterdatensatz mit dieser T.C.-Kimlik-Nummer.',

  // Personaldokumente (§15.2 Pfad B + §8; Datenschutz)
  'personnelDrawer.analysis.hint':
    'Sobald das Ergebnis vorliegt, erhalten Sie hier einen Hinweis zur Bestätigung.',
  'personnelDocs.title': 'Dokumente',
  'personnelDocs.kvkk':
    'Diese Dokumente enthalten personenbezogene Daten. Laden Sie nur die erforderlichen Unterlagen hoch; der Zugriff ist auf geschäftliche Zwecke beschränkt.',
  'personnelDocs.add': 'Dokument hochladen',
  'personnelDocs.empty': 'Für diese Person wurden noch keine Dokumente hochgeladen.',
  'personnelDocs.col.document': 'Dokument',
  'personnelDocs.col.approval': 'Genehmigungsstatus',
  'personnelDocs.rejectionReason': 'Ablehnungsgrund: {{reason}}',
  'personnelDocs.add.title': 'Personaldokument hochladen',
  'personnelDocs.add.description':
    'Wählen Sie die Datei, ihren Typ und die Gültigkeitsdaten. Die Datei wird direkt in den sicheren Speicher hochgeladen.',
  'personnelDocs.add.submit': 'Hochladen und hinzufügen',
  'personnelDocs.add.uploading': 'Wird hochgeladen…',
  'personnelDocs.add.progress': 'Wird hochgeladen: {{percent}} %',
  'personnelDocs.field.file': 'Dokumentdatei',
  'personnelDocs.field.filePlaceholder': 'Datei auswählen (PDF, Bild oder Office-Dokument)',
  'personnelDocs.field.fileHint': 'Bis zu 20 MB. PDF, Bild (PNG/JPG) oder Office-Dokument.',
  'personnelDocs.field.type': 'Dokumenttyp',
  'personnelDocs.field.validFrom': 'Gültig ab',
  'personnelDocs.field.validUntil': 'Gültig bis',
  'personnelDocs.field.note': 'Notiz (optional)',
  'personnelDocs.delete.title': 'Dokument entfernen',
  'personnelDocs.delete.body': 'Möchten Sie das {{type}}-Dokument wirklich entfernen?',
  'personnelDocs.delete.confirm': 'Dokument entfernen',

  // supplier-contractor Zugriffsschranke (zweistufige Authz — Mitarbeiter sieht sie nicht)
  'access.loading': 'Zugriff wird geprüft…',
  'access.forbidden.title': 'Sie haben keinen Zugriff auf diesen Bereich',
  'access.forbidden.body':
    'Die Personalverwaltung steht nur Nachunternehmer-Verantwortlichen offen. Bitte wenden Sie sich für den Zugriff an Ihren Unternehmensadministrator.',
  'access.forbidden.back': 'Zurück zum Dashboard',
  'access.unavailable.title': 'Dieser Bereich ist derzeit nicht verfügbar',
  'access.unavailable.body':
    'Die Zugriffsinformationen konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.',
  'access.unavailable.retry': 'Erneut versuchen',

  // Statusanzeigen (keine Zuordnung / kein Zugriff / allgemeiner Fehler)
  'state.noContractor.title': 'Keine Firmenzuordnung gefunden',
  'state.noContractor.body':
    'Im aktiven Unternehmen ist Ihrem Konto keine Nachunternehmerfirma zugeordnet. Wenn Sie zu mehreren Unternehmen gehören, wählen Sie oben im Umschalter das richtige aus; andernfalls wenden Sie sich an Ihren Unternehmensadministrator.',
  'state.noAccess.title': 'Sie haben keinen Zugriff auf dieses Unternehmen',
  'state.noAccess.body':
    'Sie haben keine Zugriffszuordnung zum ausgewählten Unternehmen. Wählen Sie oben im Umschalter ein Unternehmen aus, auf das Sie zugreifen können, oder wenden Sie sich an Ihren Unternehmensadministrator.',
  'state.error.title': 'Informationen konnten nicht geladen werden',
  'state.error.body': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'state.error.retry': 'Erneut versuchen',

  'validation.identifierRequired': 'E-Mail oder Telefon ist erforderlich.',
  'validation.passwordRequired': 'Passwort ist erforderlich.',
  'validation.codeRequired': 'Bestätigungscode ist erforderlich.',
  'validation.passwordPolicy':
    'Das Passwort muss mindestens 8 Zeichen, einen Buchstaben und eine Ziffer enthalten.',

  'error.generic': 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  NETWORK_ERROR: 'Server nicht erreichbar. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  INVALID_CREDENTIALS: 'E-Mail/Telefon oder Passwort ist falsch.',
  VALIDATION_FAILED: 'Bitte überprüfen Sie die Felder.',
  UNAUTHORIZED: 'Ihre Sitzung konnte nicht bestätigt werden. Bitte melden Sie sich erneut an.',
  PASSWORD_POLICY_ERROR:
    'Das Passwort muss mindestens 8 Zeichen, einen Buchstaben und eine Ziffer enthalten.',
  CODE_INVALID: 'Der Bestätigungscode ist falsch oder verbraucht. Fordern Sie einen neuen Code an.',
  CODE_EXPIRED: 'Der Bestätigungscode ist abgelaufen. Fordern Sie einen neuen Code an.',
  CODE_TOO_FREQUENT:
    'Sie haben zu oft einen Code angefordert. Bitte warten Sie und versuchen Sie es erneut.',
  SUPPLIER_NO_COMPANY:
    'Ihr Konto ist noch mit keinem Unternehmen verknüpft. Bitte wenden Sie sich an Ihren Unternehmensadministrator.',
  SUPPLIER_INACTIVE:
    'Ihr Konto ist inaktiv. Bitte wenden Sie sich an Ihren Unternehmensadministrator.',
  COMPANY_NOT_ACCESSIBLE:
    'Sie haben keinen Zugriff auf dieses Unternehmen. Bitte wenden Sie sich an Ihren Unternehmensadministrator.',
  GUEST_INVITE_INVALID:
    'Dieser Aktivierungslink ist ungültig oder wurde bereits verwendet. Wenn Sie Ihr Konto damit bereits aktiviert haben, melden Sie sich an; andernfalls fordern Sie bei dem Unternehmen, das Sie hinzugefügt hat, einen neuen Link an.',
  GUEST_INVITE_EXPIRED:
    'Dieser Aktivierungslink ist abgelaufen. Bitte fordern Sie bei dem Unternehmen, das Sie hinzugefügt hat, einen neuen Link an.',

  // Dokument-Upload / Nachunternehmer (§8 + §13.6) Fehlercodes — lokaler Fallback (Backend-Paket überschreibt).
  DOCUMENT_TOO_LARGE: 'Die Datei überschreitet die zulässige Größe (bis zu 20 MB).',
  DOCUMENT_TYPE_UNSUPPORTED:
    'Dieser Dateityp wird nicht unterstützt. Laden Sie ein PDF, Bild oder Office-Dokument hoch.',
  DOCUMENT_UPLOAD_FAILED:
    'Die Datei konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
  DOCUMENT_UPLOAD_ABORTED: 'Der Datei-Upload wurde abgebrochen.',
  DOCUMENT_NOT_UPLOADED:
    'Der Upload wurde nicht abgeschlossen. Bitte laden Sie die Datei erneut hoch.',
  DOCUMENT_NOT_FOUND: 'Das gesuchte Dokument wurde nicht gefunden.',
  CONTRACTOR_NOT_FOUND: 'Ihr Konto ist in diesem Unternehmen keinem Auftragnehmer zugeordnet.',
  CONTRACTOR_DOCUMENT_NOT_FOUND: 'Das Dokument wurde nicht gefunden oder wurde entfernt.',
  // Dokumentenanalyse (§20 — S17) Fehlercodes — lokaler Fallback (Backend-Paket überschreibt).
  DOCUMENT_ANALYSIS_NOT_FOUND: 'Die gesuchte Dokumentenanalyse wurde nicht gefunden.',
  DOCUMENT_ANALYSIS_IN_PROGRESS:
    'Derzeit läuft bereits eine Dokumentenanalyse. Warten Sie, bis die aktuelle Analyse abgeschlossen ist, bevor Sie eine neue starten.',
  DOCUMENT_ANALYSIS_QUOTA_EXCEEDED:
    'Das heutige Kontingent für Dokumentenanalysen ist aufgebraucht. Es wird morgen zurückgesetzt.',
  DOCUMENT_ANALYSIS_NOT_ENABLED:
    'Die Dokumentenanalyse ist für dieses Unternehmen nicht aktiviert.',
  DOCUMENT_ANALYSIS_UNAVAILABLE:
    'Die Dokumentenanalyse ist in dieser Umgebung derzeit nicht verfügbar.',
  // Annahme der Dokumentenanalyse (§20.2 — S19) Fehlercodes — lokaler Fallback.
  DOCUMENT_ANALYSIS_NOT_COMPLETE:
    'Diese Analyse ist noch nicht abgeschlossen; sie kann jetzt nicht bestätigt werden.',
  DOCUMENT_ANALYSIS_ITEM_NOT_FOUND:
    'In dieser Analyse wurde kein solches Dokumentelement gefunden. Aktualisieren Sie die Seite und versuchen Sie es erneut.',
  // Element ablehnen + Analyse verwerfen (§20.4, S24) Fehlercodes — lokaler Fallback.
  DOCUMENT_ANALYSIS_ITEM_ALREADY_ACCEPTED:
    'Dieses Element wurde bereits genehmigt und abgelegt; es kann nicht mehr abgelehnt werden. Aktualisieren Sie die Seite.',
  DOCUMENT_ANALYSIS_NOT_TERMINAL:
    'Diese Analyse ist noch nicht abgeschlossen; diese Aktion kann jetzt nicht ausgeführt werden.',
  DOCUMENT_ANALYSIS_ARTIFACT_MISSING:
    'Die im System gespeicherte Kopie dieses Dokuments wurde nicht gefunden; es konnte daher nicht abgelegt werden. Bitte laden Sie das Dokument erneut hoch.',
  DOCUMENT_ANALYSIS_ARTIFACT_COPY_FAILED:
    'Das Dokument konnte nicht kopiert werden. Bitte versuchen Sie es erneut.',
  // Personaldokument (§15) Fehlercodes — lokaler Fallback (Backend-Paket überschreibt).
  PERSONNEL_NOT_FOUND: 'Personal nicht gefunden oder nicht mit Ihrer Firma verknüpft.',
  PERSONNEL_DOCUMENT_NOT_FOUND: 'Das Dokument wurde nicht gefunden oder wurde entfernt.',
  PERSONNEL_DOCUMENT_NOT_PENDING:
    'Dieses Dokument wurde bereits geprüft und kann nicht mehr gelöscht werden. Laden Sie ein Ersatzdokument hoch oder wenden Sie sich zum Entfernen an die Kundenfirma oder den Arbeitsschutzexperten.',

  // Arbeitserlaubnisse (Supplier — §21). Schreibgeschützte Erlaubnis + eigenes Personal zuweisen + Readiness.
  'layout.permits': 'Arbeitserlaubnisse',
  'permits.title': 'Arbeitserlaubnisse',
  'permits.list.subtitle':
    'Sehen Sie die für Ihre Firma erstellten Arbeitserlaubnisse ein, weisen Sie eigenes Personal zu und verfolgen Sie deren Schulungsstatus.',
  'permits.list.search': 'Erlaubnisse suchen',
  'permits.list.searchPlaceholder': 'Nach Titel suchen',
  'permits.list.filter.status': 'Status',
  'permits.list.filter.allStatuses': 'Alle Status',
  'permits.list.col.permitType': 'Genehmigungsart',
  'permits.list.col.title': 'Titel',
  'permits.list.col.sites': 'Standorte',
  'permits.list.sitesMore': '+{{count}}',
  'permits.list.col.validity': 'Gültigkeit',
  'permits.list.col.status': 'Status',
  'permits.list.col.readiness': 'Bereites Personal',
  'permits.list.count': '{{count}} Erlaubnisse werden angezeigt',
  'permits.list.empty': 'Keine Arbeitserlaubnisse zum Anzeigen.',
  'permits.pagination.nav': 'Seitennummerierung',
  'permits.pagination.previous': 'Zurück',
  'permits.pagination.next': 'Weiter',
  'permits.readiness.summary': '{{ready}} / {{total}} bereit',
  'permits.readiness.personnelOnly': '{{total}} Personal',
  'permits.readiness.noPersonnel': 'Kein Personal',
  'permits.status.Draft': 'Entwurf',
  'permits.status.Submitted': 'Warten auf Genehmigung',
  'permits.status.Approved': 'Genehmigt',
  'permits.status.Active': 'Aktiv',
  'permits.status.Rejected': 'Abgelehnt',
  'permits.status.Expired': 'Abgelaufen',
  'permits.status.Closed': 'Geschlossen',
  'permits.status.AwaitingSupplierInfo': 'Ihre Angaben fehlen',
  'permits.status.AwaitingAiReview': 'Automatische Prüfung',
  'permits.status.Revision': 'Überarbeitung nötig',
  'permits.status.DepartmentReview': 'In Fachprüfung',
  'permits.status.AwaitingEntryPermit': 'Warten auf Zutritt',
  'permits.list.noResults': 'Keine Arbeitserlaubnisse entsprechen Ihren Filtern.',
  'personnel.list.count': '{{count}} Personen aufgelistet',
  'documents.list.count': '{{count}} Dokumente aufgelistet',
  'common.clearFilters': 'Filter zurücksetzen',
  'common.noResults.body': 'Ändern oder löschen Sie Suche und Filter.',
  'permits.detail.back': 'Zurück zu den Arbeitserlaubnissen',
  'permits.detail.loading': 'Erlaubnis wird geladen…',
  'permits.detail.readOnlyNote':
    'Die Erlaubnisdaten werden vom Arbeitsschutzexperten verwaltet. Sie können nur eigenes Personal zuweisen oder entfernen.',
  'permits.detail.field.sites': 'Standorte',
  'permits.detail.field.validityStart': 'Gültigkeitsbeginn',
  'permits.detail.field.validityEnd': 'Gültigkeitsende',
  'permits.detail.field.createdAt': 'Erstellt',
  'permits.detail.section.details': 'Details',
  'permits.detail.section.requirements': 'Anforderungen',
  'permits.detail.section.personnel': 'Zugeordnetes Personal',
  'permits.detail.section.trainings': 'Erforderliche Schulungen',
  'permits.detail.requiredDocuments': 'Erforderliche Dokumente',
  'permits.detail.requiredDocumentsEmpty':
    'Für diese Genehmigungsart sind keine Dokumente erforderlich.',
  'permits.trainings.empty': 'Für diese Erlaubnis sind keine erforderlichen Schulungen definiert.',
  'permits.detail.protectiveEquipment': 'Erforderliche PSA',
  'permits.detail.protectiveEquipmentHint':
    'Von der Genehmigungsart geforderte persönliche Schutzausrüstung; diese Ausrüstung stellen Sie vor Ort bereit.',
  'permits.detail.protectiveEquipmentEmpty':
    'Für diese Genehmigungsart ist keine PSA erforderlich.',
  'permits.detail.protectiveEquipmentMinimumNotice':
    'Die oben aufgeführte persönliche Schutzausrüstung ist die Mindestanforderung. Bitte halten Sie auch jede weitere Schutzausrüstung bereit, die Ihre Arbeit und Ihre Sicherheit erfordern.',
  'permits.personnel.add': 'Personal zuweisen',
  'permits.personnel.col.name': 'Name',
  'permits.personnel.col.training': 'Schulung',
  'permits.personnel.col.documents': 'Dokumente',
  'permits.personnel.col.readiness': 'Bereitschaft',
  'permits.personnel.requiredDocuments': 'Erforderliche Personaldokumente',
  'permits.personnel.requiredDocumentsEmpty':
    'Für diese Genehmigungsart sind keine Personaldokumente erforderlich.',
  'permits.personnel.ready': 'Bereit',
  'permits.personnel.notReady': 'Unvollständig',
  'permits.personnel.missingDocuments': 'Fehlende Dokumente',
  'permits.personnel.empty': 'Diesem Erlaubnis ist noch kein Personal zugewiesen.',
  'permits.personnel.action.remove': 'Personal entfernen',
  'permits.personnel.action.openMenu': 'Aktionen für {{name}}',
  'permits.personnel.remove.title': 'Personal entfernen',
  'permits.personnel.remove.body': 'Möchten Sie {{name}} wirklich aus dieser Erlaubnis entfernen?',
  'permits.personnel.remove.confirm': 'Personal entfernen',
  'permits.personnel.add.title': 'Personal der Erlaubnis zuweisen',
  'permits.personnel.add.description':
    'Wählen Sie eine oder mehrere Personen aus Ihrem eigenen Personal aus, um sie dieser Erlaubnis zuzuweisen. Auch Personen, die ihr Konto noch nicht aktiviert haben, können zugewiesen werden.',
  'permits.personnel.add.submit': 'Zuweisen',
  'permits.personnel.add.empty':
    'Es gibt kein geeignetes Personal zum Zuweisen. Sie können unten neues Personal anlegen.',
  'permits.personnel.add.createNew': 'Neues Personal anlegen',
  'permits.personnel.notActivated': 'Nicht aktiviert',
  'permits.personnel.notActivated.hint':
    'Die Person kann die erforderlichen Schulungen dieser Erlaubnis erst abschließen, wenn sie ihr Konto aktiviert hat. Aktivierungslinks werden über Mein Personal gesendet.',
  // Arbeitserlaubnis — Fahrzeuge (§23.2; der befugte Subunternehmer-Nutzer fügt Fahrzeuge hinzu und lädt Fahrzeugdokumente hoch/löscht sie, die Arbeitsschutzfachkraft genehmigt)
  'permits.vehicles.section': 'Fahrzeuge',
  'permits.detail.tab.personnel': 'Personal',
  'permits.detail.tabs.label': 'Genehmigungsbereiche',
  'permits.detail.tab.personnelIncomplete_one': '{{count}} Person unvollständig',
  'permits.detail.tab.personnelIncomplete_other': '{{count}} Personen unvollständig',
  'permits.detail.tab.vehiclesIncomplete_one': '{{count}} Fahrzeug unvollständig',
  'permits.detail.tab.vehiclesIncomplete_other': '{{count}} Fahrzeuge unvollständig',
  'permits.vehicles.add': 'Fahrzeug hinzufügen',
  'permits.vehicles.requiredDocuments': 'Erforderliche Fahrzeugdokumente',
  'permits.vehicles.requiredDocumentsEmpty':
    'Für diese Genehmigungsart sind keine Fahrzeugdokumente erforderlich.',
  'permits.vehicles.empty': 'Dieser Arbeitserlaubnis wurde noch kein Fahrzeug hinzugefügt.',
  'permits.vehicles.ready': 'Bereit',
  'permits.vehicles.notReady': 'Unvollständig',
  'permits.vehicles.missingDocuments': 'Fehlende Fahrzeugdokumente',
  'permits.vehicles.upload.title': 'Fahrzeugdokument hochladen',
  'permits.vehicles.upload.description':
    'Laden Sie ein Dokument für das Fahrzeug mit dem Kennzeichen {{plate}} hoch. Es wird zur Genehmigung an die Arbeitsschutzfachkraft gesendet.',
  'permits.vehicles.upload.chooseFile': 'Datei auswählen',
  'permits.vehicles.upload.submit': 'Hochladen',
  'permits.vehicles.docs.col.type': 'Dokumenttyp',
  'permits.vehicles.docs.col.approval': 'Genehmigungsstatus',
  'permits.vehicles.docs.rejectionReason': 'Ablehnungsgrund: {{reason}}',
  'permits.vehicles.docs.action.download': 'Dokument herunterladen',
  'permits.vehicles.docs.action.delete': 'Dokument löschen',
  'permits.vehicles.docs.delete.title': 'Dokument löschen',
  'permits.vehicles.docs.delete.body':
    'Dokument "{{type}}" löschen? Es verschwindet auch aus allen Arbeitserlaubnissen des Fahrzeugs.',
  'permits.vehicles.docs.delete.confirm': 'Löschen',
  'permits.docApproval.pending': 'Genehmigung ausstehend',
  'permits.docApproval.approved': 'Genehmigt',
  'permits.docApproval.rejected': 'Abgelehnt',
  'vehicles.docStatus.allApproved': 'Alle genehmigt',
  'vehicles.docStatus.none': 'Keine Dokumente',
  'vehicles.docStatus.missingEnd': 'Kein Enddatum',
  'vehicles.openPermits.yes': 'In offener Erlaubnis',
  'vehicles.sheet.docs.title': 'Fahrzeugdokumente',
  'vehicles.sheet.docs.upload': 'Dokument hochladen',
  'vehicles.sheet.docs.empty': 'Diesem Fahrzeug wurden noch keine Dokumente hinzugefügt.',
  'vehicles.sheet.docs.note':
    'Dokumente werden beim Fahrzeug geführt; eine Genehmigung gilt für alle Arbeitserlaubnisse, denen das Fahrzeug hinzugefügt wird.',
  'vehicles.sheet.plateLocked': 'Kennzeichen gesperrt',
  'vehicles.upload.noteTooLong': 'Die Notiz darf höchstens {{max}} Zeichen lang sein.',
  'vehicles.validation.plateInvalid':
    'Das Kennzeichen ist ungültig: höchstens {{max}} Zeichen und höchstens {{keyMax}} Buchstaben und Ziffern, keine unsichtbaren Zeichen. Geben Sie das Kennzeichen erneut von Hand ein.',
  'vehicles.title': 'Fahrzeuge',
  'vehicles.subtitle':
    'Die Fahrzeuge Ihrer Firma. Ein Dokument wird einmal genehmigt und gilt für jede Arbeitserlaubnis, der das Fahrzeug hinzugefügt wird.',
  'vehicles.add': 'Fahrzeug hinzufügen',
  'vehicles.list.count_one': '{{count}} Fahrzeug aufgelistet',
  'vehicles.list.count_other': '{{count}} Fahrzeuge aufgelistet',
  'vehicles.empty': 'Es wurden noch keine Fahrzeuge hinzugefügt.',
  'vehicles.col.plate': 'Kennzeichen',
  'vehicles.col.description': 'Beschreibung',
  'vehicles.col.documents': 'Dokumente',
  'vehicles.col.docStatus': 'Dokumentstatus',
  'vehicles.col.openPermits': 'Offene Erlaubnis',
  'vehicles.action.openMenu': 'Aktionen für Fahrzeug {{plate}}',
  'vehicles.action.upload': 'Dokument hochladen',
  'vehicles.action.edit': 'Bearbeiten',
  'vehicles.action.delete': 'Löschen',
  'vehicles.action.deleteBlocked': 'Löschen (zuerst aus offenen Arbeitserlaubnissen entfernen)',
  'vehicles.action.deleteBlockedApproved': 'Löschen (genehmigtes Dokument vorhanden)',
  'vehicles.delete.title': 'Fahrzeug löschen',
  'vehicles.delete.body':
    'Fahrzeug {{plate}} und seine Dokumente löschen? In früheren Arbeitserlaubnissen bleibt das Kennzeichen sichtbar.',
  'vehicles.delete.confirm': 'Löschen',
  'vehicles.form.edit.title': 'Fahrzeug bearbeiten',
  'vehicles.form.edit.description': 'Änderungen gelten für alle Arbeitserlaubnisse des Fahrzeugs.',
  'vehicles.form.create.description':
    'Ein neues Fahrzeug zur Fahrzeugliste Ihrer Firma hinzufügen.',
  'vehicles.form.submit.edit': 'Speichern',
  'vehicles.form.submit.create': 'Hinzufügen',
  'vehicles.form.field.plate': 'Kennzeichen',
  'vehicles.form.field.description': 'Beschreibung',
  'vehicles.form.platePlaceholder': 'z. B. 34 ABC 123',
  'vehicles.form.plateLocked':
    'Das Kennzeichen kann nicht mehr geändert werden: Das Fahrzeug wurde bereits einer Arbeitserlaubnis hinzugefügt oder eines seiner Dokumente wurde genehmigt. Legen Sie für ein anderes Kennzeichen ein neues Fahrzeug an.',
  'vehicles.permitAdd.title': 'Fahrzeug hinzufügen',
  'vehicles.permitAdd.description':
    'Wählen Sie aus den Fahrzeugen Ihrer Firma oder geben Sie ein neues Kennzeichen ein. Ein neues Kennzeichen wird auch in Ihre Fahrzeugliste aufgenommen.',
  'vehicles.permitAdd.submit': 'Hinzufügen',
  'vehicles.permitAdd.registered': 'Registrierte Fahrzeuge',
  'vehicles.permitAdd.registeredEmpty': 'Keine registrierten Fahrzeuge zum Hinzufügen vorhanden.',
  'vehicles.permitAdd.newVehicle': 'Neues Fahrzeug',
  'vehicles.permitAdd.plateOnPermit': 'Dieses Fahrzeug ist bereits in der Arbeitserlaubnis.',
  'vehicles.permitAdd.plateExisting':
    'Dieses Kennzeichen ist bereits in der Liste; das vorhandene Fahrzeug wird der Arbeitserlaubnis hinzugefügt.',
  'vehicles.permitAdd.plateNew': 'Neues Fahrzeug; es wird auch in die Fahrzeugliste aufgenommen.',
  'vehicles.permitAdd.partialFailure': 'Fahrzeug {{plate}} konnte nicht hinzugefügt werden.',
  'vehicles.unlink.action': 'Aus Arbeitserlaubnis entfernen',
  'vehicles.unlink.title': 'Fahrzeug aus der Arbeitserlaubnis entfernen',
  'vehicles.unlink.body':
    'Fahrzeug {{plate}} aus dieser Arbeitserlaubnis entfernen? Fahrzeug und Dokumente bleiben in der Fahrzeugliste erhalten.',
  'vehicles.unlink.confirm': 'Entfernen',
  'permits.vehicles.col.readiness': 'Bereitschaft',
  'vehicles.validation.plateRequired': 'Das Kennzeichen ist erforderlich.',
  'vehicles.validation.plateTooLong': 'Das Kennzeichen darf höchstens {{max}} Zeichen lang sein.',
  'vehicles.validation.plateKeyTooLong':
    'Das Kennzeichen darf höchstens {{max}} Buchstaben und Ziffern enthalten.',
  'vehicles.validation.descriptionTooLong':
    'Die Beschreibung darf höchstens {{max}} Zeichen lang sein.',
  VEHICLE_NOT_FOUND:
    'Fahrzeug nicht gefunden; es wurde möglicherweise gelöscht oder aus der Arbeitserlaubnis entfernt.',
  VEHICLE_DOCUMENT_NOT_FOUND:
    'Dieses Fahrzeugdokument wurde nicht gefunden oder existiert nicht mehr.',
  VEHICLE_PLATE_ALREADY_EXISTS:
    'Ein Fahrzeug mit diesem Kennzeichen ist bereits erfasst (Leerzeichen und Satzzeichen werden ignoriert). Verwenden Sie das vorhandene Fahrzeug aus der Liste.',
  VEHICLE_PLATE_LOCKED:
    'Das Kennzeichen dieses Fahrzeugs kann nicht mehr geändert werden: Das Fahrzeug wurde bereits einer Arbeitserlaubnis hinzugefügt oder eines seiner Dokumente wurde genehmigt. Legen Sie für ein anderes Kennzeichen ein neues Fahrzeug an.',
  VEHICLE_HAS_OPEN_PERMITS:
    'Dieses Fahrzeug ist einer offenen Arbeitserlaubnis zugeordnet und kann nicht gelöscht werden. Entfernen Sie es zuerst aus den offenen Arbeitserlaubnissen.',
  VEHICLE_HAS_LOCKED_DOCUMENTS:
    'Dieses Fahrzeug kann nicht gelöscht werden: Es hat ein genehmigtes Dokument, oder eines seiner Dokumente wird verwendet (der Zutritt wurde gewährt, während es vorlag, oder das Fahrzeug ist einer aktiven Arbeitserlaubnis zugeordnet). Das Fahrzeug bleibt in der Liste; legen Sie für ein anderes Fahrzeug ein neues an.',
  VEHICLE_DOCUMENT_NOT_PENDING:
    'Dieses Dokument wurde bereits geprüft und kann nicht mehr gelöscht werden. Laden Sie stattdessen ein Ersatzdokument hoch.',
  VEHICLE_DOCUMENT_IN_USE:
    'Dieses Dokument wird verwendet und kann nicht gelöscht werden: Dem Fahrzeug wurde der Zutritt gewährt, während das Dokument vorlag, oder das Fahrzeug ist einer aktiven Arbeitserlaubnis zugeordnet. Lehnen Sie ein fehlerhaftes Dokument ab oder laden Sie ein neues hoch.',
  PERMIT_NOT_FOUND: 'Arbeitserlaubnis nicht gefunden oder gehört nicht zu Ihrer Firma.',
};

export const appResources: AppResources = {
  'tr-TR': tr,
  'en-US': en,
  'de-DE': de,
};
